// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%239933FF%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Base & Typography --- */
:root {
  --primary-bg: #000000;
  --accent-purple: #C700FF;
  --accent-gradient: linear-gradient(90deg, #C700FF, #006EFF);
  --text-white: #FFFFFF;
  --text-white: #FFFFFF;
  --font-logo: '10Pixel', sans-serif;
  --font-heading: '10Pixel', sans-serif;
  --font-body: '10Pixel', sans-serif;
  --font-serif: '10Pixel', sans-serif;
  --card-bg: #1a1a1a;
  --placeholder-bg: #333333;
  --heading-underline-gap: 0.25em;
  --heading-underline-width: min(20ch, 80%);
  --heading-underline-thickness: 6px;
}

.load{

  display: flex; 
  justify-content: center;   /* horizontal */
  align-items: center;       /* vertical */
  height: 100vh; 
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}

@supports (-webkit-touch-callout: none) {
  body,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .hero h1,
  .hero-heading,
  .hero p {
    -webkit-font-smoothing: subpixel-antialiased;
    -webkit-text-stroke: 0.01em transparent;
    color: #FFFFFF !important;
  }
}

/* Android Chrome specific fixes */
@media screen and (-webkit-min-device-pixel-ratio: 1) {
  body,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .hero h1,
  .hero-heading,
  .hero p {
    -webkit-font-smoothing: subpixel-antialiased;
    text-rendering: optimizeLegibility;
    color: #FFFFFF !important;
  }
}




body {
  margin: 0;
  font-family: var(--font-body);
  font-weight: 400;
  /* Regular weight for body text */
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  -webkit-text-size-adjust: 100%;
  background-color: var(--primary-bg);
  background: radial-gradient(circle at center, #C700FF15 0%, var(--primary-bg) 70%);
  /* box-shadow: inset 0 0 50px rgba(199, 0, 255, 0.2); */
  color: #FFFFFF;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
  -webkit-text-stroke: 0.01em transparent;
}

/* Ensure layout scales nicely on small mobile / iOS viewports */
html,
body {
  width: 100%;
  max-width: 100%;
}

img,
video,
canvas {
  max-width: 100%;
  height: auto;
}

body.no-scroll {
  overflow-y: hidden;
  /* Prevent vertical scrolling during fixed section */
}

:where(h1, h2, h3) {
  font-family: var(--font-heading);
  font-weight: 400;
  /* Bolder headings */
  font-style: italic;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  position: relative;
  display: inline-block;
  padding-bottom: var(--heading-underline-gap);
  text-decoration: none !important;
  overflow: visible;
}

/* Advanced Underline for Page Titles (h1) */
h1::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: var(--heading-underline-width);
  height: 2px;
  /* Sleek and thin */
  /* Sleek and thin */
  background: linear-gradient(90deg,
      transparent 0%,
      rgba(199, 0, 255, 0) 10%,
      #C700FF 40%,
      #006EFF 60%,
      rgba(0, 110, 255, 0) 90%,
      transparent 100%);
  /* Gradient from Purple (#C700FF) to Blue (#006EFF) */
  transform: translateX(-50%) scaleX(0.5);
  transform-origin: center;
  opacity: 0;
  will-change: transform, opacity;
  animation: heading-underline-reveal 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

/* Distinct Underline for Subheadings (h2-h6) */
:where(h2, h3, h4, h5, h6)::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 60px;
  /* Fixed elegant width */
  height: 2px;
  /* Slightly visible but refined */
  /* Slightly visible but refined */
  background: var(--accent-gradient);
  /* Solid accent color with slight transparency */
  transform: translateX(-50%);
  border-radius: 1px;
}

p {
  font-weight: 400;
  color: #FFFFFF;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}

a {
  text-decoration: none;
  color: inherit;
}

.App {
  text-align: center;
  padding-top: 0;
}

/* Adjust padding for mobile */
@media (max-width: 768px) {
  .App {
    padding-top: 0;
  }
}

/* --- Logo Images --- */
.navbar-logo-img {
  height: 40px;
  width: auto;
  object-fit: contain;
  animation: fadeInDown 1s ease-out 0.1s both;
}

/* Default State (Web & Mobile Other = Original Logo) */
.logo-original {
  display: block;
}

/* Hidden by default (Favicon) */
.logo-favicon {
  display: none;
}

.navbar-title {
  display: none !important;
}

/* Mobile Adjustments */
@media (max-width: 768px) {

  /* Mobile Home: Show Favicon, Hide Original, Hide Toggle */
  .navbar.page-home .logo-favicon {
    display: block !important;
  }

  .navbar.page-home .logo-original {
    display: none !important;
  }

  .mobile-home-hidden {
    display: none !important;
  }
}

.hero-logo-img {
  height: 100px;
  margin-bottom: 20px;
  filter: drop-shadow(0 0 15px rgba(199, 0, 255, 0.8));
  animation: glow 2s infinite ease-in-out, fadeInDown 1s ease-out;
}

@keyframes glow {
  0% {
    filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.7));
  }

  50% {
    filter: drop-shadow(0 0 25px rgba(199, 0, 255, 1));
  }

  100% {
    filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.7));
  }
}

/* --- Animation Keyframes --- */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes labelGlow {
  0% {
    text-shadow: 0 0 5px rgba(200, 0, 255, 0.5);
  }

  50% {
    text-shadow: 0 0 15px rgba(200, 0, 255, 0.8);
  }

  100% {
    text-shadow: 0 0 5px rgba(200, 0, 255, 0.5);
  }
}

@keyframes heading-underline-reveal {
  0% {
    transform: translateX(-50%) scaleX(0.2);
    opacity: 0;
  }

  45% {
    opacity: 0.85;
  }

  100% {
    transform: translateX(-50%) scaleX(1);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  :where(h1, h2, h3, h4, h5, h6)::after {
    animation: none !important;
    opacity: 1;
    transform: translateX(-50%) scaleX(1);
  }
}

.footer-logo-img {
  height: 40px;
  animation: fadeInUp 1s ease-out 0.1s both;
}

/* --- Container --- */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  margin-top: 70px;
}

/* Adjust container padding for mobile */
@media (max-width: 768px) {
  .container {
    padding: 70px 0;
  }
}

/* --- Navigation Bar --- */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 5%;
  background-color: var(--primary-bg);
  position: relative;
  width: 100%;
  border-bottom: none;
  margin-bottom: 0;
  z-index: 10;
}

.navbar-logo {
  display: flex;
  align-items: center;
}

/* New container for navbar links */
.navbar-links-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.navbar-links {
  display: flex;
  list-style: none;
  gap: 5px;
  /* Reduced gap since we have padding in container */
  background-color: rgba(255, 255, 255, 0.1);
  /* Light grey/transparent background */
  padding: 8px 15px;
  border-radius: 50px;
  /* Oval shape */
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
}

.navbar-links a {
  font-weight: 400;
  /* Regular weight for nav links */
  font-family: var(--font-body);
  /* Geometric sans-serif */
  padding: 8px 15px;
  border-radius: 20px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.navbar-links a.active,
.navbar-links a:hover {
  background: var(--accent-gradient);
  color: var(--text-white);
  font-weight: 600;
  /* Semi-bold for active links */
}

/* Mobile menu toggle */
.navbar-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  z-index: 11;
  /* Ensure it's above other elements */
  padding: 10px;
  /* Increase padding for easier tapping */
  margin-left: 10px;
  /* Add some spacing */
  background-color: transparent;
  /* Restore original background */
  border: none;
  /* Remove test border */
  align-self: center;
  /* Center vertically */
}

.bar {
  width: 25px;
  height: 3px;
  background-color: var(--text-white);
  margin: 3px 0;
  transition: 0.3s;
  border-radius: 2px;
  /* Slightly rounded bars */
}

/* Mobile menu styles */
.navbar-menu {
  display: flex;
  align-items: center;
  /* Ensure content is centered */
  height: 100%;
  /* Full height */
}

/* Mobile navbar links for small screens */
.mobile-navbar-links {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: var(--primary-bg);
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  z-index: 9998;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
}

.mobile-navbar-links.show {
  transform: translateX(0);
}

.mobile-navbar-links a {
  padding: 15px;
  margin: 5px 0;
  border-radius: 5px;
  text-align: center;
  font-size: 1.1rem;
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  text-decoration: none;
}

.mobile-navbar-links a.active,
.mobile-navbar-links a:hover {
  background: var(--accent-gradient);
  color: var(--text-white);
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .navbar-links {
    gap: 10px;
  }

  .navbar-links a {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .navbar {
    padding: 15px 5%;
    /* Reduce padding for mobile */
    min-height: 70px;
    /* Adjust height for mobile as per memory */
    background-color: var(--primary-bg) !important;
    /* Restore original background */
  }

  .navbar-links {
    display: none;
    /* Hide desktop nav on mobile */
  }

  .navbar-toggle {
    display: flex !important;
    position: relative;
  }

  /* Mobile navbar links positioning */
  .mobile-navbar-links {
    top: 100%;
  }
}

/* --- Hero Section --- */
.hero {
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, #C700FF60 0%, transparent 70%);
  border-radius: 50%;
  z-index: -1;
  animation: pulse 3s infinite ease-in-out;
}

.hero-logo {
  display: flex;
  align-items: center;
}

.hero h1 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  max-width: 600px;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  color: #FFFFFF;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}

.hero-heading {
  font-family: var(--font-serif);
  font-size: 1.8rem;
  font-weight: 400;
  font-style: italic;
  margin-bottom: 15px;
  max-width: 600px;
  animation: fadeInDown 1s ease-out 0.3s both;
  color: #FFFFFF;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}

.highlight-text {
  color: #C700FF;
  /* Bright purple color */
  font-weight: 600;
  /* Slightly bolder for emphasis */
}

.hero p {
  font-size: 1rem;
  max-width: 550px;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  color: #FFFFFF;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  text-rendering: optimizeLegibility;
}


/* Default: desktop */
.content-mobile {
  display: none;
}

/* Mobile view */
@media (max-width: 480px) {
  .content-desktop {
    display: none;
  }

  .content-mobile {
    display: block;
  }
}



/* Mobile adjustments for hero section */
@media (max-width: 768px) {
  .hero {
    padding: 80px 5% 60px;
    min-height: 70vh;
  }

  .hero h1 {
    font-size: 2.5rem;
    margin-bottom: 25px;
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 500;
  }


  .hero-heading {
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 500;
  }

  .hero p {
    font-size: 1.1rem;
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 400;
  }

  .hero-logo-img {
    height: 100px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 70px 5% 50px;
    margin-top: 3rem;
    min-height: 60vh;
    margin-bottom: -5rem;
  }

  .hero h1 {
    font-size: 2.2rem;
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 500;
  }

  .hero-heading {
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 500;
  }

  .hero p {
    font-size: 1rem;
    color: #FFFFFF !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -moz-osx-font-smoothing: auto;
    text-rendering: optimizeLegibility;
    font-weight: 400;
  }

  .hero-logo-img {
    height: 90px;
  }
}

/* --- Button --- */
.btn {
  display: inline-block;
  padding: 12px 30px;
  /* Gradient Border Logic */
  border: 2px solid transparent;
  background: linear-gradient(var(--primary-bg), var(--primary-bg)) padding-box,
    var(--accent-gradient) border-box;
  /* Ensure primary background covers the padding area */

  color: #FFFFFF;
  /* White text */
  font-weight: 500;
  /* Regular weight */
  border-radius: 50px;
  /* Pill-shaped */
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 50px;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.btn:hover {
  background: var(--accent-gradient);
  border-color: transparent;
  /* Optional: hide border if full fill */
  color: var(--text-white);
}

/* --- Section Heading --- */
.section-heading {
  font-family: var(--font-heading);
  font-size: 2.2rem;
  font-weight: 400;
  color: #C700FF;
  /* Bright purple as specified */
  margin-bottom: 35px;
  text-transform: none !important;
  animation: fadeInUp 1s ease-out 0.2s both;
  font-style: normal;
}

@media (max-width: 480px) {
  #project-heading{
    margin-bottom: 60px;
  }
}

/* ===== Scroll Wrapper ===== */
.scrollable-grid {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.bts-gallery-heading{
  margin-top: -20px;
}


@media (max-width: 480px) {
  #bts-btn{
    margin-top: -20px;
  }
}

/* ===== Auto-scrolling Track ===== */
.placeholder-grid {
  display: flex;
  gap: 35px;
  width: max-content;
  padding: 20px 0;
}

.continue:hover {
  animation-play-state: running !important;
}

/* Auto-scroll animation */
.autoscroll {
  animation: reel-scroll 40s linear infinite;;
}

/* Pause on hover */
.scrollable-grid:hover .autoscroll {
  animation-play-state: paused;
}

/* ===== Individual Card ===== */
.placeholder-card {
  position: relative;
  display: flex ;
  justify-content: center;
  align-items: center;
  width: 260px;
  height: 460px;
  border-radius: 14px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

/* Hover lift */
.placeholder-card:hover {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
}

/* ===== Iframe Video ===== */
.placeholder-card iframe {
  width: 100%;
  height: 100%;
  border: none;
  object-fit: cover;
  border-radius: 14px;
  background: #000;
}

/* Disable iframe focus outline */
.placeholder-card iframe:focus {
  outline: none;
}

/* ===== Gradient Overlay (Cinematic edge) ===== */
.placeholder-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.55),
    rgba(0, 0, 0, 0.15) 40%,
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
}

/* ===== Scroll Animation ===== */
@keyframes reel-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* ===== Responsive ===== */

/* Tablets */
@media (max-width: 1024px) {
  .placeholder-card {
    width: 220px;
    height: 400px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .placeholder-grid {
    gap: 16px;
  }

  .placeholder-card {
    width: 180px;
    height: 320px;
    border-radius: 12px;
  }
}

/* Small phones */
@media (max-width: 480px) {
  .placeholder-card {
    width: 200px;
    height: 270px;
  }
}



/* --- Trailers & BTS Placeholders --- */
/* .placeholder-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
} */

/* .placeholder-card {
  background-color: transparent;
  /* Fixed: transparent video background *
  border-radius: 15px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
  font-weight: 500;
  font-family: var(--font-body);
  text-transform: uppercase;
  transition: all 0.3s ease;
  min-width: auto;
  flex-shrink: 0;
  box-shadow: none !important;
  /* Fixed: No shadow *
  border: none;
  position: relative;
} */

/* .placeholder-card:hover {
  transform: translateY(-8px);
  /* Removed hover background and shadow to keep video clean *
} */

/* --- Scrollable Grid for BTS --- */
/* .scrollable-grid {
  position: relative;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  padding-bottom: 20px;
  /* Space for visual balance *
  margin: 0 auto;
} */

/* --- Autoscroll Animation ---
.autoscroll {
  width: max-content;
  min-width: 100%;
  animation: scroll 80s linear infinite;
  /* Slower speed: 40s -> 80s *
  scrollbar-width: none;
  /* Firefox *
  display: flex;
  gap: 30px;
  will-change: transform;
  flex-wrap: nowrap;
} */

/* .autoscroll:hover {
  animation-play-state: paused;
} */

.autoscroll::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    /* Move left by 50% (width of one set of items) */
    transform: translateX(-50%);
  }
}

@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.8;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(0.9);
    opacity: 0.8;
  }
}

/* Mobile adjustments for scrollable grids */
@media (max-width: 768px) {
  .scrollable-grid {
    padding-bottom: 25px;
  }

  .autoscroll {
    animation-duration: 60s;
    gap: 25px;
  }

  .placeholder-card {
    min-width: auto;
    height: 300px;
  }
}

@media (max-width: 480px) {
  .scrollable-grid {
    padding-bottom: 20px;
  }

  .autoscroll {
    animation-duration: 50s;
    gap: 20px;
  }

  .placeholder-card {
    min-width: auto;
    height: 260px;
  }
}

/* --- Services Section --- */
.services-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 10px;
  /* Reduced further to bring cards closer */
  justify-content: center;
}

.services-labels {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0px;
  /* Reduced further to bring labels closer */
  justify-content: center;
  margin-top: 15px;
  justify-items: center;
}

.services-labels>.service-label {
  margin: 15px auto;
  text-align: center;
}

.service-pair {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  /* Reduced further to bring cards and labels closer */
}

.service-card {
  background-color: transparent;
  /* Removed background */
  border: none;
  /* Removed purple border */
  border-radius: 15px;
  transition: all 0.3s ease;
  box-shadow: none;
  /* Removed box shadow */
  overflow: hidden;
  width: fit-content;
  /* Fit to content size */
  height: fit-content;
  /* Fit to content size */
  margin: 0 auto;
  /* Center the card */
}

.service-card-link {
  text-decoration: none;
  display: block;
  width: fit-content;
  /* Fit to content size */
  height: fit-content;
  /* Fit to content size */
  cursor: pointer;
  /* Show pointer cursor */
  transition: transform 0.3s ease;
  /* margin: 0 auto;
   */
   margin-bottom: 20px;
  /* Center the link */
}

.service-card-link:hover {
  transform: translateY(-5px);
  /* Add hover effect */
}

/* Removed hover effect as per requirements */

.service-image-container {
  position: relative;
  width: fit-content;
  /* Fit to image size */
  height: fit-content;
  /* Fit to image size */
  overflow: hidden;
  background-color: transparent;
  /* Removed background */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  /* Add padding to prevent images from touching edges */
  box-sizing: border-box;
}

.service-image {
  width: auto;
  /* Adjust to natural image width */
  height: 198px; /*198px*/
  /* Increased by 10% from 180px */
  object-fit: contain;
  /* Changed from cover to contain to show full image */
  transition: transform 0.3s ease;
  background-color: transparent;
  /* Removed background */
  display: block;
  border: 1px solid #FFFFFF;   
  border-radius: 12px;         /* Rounded corners */
  padding: 4px;
}

.service-card,
.service-card-link,
.service-image-container {
  overflow: visible !important;
}


.service-card:hover .service-image {
  transform: scale(1.05);
}

.service-icon {
  color: var(--accent-purple);
  font-size: 4rem;
  text-align: center;
  position: relative;
}

.camera-icon {
  position: absolute;
  font-size: 2rem;
  bottom: 10px;
  right: 10px;
}

.service-label {
  background-color: rgba(0, 0, 0, 0.7);
  color: var(--text-white);
  padding: 8px 20px;
  border-radius: 20px;
  border: 1px solid var(--accent-purple);
  font-family: var(--font-body);
  /* font-family: Arial, Helvetica, sans-serif !important; */
  font-weight: 500;
  /* Medium weight */
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 0.5px;
  /* Removed absolute positioning to ensure labels appear in normal document flow */
  position: relative;
  bottom: auto;
  left: auto;
  transform: none;
  margin: 15px auto;
  text-align: center;
  display: inline-block;
}

.service-label-link {
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.service-label-link:hover {
  text-decoration: none;
}

.service-card h3 {
  display: none;
  /* Hide the old text elements */
}

/* Responsive adjustments for Services section */
@media (max-width: 768px) {
  .services-container {
    display: flex;
    flex-direction: column;
    gap: 15px;
    /* Reduced further to bring cards closer */
  }

  .service-pair {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .services-cards {
    grid-template-columns: 1fr;
  }

  .services-labels {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .service-card {
    height: fit-content;
    /* Fit to content size */
    width: fit-content;
    /* Fit to content size */
  }

  .service-card-link {
    height: fit-content;
    /* Fit to content size */
    width: fit-content;
    /* Fit to content size */
  }

  .service-image {
    height: 188px; /*158*/
    /* Increased by 10% from 144px */
  }

  .service-label {
    font-size: 0.9rem;
    padding: 6px 15px;
  }
}

@media (max-width: 480px) {
  .service-card {
    height: fit-content;
    /* Fit to content size */
    width: fit-content;
    /* Fit to content size */
  }

  .service-card-link {
    height: fit-content;
    /* Fit to content size */
    width: fit-content;
    /* Fit to content size */
  }

  .service-image {
    height: 200px; /*132*/
    /* Increased by 10% from 120px */
  }

  .service-label {
    font-size: 0.8rem;
    padding: 5px 12px;
  }
}

/* --- Projects Section --- */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.project-poster {
  border-radius: 15px;
  overflow: hidden;
  transition: transform 0.3s ease;
  position: relative;
  height: 400px;
  /* Fixed height for consistent sizing */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  border: 1px solid #FFFFFF;
  /* Added white border as requested */
}

.project-poster:hover {
  transform: scale(1.05);
}

.project-poster img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* Show full image without cropping */
  object-position: center;
  display: block;
  background-color: #000;
}

/* --- Team/Profiles Section --- */
.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.bts-section {
  margin: 40px 0 60px 0;
}

.bts-content {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  /* Align content to top */
}

.bts-text-content {
  flex: 1 1;
  padding-right: 20px;
  /* Add some padding to separate from video column */
}

.bts-visual-content {
  flex: 1 1;
}

.bts-subheading {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  font-weight: 400;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: none;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.bts-description {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  line-height: 1.6;
  max-width: 600px;
}

.movie-info {
  margin-bottom: 40px;
}

.movie-info:last-child {
  margin-bottom: 0;
}

.bts-section {
  margin: 40px 0 60px 0;
}

.movie-item {
  margin-bottom: 60px;
}

.movie-item:last-child {
  margin-bottom: 0;
}

.bts-visual-content {
  flex: 1 1;
}

.film-strip {
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* Consistent spacing with text content */
}

.film-frame-container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  /* Film strip frame that completely covers the video block */
  padding: 20px 30px;
  /* Space for the film strip borders */
  /* Add a subtle shadow to make it look more like a frame */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  /* Ensure proper box sizing */
  box-sizing: border-box;
  border-radius: 15px;
}

.film-strip-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Dark charcoal grey with subtle texture */
  background: #1a1a1a;
  border-radius: 15px;
  z-index: 1;
  /* Subtle grain texture simulation */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);
  /* Ensure proper box sizing */
  box-sizing: border-box;
  /* Film strip frame that completely encompasses the video block */
  border: none;
  /* Add a subtle inner glow to make it look more like a frame */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);
}

/* Film strip frame with black and white borders */
.film-strip-overlay::before,
.film-strip-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25px;
  /* Wider to create a proper frame */
  /* Black and white stripes forming the film strip frame */
  background: repeating-linear-gradient(to bottom,
      #000 0px,
      #000 15px,
      #fff 15px,
      #fff 30px);
  z-index: 2;
  /* Add 3D effect to make it look like a real film strip frame */
  box-shadow:
    inset 1px 0 3px rgba(255, 255, 255, 0.4),
    inset -1px 0 3px rgba(0, 0, 0, 0.4);
  border: 1px solid #333;
  /* Subtle border to define the frame */
}

.film-strip-overlay::before {
  left: 15px;
  /* Positioned to create the left frame */
}

.film-strip-overlay::after {
  right: 15px;
  /* Positioned to create the right frame */
}





.film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  /* Match the inner frame */
  overflow: hidden;
  transition: transform 0.3s ease;
  z-index: 4;
  /* Ensure content is above overlay */
  cursor: pointer;
  /* Style to make it look like it's inside the film frame */
  background: #000;
  /* Black background for video */
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  /* Shadow to separate from frame */
  width: 100%;
  height: 100%;
}

.video-block-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  /* Video content inside the film frame */
  border-radius: 10px;
  /* Match the film-frame-content radius */
  overflow: hidden;
  /* Style to make it look embedded in the frame */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  /* Shadow to give depth */
  /* Ensure proper sizing within the frame */
  box-sizing: border-box;
}

.video-block-container video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;
  /* Match the container radius */
  /* Style to make it look embedded in the film frame */
  filter: contrast(1.05) saturate(1.05);
  /* Slight enhancement */
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
  /* Inner shadow for depth */
  background-color: #000;
}

/* Removed hover effect */
.film-frame-content:hover {
  transform: none;
}

.checkerboard-pattern {
  width: 100%;
  height: 100%;
  background-image:
    linear-gradient(45deg, #444 25%, transparent 25%),
    linear-gradient(-45deg, #444 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #444 75%),
    linear-gradient(-45deg, transparent 75%, #444 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

.play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  /* Size for good visibility */
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  /* Removed transition to eliminate hover effects */
  z-index: 3;
  pointer-events: none;
  /* Allow clicks to pass through to video controls */
  /* Style to make it look embedded in the film frame */
  background: rgba(0, 0, 0, 0.4);
  /* Darker background for contrast */
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Center the icon perfectly */
  line-height: 1;
  /* Add a subtle border to match the frame style */
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  /* Shadow for depth */
}

/* Removed hover effect on play overlay */
.film-frame-content:hover .play-overlay {
  color: rgba(200, 0, 255, 0.8);
  transform: translate(-50%, -50%);
}

/* Original video container styles - kept for backward compatibility */
.video-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.video-player-container {
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 30px;
  border: 15px solid #333;
  /* Rim-like border */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.video-player {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}

.video-player video {
  width: 100%;
  height: auto;
  display: block;
}

.video-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 400;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.video-description {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

.bts-tabs {
  display: flex;
  justify-content: center;
  margin: 30px 0 40px 0;
  gap: 15px;
}

.tab-button {
  padding: 12px 30px;
  border: 2px solid transparent !important;
  background: linear-gradient(#000, #000) padding-box,
    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  color: #FFFFFF;
  font-weight: 500;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
  outline: none;
}

.tab-button:hover,
.tab-button:focus {
  background: linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  color: var(--text-white);
  box-shadow: 0 0 10px rgba(199, 0, 255, 0.5);
  outline: none;
  /* Ensure border is transparent to maintain size but background covers it */
  border: 2px solid transparent !important;
}

.tab-button.active {
  background: linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  color: var(--text-white);
  border: 2px solid transparent !important;
}

.team-card-link {
  text-decoration: none;
}

.team-card {
  background-color: var(--card-bg);
  border: 2px solid var(--accent-purple);
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  transition: all 0.3s ease;
}

.team-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 0 20px 3px rgba(199, 0, 255, 0.2);
}

.team-card-img-placeholder {
  width: 100%;
  aspect-ratio: 1 / 1;
  /* Makes it a square */
  background-color: var(--placeholder-bg);
  border-radius: 10px;
}

.team-card p {
  color: var(--text-white);
  font-weight: 600;
  font-size: 1.1rem;
  margin: 0;
}

/* --- Footer --- */
.footer {
  background-color: #240046;
  /* Deep purple - matches logo color */
  padding: 30px 5%;
  z-index: 100;
  position: relative;
  margin-top: 50px;
  /* Add margin to ensure proper spacing */
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  text-align: left;
  margin-bottom: 20px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* Increased gap for better spacing */
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.footer-logo-img {
  height: 30px;
  filter: grayscale(100%) brightness(200%);
  /* Monochrome version of the logo */
}

.social-icons {
  display: flex;
  gap: 15px;
}

.social-icons a {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  /* Soft-cornered squares */
  background-color: #333;
  /* Light grey/off-white fill */
  color: var(--text-white);
  /* Light grey/off-white icon color */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.social-icons a:hover {
  background-color: var(--accent-purple);
  color: var(--text-white);
}

.footer-column h4 {
  font-size: 1rem;
  font-weight: 600;
  /* Medium/bold weight */
  margin-bottom: 10px;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  color: #FFFFFF;
  /* White text for violet background */
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.footer-links a {
  color: #FFFFFF;
  /* Light grey for links on violet */
  transition: color 0.3s ease;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  text-transform: capitalize;
  /* Sentence case (only first letter capitalized) */
  font-size: 0.85rem;
}

.footer-links a:hover {
  color: #FFFFFF;
  /* White on hover */
}

.footer-description {
  color: #FFFFFF;
  /* Light grey text for violet background */
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  font-size: 0.85rem;
  /* Smaller size */
  line-height: 1.4;
  max-width: 300px;
}

.copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  /* Light border for violet */
  padding-top: 15px;
  margin-top: 15px;
  font-size: 0.8rem;
  /* Smallest size */
  color: #FFFFFF;
  /* Light grey for violet background */
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  text-align: center;
  /* Centered text */
}

/* Mobile adjustments for footer */
@media (max-width: 768px) {
  .footer {
    padding: 40px 5%;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .footer-column h4 {
    font-size: 1.2rem;
    margin-bottom: 15px;
  }

  .footer-links a {
    font-size: 0.9rem;
  }

  .footer-description {
    font-size: 0.85rem;
  }

  .social-icons {
    gap: 12px;
  }

  .social-icons a {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }

  .copyright {
    font-size: 0.75rem;
    padding-top: 15px;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 30px 5%;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .footer-column h4 {
    font-size: 1.1rem;
    margin-bottom: 12px;
  }

  .footer-links a {
    font-size: 0.85rem;
  }

  .footer-description {
    font-size: 0.8rem;
  }

  .social-icons {
    gap: 10px;
    justify-content: center;
  }

  .social-icons a {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }

  .copyright {
    font-size: 0.7rem;
    padding-top: 12px;
    margin-top: 12px;
  }
}

/* --- What We Do Page --- */
.what-we-do-main {
  background-color: #000000;
  /* Solid black background */
  min-height: calc(100vh - 80px);
}

.what-we-do-hero {
  padding: 60px 5%;
  text-align: center;
}

.what-we-do-heading {
  font-family: var(--font-heading);
  /* Decorative serif font */
  font-size: 2.2rem;
  font-weight: 400;
  color: #8A00C2;
  /* Bright purple */
  margin-bottom: 60px;
  text-transform: none !important;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
  font-style: normal !important;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* 3 columns */
  gap: 20px;
  /* Reduce gap */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.service-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}

.service-container-link {
  text-decoration: none;
  color: inherit;
  transition: transform 0.3s ease;
  display: block;
  height: 100%;
}

.service-container-link:hover {
  transform: translateY(-5px);
}

.service-container-link .service-card {
  cursor: pointer;
}

/* Admin Panel Styles */
.admin-panel {
  background-color: var(--primary-bg);
  color: var(--text-white);
  min-height: calc(100vh - 80px);
  padding: 20px;
}

.admin-header {
  text-align: center;
  margin-bottom: 30px;
  padding: 20px 0;
  border-bottom: 1px solid var(--accent-purple);
}

.admin-title {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0;
  font-style: italic;
  text-decoration: underline;
  text-transform: none !important;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.admin-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
  justify-content: center;
}

.admin-tab-button {
  padding: 12px 25px;
  border: 2px solid var(--accent-purple);
  background-color: transparent;
  color: var(--accent-purple);
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.admin-tab-button:hover,
.admin-tab-button.active {
  background-color: var(--accent-purple);
  color: var(--text-white);
}

.admin-section {
  max-width: 1200px;
  margin: 0 auto;
}

.admin-section h2 {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-bottom: 20px;
  text-align: center;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.admin-form-container {
  background-color: var(--card-bg);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 30px;
  border: 1px solid var(--accent-purple);
}

.admin-form h3 {
  font-family: var(--font-heading);
  font-weight: 400;
  color: var(--accent-purple);
  margin-bottom: 20px;
  text-align: center;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 0px;
  font-weight: 500;
  color: var(--text-white);
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #444;
  background-color: #333;
  color: var(--text-white);
  font-family: var(--font-body);
  font-size: 1rem;
  box-sizing: border-box;
}

.form-textarea {
  min-height: 120px;
  resize: vertical;
}

.submit-btn {
  display: inline-block;
  padding: 12px 30px;
  border: 2px solid #FFFFFF;
  background-color: transparent;
  color: #FFFFFF;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 100%;
  font-size: 1rem;
}

.submit-btn:hover {
  background-color: var(--accent-purple);
  color: var(--text-white);
}

.delete-btn {
  padding: 8px 15px;
  border: 2px solid #ff3333;
  background-color: transparent;
  color: #FFFFFF;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.delete-btn:hover {
  background-color: #ff3333;
  color: var(--text-white);
}

.admin-items-list h3 {
  font-family: var(--font-heading);
  font-weight: 400;
  color: var(--accent-purple);
  margin: 30px 0 20px 0;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.admin-item {
  background-color: var(--card-bg);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #444;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.admin-item-content {
  flex: 1 1;
}

.admin-item-content h4 {
  font-family: var(--font-heading);
  color: var(--accent-purple);
  margin-bottom: 10px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.admin-item-content p {
  color: var(--text-white);
  margin-bottom: 10px;
  line-height: 1.5;
}

.item-link,
.item-email,
.item-date,
.item-message {
  font-size: 0.9rem;
}

.admin-item-image {
  max-width: 200px;
  border-radius: 10px;
  margin-top: 10px;
}

.admin-item-video {
  max-width: 300px;
  margin-top: 10px;
  border-radius: 10px;
}

/* Responsive adjustments for Admin Panel */
@media (max-width: 768px) {
  .admin-panel {
    padding: 15px;
  }

  .admin-title {
    font-size: 2rem;
  }

  .admin-tabs {
    flex-direction: column;
    align-items: center;
  }

  .admin-tab-button {
    width: 100%;
    max-width: 300px;
  }

  .admin-item {
    flex-direction: column;
    align-items: stretch;
  }

  .admin-item-image,
  .admin-item-video {
    max-width: 100%;
  }
}

.service-container-link:hover {
  transform: translateY(-5px);
}

.service-container-link .service-label {
  background-color: rgba(0, 0, 0, 0.7);
  color: var(--text-white);
  padding: 8px 20px;
  border-radius: 20px;
  border: 1px solid var(--accent-purple);
  font-family: var(--font-body);
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
  letter-spacing: 0.5px;
  position: relative;
  margin: 15px auto 0;
  text-align: center;
  display: block;
  width: fit-content;
}

.service-card {
  background-color: transparent;
  /* Remove dark grey outer container */
  border: none;
  /* Remove border */
  border-radius: 15px;
  /* Keep rounded corners */
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.service-illustration {
  width: 100%;
  height: 150px;
  /* Reduce height */
  background-color: transparent;
  /* Remove darker grey background */
  border-radius: 15px;
  /* Keep rounded corners */
  margin-bottom: 0;
  /* Remove margin */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  /* Prevent illustration from shrinking */
}

.service-placeholder {
  width: 100%;
  height: 100%;
  background-color: transparent;
  /* Remove grey background */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #C700FF;
  position: relative;
  overflow: hidden;
}

.service-placeholder::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg,
      rgba(199, 0, 255, 0.1) 25%,
      transparent 25%,
      transparent 75%,
      rgba(199, 0, 255, 0.1) 75%),
    linear-gradient(45deg,
      rgba(199, 0, 255, 0.1) 25%,
      transparent 25%,
      transparent 75%,
      rgba(199, 0, 255, 0.1) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
  z-index: 1;
}

.placeholder-text {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1.2rem;
  font-weight: 500;
}

.placeholder-icon {
  position: relative;
  z-index: 2;
  font-size: 3rem;
  margin-bottom: 20px;
  color: #C700FF;
}

.placeholder-icon .camera-icon {
  position: absolute;
  font-size: 1.5rem;
  bottom: -5px;
  right: -10px;
}

.service-placeholder {
  color: #FFFFFF;
  /* White text */
  font-family: var(--font-body);
  font-size: 1rem;
}

.service-label {
  display: none;
  /* Hide the service label */
}

.service-description {
  color: #CCCCCC;
  /* Light grey text */
  font-family: var(--font-body);
  font-weight: 400;
  text-align: center;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-top: auto;
  /* Push description to bottom of card */
  margin-bottom: 0;
}

.what-we-do-footer {
  background-color: #240046;
  /* Deep purple - matches logo color */
  padding: 60px 5%;
  margin-top: 60px;
}

.what-we-do-footer .footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  text-align: left;
  margin-bottom: 40px;
}

.what-we-do-footer .footer-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.what-we-do-footer .footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.what-we-do-footer .footer-logo-img {
  height: 40px;
}

.what-we-do-footer .social-icons {
  display: flex;
  gap: 15px;
}

.what-we-do-footer .social-icons a {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  /* Soft-cornered squares */
  background-color: transparent;
  /* Transparent background */
  color: #FFFFFF;
  /* White outline-style icons */
  border: 1px solid #FFFFFF;
  /* White border */
  display: flex;
  justify-content: center;
  align-items: center;
}

.what-we-do-footer .social-icons a:hover {
  background-color: #8A00C2;
  /* Purple fill on hover */
  border-color: #8A00C2;
  /* Purple border on hover */
}

.what-we-do-footer .footer-column h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 20px;
  font-family: var(--font-body);
  /* Sans-serif font */
  color: #FFFFFF;
  /* White heading */
}

.what-we-do-footer .footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.what-we-do-footer .footer-links a {
  color: #E0E0E0;
  /* Light grey for links on violet */
  font-family: var(--font-body);
  /* Sans-serif font */
  font-weight: 400;
  /* Regular weight */
  text-decoration: none;
}

.what-we-do-footer .footer-links a:hover {
  color: #FFFFFF;
  /* White on hover */
}

.what-we-do-footer .footer-description {
  color: #E0E0E0;
  /* Light grey text for violet background */
  font-family: var(--font-body);
  /* Sans-serif font */
  font-weight: 400;
  /* Regular weight */
  font-size: 0.9rem;
  line-height: 1.5;
  max-width: 300px;
}

.what-we-do-footer .copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  /* Light border for violet */
  padding-top: 20px;
  margin-top: 20px;
  font-size: 0.8rem;
  color: #E0E0E0;
  /* Light grey for violet background */
  font-family: var(--font-body);
  /* Sans-serif font */
  font-weight: 400;
  /* Regular weight */
  text-align: center;
  /* Centered text */
}

/* Responsive adjustments for What We Do page */
@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns on medium screens */
    gap: 25px;
    /* Reduce gap on medium screens */
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    /* 1 column on small screens */
    gap: 15px;
    /* Reduce gap on small screens */
  }

  .navbar .navbar-links {
    flex-wrap: wrap;
    justify-content: center;
  }

  .what-we-do-footer .footer-grid {
    text-align: center;
  }

  .what-we-do-footer .footer-column {
    align-items: center;
  }

  .what-we-do-footer .copyright {
    text-align: center;
  }
}

/* --- Projects Page --- */

@media (max-width: 480px) {
  #project{
    margin-top: 0;
  }
}
.projects-header {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: #000000;
  /* Solid black background */
  z-index: 1000;
  border-bottom: 1px solid #222;
}

.projects-main {
  background-color: #000000;
  /* Solid black background */
  min-height: calc(100vh - 80px);
  padding: 24px 0 60px;
  position: relative;
  z-index: 1;
  margin-top: 60px;
  /* Account for fixed header */
  /* overflow: hidden; Removed to allow dropdown to be visible */
  will-change: transform;
  /* Enable hardware acceleration */
}

.projects-hero {
  padding: 0 5%;
  max-width: 1200px;
  margin: 0 auto;
}

.projects-header-container {
  position: relative;
  margin-bottom: 24px;
  z-index: 1000;
  text-align: center;
}

.category-filter {
  position: absolute;
  display: inline-block;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1003;
  /* Ensure it's above other elements */
}

.category-dropdown {
  background: transparent;
  border: 1px solid #FFFFFF;
  border-radius: 4px;
  color: #FFFFFF;
  padding: 6px 10px;
  font-family: var(--font-body);
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  min-width: 120px;
  justify-content: space-between;
  font-size: 12px;
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.3s ease;
}

.category-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #000000;
  border: 1px solid #C700FF;
  border-radius: 4px;
  margin-top: 3px;
  z-index: 1004;
  /* Increased z-index to ensure visibility */
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  min-width: 120px;
  width: auto;
}

.category-dropdown-item {
  padding: 8px 12px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #333;
  font-size: 12px;
  white-space: nowrap;
}

.category-dropdown-item:last-child {
  border-bottom: none;
}

.category-dropdown-item:hover {
  background: rgba(199, 0, 255, 0.2);
  color: #C700FF;
}

/* --- Projects Section --- */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
}

.project-poster {
  border-radius: 15px;
  overflow: hidden;
  transition: transform 0.3s ease;
  position: relative;
  height: 360px;
  /* Fixed height for consistent sizing */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
}

.project-poster:hover {
  transform: scale(1.05);
}

.project-poster img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* Show full image without cropping */
  object-position: center;
  display: block;
  background-color: #000;
}

/* Project overlay and options */
.project-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 15px;
}

.project-poster:hover .project-overlay {
  opacity: 1;
}

.project-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 80%;
}

.project-option-btn {
  padding: 12px 20px;
  border: none;
  border-radius: 25px;
  font-family: var(--font-body);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
}

.bts-btn {
  background-color: transparent;
  border: 1px solid #FFFFFF;
  color: white;
}

.bts-btn:hover {
  background: var(--accent-gradient);
  border-color: transparent;
  transform: translateY(-2px);
}

.trailer-btn {
  background-color: transparent;
  border: 1px solid #FFFFFF;
  color: white;
}

.trailer-btn:hover {
  background: var(--accent-gradient);
  border-color: transparent;
  color: white;
  transform: translateY(-2px);
}

/* Fullscreen overlay */
.trailer-modal {
  position: fixed;
  inset: 0; /* top:0 right:0 bottom:0 left:0 */
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

/* Wrapper keeps aspect ratio */
.trailer-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive video */
.trailer-iframe {
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  border: none;
  object-fit: contain; /* keeps full video visible */
  background: black;
}

/* Close button */
.trailer-close {
  position: absolute;
  top: 16px;
  right: 20px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: #fff;
  font-size: 32px;
  cursor: pointer;
  z-index: 10001;
  padding: 6px 12px;
  border-radius: 50%;
}

.trailer-close:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .trailer-close {
    font-size: 28px;
    top: 12px;
    right: 12px;
  }
}

.projects-footer {
  background-color: #240046;
  /* Deep purple - matches logo color */
  padding: 60px 5%;
  margin-top: 60px;
  color: #FFFFFF;
}

.projects-footer .footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  text-align: left;
  margin-bottom: 40px;
}

.projects-footer .footer-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.projects-footer .footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.projects-footer .footer-logo-img {
  height: 40px;
  filter: grayscale(100%) brightness(200%);
  /* Monochrome version of the logo */
}

.projects-footer .social-icons {
  display: flex;
  gap: 15px;
}

.projects-footer .social-icons a {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  /* Soft-cornered squares */
  background-color: #333;
  /* Light grey/off-white fill */
  color: var(--text-white);
  /* Light grey/off-white icon color */
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}

.projects-footer .social-icons a:hover {
  background-color: var(--accent-purple);
  color: var(--text-white);
}

.projects-footer .footer-column h4 {
  font-size: 1.1rem;
  font-weight: 600;
  /* Medium/bold weight */
  margin-bottom: 20px;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  color: #FFFFFF;
  /* White text for violet background */
}

.projects-footer .footer-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.projects-footer .footer-links a {
  color: #E0E0E0;
  /* Light grey for links on violet */
  transition: color 0.3s ease;
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  text-decoration: none;
  text-transform: capitalize;
  /* Sentence case (only first letter capitalized) */
}

.projects-footer .footer-links a:hover {
  color: #FFFFFF;
  /* White on hover */
}

.projects-footer .footer-description {
  color: #E0E0E0;
  /* Light grey text for violet background */
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  font-size: 0.9rem;
  /* Smaller size */
  line-height: 1.5;
  max-width: 300px;
}

.projects-footer .copyright {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  /* Light border for violet */
  padding-top: 20px;
  margin-top: 20px;
  font-size: 0.8rem;
  /* Smallest size */
  color: #E0E0E0;
  /* Light grey for violet background */
  font-family: var(--font-body);
  /* Geometric sans-serif */
  font-weight: 400;
  /* Regular weight */
  text-align: center;
  /* Centered text */
}

/* Responsive adjustments for Projects page */
@media (max-width: 992px) {
  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns on medium screens */
  }

  .projects-header-container {
    flex-direction: column;
  }
}

/* Add these new responsive breakpoints at the end of the file, just before the closing comments */

/* Extra small devices (phones, 480px and down) */
@media (max-width: 480px) {
  .container {
    width: 95%;
    padding: 60px 0;
  }

  .section-heading {
    font-size: 2rem;
  }

  .btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .hero h1 {
    font-size: 1.2rem;
  }

  .hero-heading {
    font-size: 1.5rem;
  }

  .hero p {
    font-size: 0.9rem;
  }

  .hero-logo-img {
    height: 80px;
  }

  .placeholder-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .placeholder-card {
    height: 350px;
    /* Maintain better height on small screens */
  }

  .services-cards {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .services-labels {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .team-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .footer-column {
    align-items: center;
  }

  /* Responsive adjustments for Services section */
  @media (max-width: 768px) {
    .services-cards {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .services-labels {
      grid-template-columns: 1fr;
      gap: 15px;
    }

    .service-card {
      height: 250px;
    }

    .service-label {
      font-size: 0.9rem;
      padding: 6px 15px;
    }
  }

  @media (max-width: 480px) {
    .service-card {
      height: 200px;
    }

    .service-label {
      font-size: 0.8rem;
      padding: 5px 12px;
    }
  }


  .social-icons {
    justify-content: center;
  }
}

/* Small devices (phones, 481px to 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .container {
    width: 95%;
  }

  .section-heading {
    font-size: 2.2rem;
  }

  .placeholder-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .placeholder-card {
    height: 300px;
    /* Adjust height for medium screens */
  }

  .services-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .services-labels {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

/* Medium devices (tablets, 768px to 991px) */
@media (min-width: 768px) and (max-width: 991px) {
  .placeholder-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .placeholder-card {
    height: 350px;
    /* Maintain better height for tablets */
  }

  .services-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .services-labels {
    grid-template-columns: repeat(2, 1fr);
  }

  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Large devices (desktops, 992px to 1199px) */
@media (min-width: 992px) and (max-width: 1199px) {
  .container {
    max-width: 960px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

/* Responsive adjustments for Projects page */
@media (max-width: 992px) {
  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns on medium screens */
  }

  .projects-header-container {
    flex-direction: column;
  }

  .category-filter {
    position: relative;
    right: auto;
    top: auto;
    transform: none;
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
    /* 1 column on small screens */
  }

  .navbar .navbar-links {
    flex-wrap: wrap;
    justify-content: center;
  }

  .projects-footer .footer-grid {
    text-align: center;
  }

  .projects-footer .footer-column {
    align-items: center;
  }

  .projects-footer .copyright {
    text-align: center;
  }

  .category-filter {
    position: relative;
    right: auto;
    top: auto;
    transform: none;
    margin-top: 20px;
  }
}

/* --- Founders Page --- */
.founders-main {
  background-color: #000000;
  /* Solid black background */
  min-height: calc(100vh - 80px);
  padding: 32px 0 60px;
}

.founders-hero {
  padding: 0 5%;
  max-width: 1200px;
  margin: 0 auto;
}

.founders-heading {
  font-family: var(--font-heading);
  /* Elegant Serif font */
  font-size: 3rem;
  /* Large size */
  font-weight: 400;
  /* High contrast */
  color: #C700FF;
  /* Brand's signature vibrant purple */
  margin-bottom: 32px;
  text-transform: none;
  /* Not uppercase */
  text-align: center;
  font-style: italic;
  animation: fadeInUp 1s ease-out 0.2s both;
  font-style: normal !important;
  
}

.founder-item {
  margin-bottom: 48px;
}

.founder-item:last-child {
  margin-bottom: 0;
}

.founder-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}



.founder-columns {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.founder-columns--reversed {
  flex-direction: row-reverse;
}

.founder-columns--reversed .founder-text-content {
  text-align: left;
  align-items: flex-start;
}

.founder-columns--reversed .founder-biography {
  margin-left: 0;
  margin-right: 0;
}

.founder-text-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.founder-name {
  font-family: var(--font-heading);
  /* Prominent Serif font */
  font-size: 2.5rem;
  font-weight: 400;
  color: #FFFFFF;
  /* White color */
  margin: 0;
  text-transform: none;
  font-style: italic;
}

.founder-title {
  font-family: var(--font-heading);
  /* Clean, modern sans-serif */
  font-size: 1.2rem;
  font-weight: 400;
  /* Regular weight */
  color: #FFFFFF;
  /* White color */
  margin: 0;
  text-transform: none;
  font-style: italic;
}

.founder-biography {
  font-family: var(--font-body);
  /* Standard sans-serif */
  font-size: 1rem;
  font-size: 1rem;
  color: #FFFFFF;
  /* White color */
  line-height: 1.6;
  margin-top: 15px;
  /* Separation from designation */
  max-width: 600px;
  margin: 0;
}

.founder-photo-content {
  flex: 1 1;
}

.founder-main-photo .photo-placeholder {
  width: 100%;
  height: 460px;
  background-color: var(--placeholder-bg);
  /* Grey background */
  border-radius: 15px;
  /* Soft, rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1.2rem;
  font-style: italic;
}

.founder-photo-grid {
  display: flex;
  gap: 20px;
}

.founder-photo-placeholder {
  flex: 1 1;
}

.founder-photo-placeholder .photo-placeholder {
  width: 100%;
  height: 150px;
  background-color: var(--placeholder-bg);
  /* Grey background */
  border-radius: 15px;
  /* Rounded rectangle */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1rem;
  font-style: italic;
}

/* Responsive adjustments for Founders page */
@media (max-width: 992px) {
  .founders-heading {
    font-size: 2.5rem;
  }

  .founder-columns {
    flex-direction: column;
  }

  .founder-columns--reversed {
    flex-direction: column;
  }

  .founder-columns--reversed .founder-text-content {
    text-align: left;
  }

  .founder-columns--reversed .founder-biography {
    margin-left: 0;
  }

  .founder-main-photo .photo-placeholder {
    height: 360px;
  }
}

@media (max-width: 600px) {

  .founder-text-content,
  .founder-columns--reversed .founder-text-content {
    align-items: center;
    text-align: left;
  }

  .founder-biography {
    max-width: 100%;
    font-size: 0.95rem;
    line-height: 1.55;
  }

  .founder-photo-grid {
    flex-direction: column;
    gap: 16px;
  }

  .founder-content {
    gap: 24px;
  }

  .founder-columns {
    gap: 20px;
  }

  .founder-name {
    font-size: 1.9rem;
  }

  .founder-title {
    font-size: 1.05rem;
  }

  .founder-main-photo .photo-placeholder {
    height: 280px;
    border-radius: 12px;
  }

  .founder-photo-placeholder .photo-placeholder {
    height: 110px;
    border-radius: 12px;
  }
}

@media (max-width: 768px) {
  .founders-heading {
    font-size: 2rem;
  }

  .founder-name {
    font-size: 2rem;
  }

  .founder-photo-grid {
    flex-direction: column;
  }

  .founder-main-photo .photo-placeholder {
    height: 250px;
  }

  .founder-photo-placeholder .photo-placeholder {
    height: 120px;
  }
}

/* --- Contact Us Page --- */
.contact-main {
  background-color: #000000;
  /* Solid black background */
  min-height: calc(100vh - 80px);
  padding: 40px 0;
}

.contact-hero {
  padding: 0 5%;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-heading {
  font-family: var(--font-heading);
  /* Signature stylish Serif font */
  font-size: 2.2rem;
  /* Large size */
  font-weight: 400;
  /* High contrast */
  color: #C700FF;
  /* Bright, vibrant purple */
  margin-bottom: 40px;
  text-transform: none;
  /* Not uppercase */
  text-align: center;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
  font-style: normal !important;
}

.contact-content {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
}

.contact-columns {
  display: flex;
  gap: 30px;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
}

.contact-map-column {
  margin-top: 60px;
  flex: 1 1;
  min-width: 300px;
  display: flex;
  flex-direction: column;
}

.map-placeholder {
  flex: 1 1;
  width: 100%;
  height: 100%;
  min-height: 450px;
  /* Ensure sufficient height */
  background-color: var(--placeholder-bg);
  /* Light grey */
  border-radius: 15px;
  /* Very soft, rounded corners */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1.5rem;
  font-style: italic;
  overflow: hidden;
}

.map-placeholder iframe {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: inherit;
  object-fit: cover;
}

.contact-form-column {
  flex: 1 1;
  min-width: 350px;
  /* Reduced to fit side-by-side on laptop */
  display: flex;
  flex-direction: column;
  margin-top: 60px;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  justify-content: center;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  color: #C700FF;
  /* Bright purple label */
  font-family: var(--font-heading);
  /* Decorative serif font */
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  animation: fadeInUp 0.6s ease-out;
}

.animated-label {
  animation: labelGlow 2s infinite ease-in-out;
}

.form-input,
.form-textarea {
  background-color: #1a1a1a;
  /* Darker background */
  border: 2px solid #C700FF;
  /* Purple border */
  border-radius: 50px;
  /* Pill-shaped */
  padding: 25px 40px;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1.1rem;
  outline: none;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(199, 0, 255, 0.2);
  width: 100%;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #C700FF;
  box-shadow: 0 0 15px rgba(200, 0, 255, 0.4);
  transform: scale(1.02);
}

.form-input:hover,
.form-textarea:hover {
  border-color: #C700FF;
  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: #999999;
  font-style: italic;
  opacity: 0.7;
}

.form-textarea {
  min-height: 250px;
  border-radius: 30px;
  /* Slightly less rounded for textarea */
  padding: 100px 120px;
  resize: vertical;
  font-size: 1.2rem;
}

.submit-btn {
  background: linear-gradient(45deg, #C700FF, #C700FF);
  /* Purple gradient */
  border: none;
  border-radius: 50px;
  /* Pill-shaped */
  color: #FFFFFF;
  /* White text */
  padding: 15px 40px;
  font-family: var(--font-heading);
  /* Decorative serif font */
  font-size: 1.2rem;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
  /* Align to the left */
  margin-top: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  box-shadow: 0 5px 15px rgba(199, 0, 255, 0.4);
  transform: translateY(0);
}

.submit-btn:hover {
  background: linear-gradient(45deg, #C700FF, #C700FF);
  /* Reverse gradient on hover */
  color: #FFFFFF;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(199, 0, 255, 0.6);
}

.submit-btn:active {
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(199, 0, 255, 0.4);
}

/* Responsive adjustments for Contact Us page */
@media (max-width: 992px) {
  .contact-heading {
    font-size: 2.5rem;
  }

  .contact-columns {
    flex-direction: column;
  }

  .map-placeholder {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .contact-heading {
    font-size: 2rem;
    margin-bottom: 30px !important;
  }

  .map-placeholder {
    height: 300px;
  }

  .submit-btn {
    width: 100%;
  }

  .contact-columns {
    flex-direction: column;
    gap: 24px;
    align-items: stretch;
  }

  .contact-form-column,
  .contact-map-column {
    width: 100%;
    min-width: auto;
  }
}

@media (max-width: 600px) {
  .contact-main {
    padding: 32px 0 48px;
  }

  .contact-hero {
    padding: 0 6%;
  }

  .contact-heading {
    font-size: 1.75rem;
    margin-bottom: 28px;
  }

  .contact-content {
    gap: 24px;
  }

  .contact-columns {
    gap: 18px;
    align-items: center;
  }

  .map-placeholder {
    height: 220px;
    border-radius: 12px;
  }

  .contact-form {
    gap: 14px;
    width: 250%;
  }

  .contact-form-column {
    justify-content: center;
  }

  .form-group label {
    font-size: 1rem;
  }

  .form-input,
  .form-textarea {
    padding: 12px 16px;
    border-radius: 18px;
    font-size: 16px;
    /* Prevent iOS zoom */
    appearance: none;
  }

  .form-textarea {
    min-height: 140px;
  }

  .submit-btn {
    font-size: 16px;
    padding: 12px 20px;
    appearance: none;
  }
}

/* --- Service Detail Pages --- */
.service-detail-page {
  background-color: #000000;
  min-height: calc(100vh - 80px);
  padding: 40px 0;
}

.service-hero {
  padding: 60px 0;
  text-align: center;
  background: radial-gradient(circle at center, #C700FF20 0%, transparent 70%);
}

.service-title {
  font-family: var(--font-heading);
  font-size: 2.6rem;
  font-weight: 400;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: none !important;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  line-height: 1.1;
  word-break: break-word;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.service-intro {
  font-family: var(--font-body);
  font-size: 1.2rem;
  color: var(--text-white);
  max-width: 800px;
  margin: 0 auto 40px;
  line-height: 1.6;
}

.service-content {
  padding: 40px 0;
}

.service-description h2 {
  font-family: var(--font-heading);
  font-size: 2.2rem;
  font-weight: 400;
  color: #FFFFFF;
  margin: 40px 0 20px;
  text-transform: none;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.service-description h3 {
  font-family: var(--font-body);
  font-size: 1.5rem;
  font-weight: 600;
  color: #C700FF;
  margin: 30px 0 15px;
  text-transform: none;
}

.service-description p {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-highlights {
  background-color: #1a1a1a;
  border-radius: 15px;
  padding: 30px;
  margin: 40px 0;
}

.service-highlights h3 {
  font-family: var(--font-heading);
  font-size: 1.6rem;
  font-weight: 400;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: none;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.service-highlights ul {
  list-style-type: none;
  padding: 0;
}

.service-highlights li {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  padding: 10px 0 10px 30px;
  position: relative;
  line-height: 1.5;
}

.service-highlights li:before {
  content: "•";
  color: #C700FF;
  font-size: 1.5rem;
  position: absolute;
  left: 0;
  top: 8px;
}

/* --- Natural Flow for BTS Projects --- */
.natural-flow-section {
  position: relative;
  height: auto;
  background: #000000;
  padding: 50px 0;
  margin-top: 0;
}

.movie-item {
  margin-bottom: 80px;
  scroll-margin-top: 100px;
}

.movie-item:last-child {
  margin-bottom: 0;
}

.movie-card {
  background: #1a1a1a;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(199, 0, 255, 0.3);
  max-width: 1200px;
  margin: 0 auto;
  transition: all 0.3s ease;
}

.movie-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 60px rgba(199, 0, 255, 0.4);
}

.movie-header {
  margin-bottom: 30px;
  text-align: center;
  width: 100%;
}

.movie-title {
  font-family: var(--font-heading);
  font-size: 3rem;
  font-weight: 400;
  color: #C700FF;
  margin: 0;
  text-transform: none !important;
  letter-spacing: 1px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.movie-media {
  width: 100%;
  max-width: 800px;
  margin: 0 auto 30px;
}

.movie-description {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.movie-description p {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin: 0;
}

/* Video container styling */
.natural-flow-section .film-frame-container {
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  overflow: hidden;
}

/* Remove fixed positioning elements */
.fixed-animated-content,
.scroll-spacer,
.scroll-progress-container {
  display: none;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .movie-card {
    padding: 30px;
  }

  .movie-title {
    font-size: 2.5rem;
    font-weight: 400;
    font-style: italic;
    text-decoration: underline;
    text-decoration-color: var(--text-white);
    text-decoration-thickness: 1px;
  }

  .movie-description p {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .movie-card {
    padding: 20px;
  }

  .movie-title {
    font-size: 2rem;
    font-weight: 400;
    font-style: italic;
    text-decoration: underline;
    text-decoration-color: var(--text-white);
    text-decoration-thickness: 1px;
  }

  .movie-media {
    max-width: 100%;
  }

  .movie-description {
    max-width: 100%;
  }
}

/* Hide previous scroll styles */
.continuous-scroll-section {
  display: none;
}

.bts-section {
  position: relative;
}

/* Ensure proper centering and visibility */
.bts-projects-page {
  position: relative;
  z-index: 1;
}

.projects-hero {
  position: relative;
  z-index: 2;
}

.projects-heading {
  position: relative;
  z-index: 3;
  text-align: center;
  margin-bottom: 16px;
  /* Reduced spacing */
  font-family: var(--font-heading);
  font-weight: 400;
  color: #C700FF;
  font-style: italic;
  width: 100%;
  animation: fadeInUp 1s ease-out 0.2s both;
  font-style: normal !important;
}

.bts-tabs {
  position: relative;
  z-index: 3;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  /* Reduced spacing */
}

/* --- Scroll Animation for BTS Projects --- */
.scroll-animated-section {
  position: relative;
  background: #000000;
  padding: 50px 0;
  margin-top: 0;
  z-index: 1;
  display: none;
  /* Hide the old scroll animation section */
}

.bts-section {
  position: relative;
}

.bts-content {
  display: flex;
  gap: 32px;
  margin-bottom: 0;
  position: sticky;
  top: 80px;
  z-index: 2;
  align-items: center;
  padding: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 70vh;
}

/* Left Side - Movie Information */
.movie-list-container {
  flex: 1 1;
  max-width: 400px;
  height: auto;
  padding-right: 20px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-card-swapper {
  position: relative;
  width: 100%;
  height: 350px;
  perspective: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #1a1a1a;
  border: 2px solid rgba(199, 0, 255, 0.3);
  border-radius: 15px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  backface-visibility: hidden;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  opacity: 1;
  align-items: center;
  text-align: center;
  transform: translateZ(0);
}

.movie-card.current {
  transform: translateZ(0);
  z-index: 2;
}

.movie-card-swapper.direction-down .movie-card.current {
  animation: slideInFromBottom 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.movie-card-swapper.direction-up .movie-card.current {
  animation: slideInFromTop 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes slideInFromBottom {
  0% {
    transform: translateY(50px) scale(0.95);
    opacity: 0;
  }

  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes slideInFromTop {
  0% {
    transform: translateY(-50px) scale(0.95);
    opacity: 0;
  }

  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

/* Enhanced smooth transitions */
.movie-list-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 400;
  color: #C700FF;
  margin: 0 0 20px 0;
  text-transform: none !important;
  letter-spacing: 1px;
  text-align: center;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: translateZ(0);
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.movie-list-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin: 0;
  text-align: center;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: translateZ(0);
}

/* Right Side - Video Display */
.video-display-container {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
  max-width: 648px;
}

.video-content {
  background: #1a1a1a;
  border-radius: 15px;
  padding: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: none;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 1;
  height: 350px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateZ(0);
}

.video-content.changing {
  transform: scale(0.98) translateZ(0);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.video-info {
  text-align: center;
  padding: 20px 0;
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  opacity: 1;
}

.video-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 800;
  color: #C700FF;
  margin: 0 0 15px 0;
  text-transform: none !important;
  letter-spacing: 1px;
}

.video-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

/* Reels navigation styles */
.reel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
}

.service-detail-image {
  max-width: 300px;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  gap: 30px;
}

.service-header .service-title {
  flex: 1 1;
  text-align: center;
  margin: 0;
}

.service-image-container {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
}

/* Responsive adjustments for service detail pages */
@media (max-width: 768px) {
  .service-header {
    flex-direction: column;
    text-align: center;
  }

  .service-header .service-title {
    text-align: center;
    margin-bottom: 20px;
  }

  .service-image-container {
    justify-content: center;
  }

  .service-detail-image {
    max-width: 100%;
  }

  .reel-nav:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: translateY(-50%) scale(1.1);
  }

  .reel-nav.prev {
    left: 20px;
  }

  .reel-nav.next {
    right: 20px;
  }

  .reel-nav:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    transform: translateY(-50%);
  }

  .reels-progress {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 10;
  }

  .progress-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .progress-dot.active {
    background: #C700FF;
    transform: scale(1.2);
  }

  /* Fixed content section - stays in place like Instagram reels */
  .fixed-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 400px;
    padding: 20px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fixed-content .movie-title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .fixed-content .movie-description {
    font-size: 0.95rem;
  }
}

/* Service Detail Page Styles */

.service-detail-image {
  max-width: 300px;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.service-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  gap: 24px;
  flex-wrap: wrap;
}

.service-header .service-title {
  flex: 1 1;
  text-align: center;
  margin: 0;
}

.service-image-container {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  padding-left: 10px;
}

/* Our Services subtitle */
.services-subtitle {
  color: #FFFFFF;
  font-family: var(--font-heading);
  font-size: 1.5rem;
  font-weight: 400;
  text-align: left;
  margin: 20px 0 40px;
}

/* Larger headings for description and what we provide with DM Serif Display font */
.service-hero h2 {
  text-align: left;
  margin-top: 30px;
  margin-bottom: 15px;
  width: 100%;
  font-family: 'DM Serif Display', serif;
  font-size: 2.2rem;
  font-weight: 400;
  color: #FFFFFF;
  text-transform: none;
  font-style: normal;
  text-decoration: none;
}

.service-intro {
  text-align: left;
  margin: 0 0 20px 0;
  width: 100%;
  max-width: 100%;
  font-size: 1.2rem;
  font-family: 'DM Serif Display', serif;
  font-weight: 400;
  white-space: pre-wrap;
}

.service-long-description {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin-bottom: 20px;
  white-space: pre-wrap;
}

.service-hero p {
  width: 100%;
  max-width: 100%;
  text-align: left !important;
  font-size: 1.1rem;
  line-height: 1.7;
  font-family: sans-serif;
  font-weight: 400;
  margin-bottom: 40px;
}

@media (max-width: 1024px) {
  .service-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 20px;
  }

  .service-header .service-title {
    text-align: center;
    font-size: 2.3rem;
  }

  .service-image-container {
    padding-left: 0;
    justify-content: center;
  }

  .service-detail-image {
    max-width: 260px;
  }

  .services-subtitle,
  .service-hero h2,
  .service-intro,
  .service-hero p {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .service-hero h2 {
    font-size: 1.9rem;
  }
}

@media (max-width: 600px) {
  .service-hero {
    padding: 40px 0;
  }

  .service-title {
    font-size: 1.9rem;
    letter-spacing: 0.5px;
  }

  .services-subtitle {
    font-size: 1.2rem;
    margin: 16px 0 28px;
  }

  .service-intro {
    font-size: 1rem;
  }

  .service-hero p {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .service-description h2 {
    font-size: 1.7rem;
    text-align: center;
  }

  .service-description h3 {
    font-size: 1.2rem;
  }
}

/* Full width description and what we provide content */
.service-hero .container {
  max-width: 100%;
  width: 100%;
  padding: 0 5%;
}

/* Responsive adjustments for service detail pages */
@media (max-width: 768px) {
  .service-header {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .service-header .service-title {
    text-align: center;
    margin-bottom: 0;
  }

  .services-subtitle {
    text-align: center;
    margin-top: 0;
  }

  .service-image-container {
    justify-content: center;
    padding-left: 0;
  }

  .service-detail-image {
    max-width: 100%;
  }

  /* Mobile alignment adjustments */
  .service-hero h2 {
    text-align: center;
    font-size: 1.8rem;
  }

  .service-intro {
    text-align: center;
  }
}

.fixed-content {
  display: none;
  position: fixed;
  top: 150px;
  left: 0;
  width: 100%;
  height: 70vh;
  display: flex;
  gap: 40px;
  padding: 0 5%;
  z-index: 10;
  pointer-events: none;
}

.fixed-content>* {
  pointer-events: auto;
}

.movie-info-container {
  flex: 1 1;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-card {
  background: #1a1a1a;
  border: 2px solid rgba(199, 0, 255, 0.3);
  border-radius: 15px;
  padding: 30px;
  width: 100%;
  height: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.movie-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 400;
  color: #C700FF;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.movie-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin: 0;
}

.video-container {
  flex: 2 1;
  max-width: 648px;
  height: 350px;
  /* Match photo card height */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.video-content {
  background: #1a1a1a;
  border-radius: 15px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

/* Scroll triggers - create scrolling space */
.scroll-triggers {
  display: none;
  /* Hide scroll triggers since we're using simple layout */
  margin-top: 100vh;
  /* Start after the fixed content */
  padding-bottom: 100vh;
  /* End with space below */
}

.scroll-trigger {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.trigger-content {
  width: 100%;
  max-width: 800px;
  padding: 40px;
  text-align: center;
  color: transparent;
  /* Hide content but keep for scroll detection */
  font-size: 1.2rem;
  line-height: 1.6;
}

.trigger-content h3 {
  color: transparent;
  font-family: var(--font-heading);
  font-size: 2rem;
  margin-bottom: 20px;
}

/* Ensure proper spacing */
.projects-main {
  padding-top: 32px;
}

/* Reels content layout */
.bts-content {
  display: flex;
  gap: 32px;
  margin-bottom: 0;
  position: sticky;
  top: 80px;
  z-index: 2;
  align-items: center;
  padding: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 70vh;
}

.movie-item {
  margin-bottom: 40px;
}

/* Video container styling */
.video-content .film-frame-container {
  max-width: 100%;
  height: 100%;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}

.reels-section .film-frame-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  padding: 20px 30px;
  box-sizing: border-box;
}

.video-content .film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  overflow: hidden;
  z-index: 4;
  background: #000;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.video-content .video-block-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.video-content .video-block-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.video-content .play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.video-content .film-strip-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #1a1a1a;
  border-radius: 15px;
  z-index: 1;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  border: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);
}

/* Film strip frame with black and white borders */
.video-content .film-strip-overlay::before,
.video-content .film-strip-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25px;
  background: repeating-linear-gradient(to bottom,
      #000 0px,
      #000 15px,
      #fff 15px,
      #fff 30px);
  z-index: 2;
  box-shadow:
    inset 1px 0 3px rgba(255, 255, 255, 0.4),
    inset -1px 0 3px rgba(0, 0, 0, 0.4);
  border: 1px solid #333;
}

.video-content .film-strip-overlay::before {
  left: 15px;
}

.video-content .film-strip-overlay::after {
  right: 15px;
}

.reels-section .film-strip-overlay::before,
.reels-section .film-strip-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25px;
  background: repeating-linear-gradient(to bottom,
      #000 0px,
      #000 15px,
      #fff 15px,
      #fff 30px);
  z-index: 2;
  box-shadow:
    inset 1px 0 3px rgba(255, 255, 255, 0.4),
    inset -1px 0 3px rgba(0, 0, 0, 0.4);
  border: 1px solid #333;
}

.reels-section .film-strip-overlay::before {
  left: 15px;
}

.reels-section .film-strip-overlay::after {
  right: 15px;
}

/* Additional styles for reels section */
.reels-section .video-block-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.reels-section .video-block-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.reels-section .film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  overflow: hidden;
  z-index: 4;
  background: #000;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.reels-section .play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

/* Ensure navbar and footer remain visible */
.navbar {
  z-index: 1000;
  position: relative;
  top: 0;
}

.footer {
  z-index: 100;
  position: relative;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .reels-content {
    flex-direction: column;
    gap: 30px;
  }

  .movie-info-container {
    max-width: 100%;
    height: auto;
  }

  .movie-title {
    font-size: 1.8rem;
  }

  .movie-description {
    font-size: 1rem;
  }

  .reels-section .film-frame-container {
    height: 300px;
  }

  .video-container {
    height: 300px;
  }

  .video-container {
    min-height: 300px;
  }

  .reel-nav {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .reel-nav.prev {
    left: 10px;
  }

  .reel-nav.next {
    right: 10px;
  }
}

@media (max-width: 768px) {
  .reels-content {
    gap: 20px;
  }

  .movie-title {
    font-size: 1.5rem;
  }

  .movie-description {
    font-size: 1rem;
  }

  .reels-section .film-frame-container {
    height: 250px;
  }

  .video-container {
    height: 250px;
  }

  .video-container {
    min-height: 250px;
  }

  .reel-nav {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .reel-nav.prev {
    left: 10px;
  }

  .reel-nav.next {
    right: 10px;
  }

  .reels-progress {
    top: 10px;
  }

  .reels-section .projects-grid {
    grid-template-columns: 1fr;
  }
}

/* --- Simple Video Section for BTS Projects --- */
.simple-video-section {
  position: relative;
  height: auto;
  background: #000000;
  padding: 50px 0;
  margin-top: 0;
}

.simple-video-section .bts-section {
  max-width: 1200px;
  margin: 0 auto;
}

.simple-video-section .projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.simple-video-section .movie-item {
  margin-bottom: 30px;
  cursor: pointer;
  transition: transform 0.3s ease;
  scroll-margin-top: 0;
}

.simple-video-section .movie-item:hover {
  transform: translateY(-5px);
}

.simple-video-section .movie-item:last-child {
  margin-bottom: 0;
}

.simple-video-section .movie-card {
  background: #1a1a1a;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(199, 0, 255, 0.3);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.simple-video-section .movie-card:hover {
  border-color: #C700FF;
  box-shadow: 0 15px 35px rgba(199, 0, 255, 0.4);
}

.simple-video-section .movie-header {
  margin-bottom: 20px;
  text-align: center;
  width: 100%;
  flex-shrink: 0;
}

.simple-video-section .movie-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 400;
  color: #C700FF;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

/* BTS Video Styles */
body {
  margin: 0;
  padding: 0;
  background: black;
  color: white;
  font-family: "Poppins", sans-serif;
  overflow-x: hidden;
}

/* Wrapper */
.bts-video-wrapper {
  width: 100%;
  background: black;
  color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Header */
.bts-header {
  text-align: center;
  margin-top: 60px;
}

.bts-title {
  font-family: var(--font-heading);
  font-size: 3rem;
  font-weight: 400;
  color: #b300ff;
  margin-bottom: 10px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.bts-toggle {
  margin-bottom: 30px;
}

.toggle-btn {
  background: #2d143d;
  color: #b300ff;
  border: none;
  padding: 8px 25px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
}

.toggle-btn.active {
  background: #b300ff;
  color: white;
}

/* Layout */
.bts-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  width: 90%;
  max-width: 1200px;
}

/* Left Info */
.bts-info {
  width: 40%;
  position: sticky;
  top: 50px;
  /* Further reduced spacing from navbar */
  transition: opacity 0.4s ease;
}

.movie-name {
  font-size: 1.8rem;
  font-style: italic;
  color: white;
  transition: all 0.3s ease;
}

.movie-description {
  margin-top: 5px;
  /* Further reduced spacing from movie name */
  font-size: 1rem;
  line-height: 1.6;
  color: #e0e0e0;
  transition: all 0.3s ease;
}

/* Right Reel Section */


/* Right Reel Section */
.bts-reel-frame {
  width: 70%;
  height: 95vh;
  background: none;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.bts-reel-scroll {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scrollbar-width: none;
}

.bts-reel-scroll::-webkit-scrollbar {
  display: none;
}

.bts-reel-item {
  scroll-snap-align: start;
  height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bts-reel-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

/* Responsive */
@media (max-width: 900px) {
  .bts-main {
    flex-direction: column;
    align-items: center;
  }

  .bts-info {
    width: 100%;
    position: static;
    text-align: center;
    margin-bottom: 20px;
  }

  .bts-reel-frame {
    width: 100%;
    height: 70vh;
  }

  .movie-name {
    font-size: 1.5rem;
  }

  .movie-description {
    font-size: 0.95rem;
  }
}

/* Extra small devices (phones, 480px and down) */
@media (max-width: 480px) {
  .movie-description {
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .container {
    width: 95%;
    padding: 60px 0;
  }

  .section-heading {
    font-size: 2rem;
  }

  .btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }

  .hero h1 {
    font-size: 1.2rem;
  }

  .hero-heading {
    font-size: 1.5rem;
  }

  .hero p {
    font-size: 0.9rem;
  }

  .hero-logo-img {
    height: 80px;
  }

  .placeholder-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .services-cards {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .services-labels {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .team-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 30px;
    text-align: center;
  }

  .footer-column {
    align-items: center;
  }

  .social-icons {
    justify-content: center;
  }
}

/* Small devices (phones, 481px to 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .container {
    width: 95%;
  }

  .section-heading {
    font-size: 2.2rem;
  }

  .placeholder-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .placeholder-card {
    height: 300px;
    /* Adjust height for medium screens */
  }

  .services-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .services-labels {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
}

/* Medium devices (tablets, 768px to 991px) */
@media (min-width: 768px) and (max-width: 991px) {
  .placeholder-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .placeholder-card {
    height: 320px;
    /* Adjust height for tablets */
  }

  .services-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .services-labels {
    grid-template-columns: repeat(2, 1fr);
  }

  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .team-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Large devices (desktops, 992px to 1199px) */
@media (min-width: 992px) and (max-width: 1199px) {
  .container {
    max-width: 960px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

.simple-video-section .movie-media {
  width: 100%;
  margin: 0 0 20px 0;
  flex: 1 1;
}

.simple-video-section .movie-description {
  width: 100%;
  text-align: center;
  flex-shrink: 0;
}

.simple-video-section .movie-description p {
  font-family: var(--font-body);
  font-size: 1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin: 0;
}

/* Video container styling */
.simple-video-section .film-frame-container {
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  overflow: hidden;
  padding: 20px 30px;
  box-sizing: border-box;
  position: relative;
  height: 350px;
  /* Fixed height to match photo cards */
}

/* Film strip overlay */
.simple-video-section .film-strip-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #1a1a1a;
  border-radius: 15px;
  z-index: 1;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  border: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);
}

/* Film strip frame with black and white borders */
.simple-video-section .film-strip-overlay::before,
.simple-video-section .film-strip-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 25px;
  background: repeating-linear-gradient(to bottom,
      #000 0px,
      #000 15px,
      #fff 15px,
      #fff 30px);
  z-index: 2;
  box-shadow:
    inset 1px 0 3px rgba(255, 255, 255, 0.4),
    inset -1px 0 3px rgba(0, 0, 0, 0.4);
  border: 1px solid #333;
}

.simple-video-section .film-strip-overlay::before {
  left: 15px;
}

.simple-video-section .film-strip-overlay::after {
  right: 15px;
}

/* Film frame content */
.simple-video-section .film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  z-index: 4;
  cursor: pointer;
  background: #000;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

/* Play overlay */
.simple-video-section .play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

/* Video block container */
.simple-video-section .video-block-container {
  position: relative;
  width: 100%;
  height: 450px;
  /* Increased from 350px */
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.simple-video-section .video-block-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

/* Film frame content */
.simple-video-section .film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease;
  z-index: 4;
  cursor: pointer;
  background: #000;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

/* Play overlay */
.simple-video-section .play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

/* --- Video Container Improvements --- */
.video-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.video-player-container {
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  height: 350px;
  /* Fixed height to match photo cards */
}

.video-player {
  width: 100%;
  height: 100%;
  border-radius: 15px;
  overflow: hidden;
}

.video-player video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.video-info {
  text-align: center;
  padding: 20px 0;
}

.video-title {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  font-weight: 700;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.video-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

/* Mobile adjustments for video components */
@media (max-width: 768px) {
  .video-player-container {
    height: 350px;
    border-radius: 12px;
  }

  .video-title {
    font-size: 2rem;
  }

  .video-description {
    font-size: 1rem;
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .video-player-container {
    height: 300px;
    border-radius: 10px;
  }

  .video-title {
    font-size: 1.8rem;
  }

  .video-description {
    font-size: 0.9rem;
  }
}

/* --- BTS Video Page --- */
.bts-video-page {
  background-color: #000000;
  min-height: calc(100vh - 80px);
  padding: 40px 0;
  overflow: hidden;
  /* Prevent scrolling */
}

.bts-video-page .projects-main {
  position: relative;
  z-index: 1;
}

.video-section {
  display: flex;
  justify-content: center;
  width: 100%;
}

.video-wrapper {
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.video-container {
  position: relative;
  width: 100%;
  height: 450px;
  /* Increased from 350px */
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  background-color: #000;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-info {
  text-align: center;
  padding: 20px;
}

.video-title {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  font-weight: 700;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.video-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

/* --- Instagram Reels Style --- */
.reels-section {
  position: relative;
  height: 80vh;
  background: #000000;
  padding: 50px 0;
  margin-top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reels-content {
  display: flex;
  gap: 40px;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  position: relative;
  align-items: stretch;
}

/* Left Side - Movie Information */
.movie-info-container {
  flex: 1 1;
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.movie-card {
  background: #1a1a1a;
  border: 2px solid rgba(199, 0, 255, 0.3);
  border-radius: 15px;
  padding: 20px;
  /* Reduced padding */
  width: 100%;
  height: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.movie-title {
  font-family: var(--font-heading);
  font-size: 2rem;
  font-weight: 800;
  color: #C700FF;
  margin: 0 0 10px 0;
  /* Reduced spacing */
  text-transform: uppercase;
  letter-spacing: 1px;
}

.movie-description {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.6;
  margin: 0;
}

/* Right Side - Video Display */
.video-container {
  flex: 2 1;
  max-width: 648px;
  height: 350px;
  /* Match photo card height */
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 10px;
  /* Reduced spacing */
}

.reel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.reel-nav:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-50%) scale(1.1);
}

.reel-nav.prev {
  left: 20px;
}

.reel-nav.next {
  right: 20px;
}

.reel-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  transform: translateY(-50%);
}

.reels-progress {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
  z-index: 10;
}

.progress-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transition: all 0.3s ease;
  cursor: pointer;
}

.progress-dot.active {
  background: #C700FF;
  transform: scale(1.2);
}

/* Responsive adjustments for video section */
@media (max-width: 768px) {
  .video-title {
    font-size: 2rem;
  }

  .video-description {
    font-size: 1rem;
  }

  .video-wrapper {
    padding: 0 15px;
  }

  .video-info {
    padding: 15px;
  }

  .reel-nav {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .reel-nav.prev {
    left: 10px;
  }

  .reel-nav.next {
    right: 10px;
  }

  .reel-info {
    padding: 15px;
  }

  .video-title {
    font-size: 1.5rem;
  }

  .video-description {
    font-size: 0.9rem;
  }
}

/* Responsive adjustments for video section */
@media (max-width: 992px) {
  .video-title {
    font-size: 2rem;
  }

  .video-description {
    font-size: 1rem;
  }

  .video-container {
    height: 300px;
  }

  .simple-video-section .film-frame-container {
    height: 300px;
  }
}

@media (max-width: 768px) {
  .video-title {
    font-size: 1.8rem;
  }

  .video-description {
    font-size: 0.9rem;
  }

  .video-container {
    height: 250px;
  }

  .simple-video-section .film-frame-container {
    height: 250px;
  }

  .simple-video-section .projects-grid {
    grid-template-columns: 1fr;
  }
}

/* Show the scroll animation section */
.scroll-animated-section {
  display: none;
  /* Hide scroll animation for reels */
}



/* Additional styles for reels section */
.reels-section .video-block-container {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.reels-section .video-block-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.reels-section .film-frame-content {
  position: relative;
  display: block;
  border-radius: 10px;
  overflow: hidden;
  z-index: 4;
  background: #000;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.reels-section .play-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  color: rgba(200, 0, 255, 0.8);
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  z-index: 3;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: 2px solid rgba(200, 0, 255, 0.5);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

/* BTS Video Styles */
body {
  margin: 0;
  padding: 0;
  background: black;
  color: white;
  font-family: "Poppins", sans-serif;
  overflow-x: hidden;
}

/* Wrapper */
.bts-video-wrapper {
  width: 100%;
  background: black;
  color: white;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Header */
.bts-header {
  text-align: center;
  margin-top: 60px;
}

.bts-title {
  font-family: var(--font-heading);
  font-size: 3rem;
  font-weight: 400;
  color: #b300ff;
  margin-bottom: 10px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.bts-toggle {
  margin-bottom: 30px;
}

.toggle-btn {
  background: #2d143d;
  color: #FFFFFF;
  border: none;
  padding: 8px 25px;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
}

.toggle-btn.active {
  background: #b300ff;
  color: white;
}

/* Layout */
.bts-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  width: 90%;
  max-width: 1200px;
}

/* Left Info */
.bts-info {
  width: 40%;
  position: sticky;
  top: 150px;
  transition: opacity 0.4s ease;
}

.movie-name {
  font-size: 1.8rem;
  font-style: italic;
  color: white;
  transition: all 0.3s ease;
}

.movie-description {
  margin-top: 15px;
  font-size: 1rem;
  line-height: 1.6;
  color: #e0e0e0;
  transition: all 0.3s ease;
}

/* Right Reel Section */
.bts-reel-frame {
  width: 70%;
  height: 90vh;
  background: none;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.bts-reel-scroll {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  scrollbar-width: none;
}

.bts-reel-scroll::-webkit-scrollbar {
  display: none;
}

.bts-reel-item {
  scroll-snap-align: start;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bts-reel-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

/* Responsive */
@media (max-width: 900px) {
  .bts-main {
    flex-direction: column;
    align-items: center;
  }

  .bts-info {
    width: 100%;
    position: relative !important;
    /* Force relative positioning */
    z-index: 10;
    text-align: center;
    background: #000;
    /* Ensure text is readable against black bg */
    padding-bottom: 10px;
    margin-bottom: 10px;
    /* Push video down */
  }

  .bts-reel-frame {
    width: 100%;
    height: 70vh;
    margin-top: 0 !important;
  }

  .movie-name {
    font-size: 1.5rem;
    margin-bottom: 3px;
    /* Further reduced spacing */
  }

  .movie-description {
    font-size: 0.8rem !important;
    /* Reduced font size */
    line-height: 1.4;
    margin-top: 5px;
    color: #e0e0e0;
  }
}

/* Remove underline from footer headings */
.footer-column h4::after {
  content: none !important;
  display: none !important;
}

.footer-column h4 {
  padding-bottom: 0 !important;
}

/* Remove underline from founder name and title */
.founder-name::after,
.founder-title::after {
  content: none !important;
  display: none !important;
}

.founder-name,
.founder-title {
  padding-bottom: 0 !important;
}

/* Ensure all specific page headings are inline-block for proper underline alignment */
.service-title,
.what-we-do-heading,
.projects-heading,
.founders-heading,
.hero-heading {
  display: inline-block !important;
  width: auto !important;
  max-width: 100%;
}

/* Ensure their containers center them */
.service-header,
.what-we-do-hero,
.projects-header-container,
.founders-hero {
  text-align: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.service-subtopics {
  margin: 15px 0;
  text-align: left;
  width: 100%;
}

.service-subtopic-item {
  margin-bottom: 15px;
}

.service-subtopic-title {
  color: #C700FF;
  font-size: 1.1rem;
  margin-bottom: 5px;
  font-weight: 600;
  display: inline-block;
}
.service-subtopic-title {
  position: relative;        /* needed so underline attaches to text */
  display: inline-block;
}


.service-subtopic-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;                /* move line up */
  transform: translateY(4px);  /* fine-tune alignment */

  width: 100%;
  height: 2px;

  background: linear-gradient(90deg, #C700FF, #006EFF);
}


.service-subtopic-description {
  color: #CCCCCC;
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.4;
}

.service-name-container {
  margin-top: -10px;
  text-align:center;
  width: 100%;
  margin-bottom: 30px;
}

@media(max-width:480px) {
  .service-name-container{
    margin-top: 10px; 
  }
}

.service-name-link {
  /* font-family: Arial, Helvetica, sans-serif !important; */
  text-decoration: none;
  display: inline-block;
}

.service-name {
  color: #FFFFFF;
  font-family: var(--font-heading);
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 1px;
  margin: 0;
  transition: color 0.3s ease;
}

.service-name-link:hover .service-name {
  color: #C700FF;
}

.edit-btn {
  padding: 8px 15px;
  border: 2px solid #33ff33;
  background-color: transparent;
  color: #33ff33;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.edit-btn:hover {
  background-color: #33ff33;
  color: var(--primary-bg);
}

.cancel-btn {
  padding: 12px 30px;
  border: 2px solid #ff9933;
  background-color: transparent;
  color: #ff9933;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
  width: auto;
  font-size: 1rem;
}

.cancel-btn:hover {
  background-color: #ff9933;
  color: #FFFFFF;
}

.delete-btn {
  padding: 8px 15px;
  border: 2px solid #ff4444;
  background-color: transparent;
  color: #ff4444;
  font-weight: 500;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.delete-btn:hover {
  background-color: #ff4444;
  color: #FFFFFF;
}

.form-select {
  background-color: #1a1a1a;
  border: 2px solid #C700FF;
  border-radius: 50px;
  padding: 15px 40px;
  color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 1.1rem;
  outline: none;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px rgba(199, 0, 255, 0.2);
  width: 100%;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 20px center;
  background-size: 20px;
}

.form-select:focus {
  border-color: #C700FF;
  box-shadow: 0 0 15px rgba(200, 0, 255, 0.4);
  transform: scale(1.02);
}

.form-select:hover {
  border-color: #C700FF;
  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);
}

.form-select option {
  background-color: #1a1a1a;
  color: #FFFFFF;
  padding: 10px;
}

/* --- Founders Page Styles --- */
.founder-row {
  display: flex;
  gap: 60px;
  align-items: flex-start;
  margin-bottom: 120px;
}

.founder-row.reversed {
  flex-direction: row-reverse;
}

.founder-image-col {
  flex: 0 0 360px;
  /* Reduced width to fit 342px images snugly */
  max-width: 100%;
  width: 100%;
}

.founder-content-col {
  flex: 0 0 50%;
  max-width: 50%;
  text-align: left;
  /* Enforce left alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* Vertically center content if needed, or flex-start */
  align-items: flex-start;
  /* Left align flex items */
}

.founder-main-photo img {
  width: 342px;
  /* Exact match with sub-images */
  height: 350px;
  /* moderate height */
  object-fit: cover;
  /* Keeps it looking like a nice portrait */
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(199, 0, 255, 0.3);
  transition: transform 0.3s ease;
}

.founder-main-photo img:hover {
  transform: scale(1.02);
}

.founder-name {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  color: #C700FF;
  margin-bottom: 5px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: #555;
  text-decoration-thickness: 1px;
  text-align: left;
}

.founder-title {
  color: #FFFFFF;
  font-size: 1.2rem;
  margin-bottom: 20px;
  opacity: 0.8;
  font-family: var(--font-body);
  text-transform: uppercase;
  letter-spacing: 2px;
}

.founder-biography {
  color: #CCCCCC;
  line-height: 1.8;
  margin-bottom: 180px;
  font-size: 1.1rem;
  font-family: var(--font-body);
}

.founder-sub-photos {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 30px;
  align-items: center;
  /* Center the images in the column */
}

.sub-photo-item img {
  width: 342px;
 /* height: 208px;*/
  object-fit: contain;
  /* Changed from cover to contain to fit photo completely */
  background: #000;
  /* Optional: background for empty space if aspect ratio differs */
  border-radius: 10px;
  border: 1px solid rgba(199, 0, 255, 0.2);
  transition: transform 0.3s ease;
  cursor: pointer;
}

.sub-photo-item img:hover {
  transform: scale(1.05);
  border-color: #C700FF;
}

@media (max-width: 992px) {
  .founder-row {
    flex-direction: column;
    gap: 40px;
  }

  .founder-row.reversed {
    flex-direction: column;
  }

  .founder-image-col,
  .founder-content-col {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }

  .founder-sub-photos {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* --- Admin Panel --- */
.admin-header {
  margin-bottom: 30px;
  text-align: center;
}

.admin-title {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  font-weight: 400;
  color: #C700FF;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-style: italic;
}

.admin-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
}

.admin-tab-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--text-white);
  padding: 10px 20px;
  border-radius: 30px;
  font-family: var(--font-body);
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.admin-tab-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.admin-tab-button.active {
  background: var(--accent-gradient);
  color: var(--text-white);
  border-color: transparent;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(199, 0, 255, 0.4);
}

/* --- Footer Visual Effects --- */

/* Footer Logo Effect */
.footer-logo-img {
  transition: transform 0.3s ease, filter 0.3s ease;
}

.footer-logo-img:hover {
  transform: scale(1.1);
  filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.6));
}

/* Social Icons Gradient Hover */
.social-icons a:hover .fa-instagram,
.social-icons a:hover .fa-linkedin-in {
  background: var(--accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  transform: scale(1.2);
  display: inline-block;
  transition: transform 0.3s ease;
}

/* --- Project Card Image Fitting --- */
.project-poster {
  height: auto !important;
  /* Allow card to shrink/grow to fit image */
  min-height: auto !important;
  display: flex !important;
  /* Removes bottom whitespace from inline-block images */
  flex-direction: column;
}

.project-poster img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  /* Ensure full image is shown */
  display: block;
  flex-grow: 1;
}

/* --- Fix Project Card Grid Stretching --- */
.projects-grid {
  align-items: start !important;
  /* Prevent cards from stretching to fill row height */
}

/* --- Specific Fix for Home Page Project Cards --- */
#project .project-poster {
  max-width: 350px !important;
  margin: 0 auto !important;
}

/* --- Specific Fix for Projects Page Project Cards --- */
.projects-main .project-poster {
  max-width: 350px !important;
  margin: 0 auto !important;
}

/* --- Fix Contact Page Alignment & Sizing (Extra Compact) --- */
.contact-hero {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}



.contact-columns {
  display: flex !important;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
  /* Tighter gap */
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-map-column,
.contact-form-column {
  flex: 1 1;
  width: 48%;
  display: flex;
  flex-direction: column;
}

/* Map sizing - Extra Compact */
.map-placeholder {
  height: 100%;
  min-height: 220px;
  /* Reduced to ~220px */
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
}

/* Form Layout */
.contact-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Compact Inputs */
.form-group {
  margin-bottom: 10px !important;
}

.animated-label {
  color: #FFFFFF !important;
  font-family: var(--font-body);
  font-size: 0.9rem;
  margin-bottom: 5px;
  display: block;
}

.form-input {
  padding: 5px 15px !important;
  height: 35px !important;
  font-size: 0.9rem;
  border: 2px solid transparent !important;
  background: linear-gradient(#333, #333) padding-box,
    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  border-radius: 8px !important;
  color: white !important;
}

.form-textarea {
  padding: 8px 15px !important;
  height: 55px !important;
  /* Increased by ~50% from 35px */
  min-height: 55px !important;
  max-height: 55px !important;
  resize: none !important;
  font-size: 0.9rem;
  border: 2px solid transparent !important;
  background: linear-gradient(#333, #333) padding-box,
    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  border-radius: 8px !important;
  color: white !important;
}

/* Force placeholders to be white */
.form-input::placeholder,
.form-textarea::placeholder {
  color: white !important;
  opacity: 1;
}

.submit-btn {
  margin-top: auto;
  padding: 6px 25px;
  font-size: 0.9rem;
  border: 2px solid transparent !important;
  background: linear-gradient(#333, #333) padding-box,
    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;
  border-radius: 25px !important;
  color: white !important;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  border-color: transparent;
  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .contact-columns {
    flex-direction: column;
  }
}

/* --- BTS Video Layout (New) --- */
.bts-main {
  display: flex;
  gap: 40px;
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  align-items: flex-start;
}

.bts-info {
  flex: 1 1;
  position: sticky;
  top: 100px;
  max-width: 100%;
  padding: 20px;
}

.bts-reel-frame {
  flex: 2 1;
  position: relative;
}

.bts-reel-scroll {
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding-bottom: 100px;
}

.bts-reel-item {
  width: 100%;
  display: flex;
  justify-content: center;
}

.film-frame-container {
  position: relative;
  width: 100%;
  max-width: 450px;
  /* Reduced max-width for better laptop fit */
  aspect-ratio: 9/16;
  max-height: 80vh;
  /* Prevent overflowing screen height */
  background: #000;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  border: 1px solid #333;
}

.film-frame-content {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}

.video-block-container {
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-block-container video,
.video-block-container iframe {
  width: 100%;
  height: 100%;
  /*object-fit: contain !important;*/
  /* Forces complete visibility */
  border: none;
}

@media (max-width: 900px) {
  .bts-main {
    display: block;
    /* Vertical stack */
  }

  .bts-info {
    position: sticky;
    top: 70px;
    /* Below Navbar */
    z-index: 30;
    /* Above scrolling videos */
    background: rgba(0, 0, 0, 0.9);
    /* Dark background */
    backdrop-filter: blur(10px);
    max-height: 30vh;
    padding: 15px;
    border-bottom: 2px solid var(--accent-purple);
    border-radius: 0 0 15px 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
    margin-bottom: 20px;
    /* Space before videos start */
    text-align: center;
  }

  .bts-reel-scroll {
    display: flex;
    flex-direction: column;
    gap: 40px;
    /* Clear separation between videos */
    padding-bottom: 40px;
  }

  .bts-reel-item {
    position: relative;
    /* Normal flow */
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .film-frame-container {
    width: 100%;
    /* Full width of container */
    max-width: 450px;
    /* Limit width for larger mobiles */
    height: auto;
    aspect-ratio: 9/16;
    margin: 0 auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  }

  .video-block-container video,
  .video-block-container iframe {
    object-fit: contain !important;
  }
}

/* --- New Responsive Styles for Founders & Contact --- */

/* Founders Page */
.founders-hero {
  padding: 60px 0 0;
  text-align: center;
  
}

.founders-heading {
  font-family: var(--font-heading);
  font-size: 2.2rem;
  color: #C700FF;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
}

.founder-row {
  display: flex;
  align-items: center;
  gap: 60px;
  margin-bottom: 80px;
  padding: 20px;
}

.founder-row:last-child {
  margin-bottom: 0;
}

.founder-row.reversed {
  flex-direction: row-reverse;
}

.founder-image-col {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.founder-main-photo {
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  border: 2px solid var(--accent-purple);
  box-shadow: 0 0 20px rgba(199, 0, 255, 0.3);
}

.founder-main-photo img {
  width: 100%;
  height: auto;
  display: block;
}

.founder-sub-photos {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  width: 100%;
  max-width: 400px;
}

/* promoters portfolio css */
/* .horizontal-scroll-wrapper{
  width: 100%;
  overflow: hidden;
  position: relative;
}

.horizontal-scroll-track {
  width: 100%;
  margin-top: 10px;
  /* height: 130px; *
  display: flex;
  gap: 20px;
  animation: horizontalScroll 30s linear infinite;
}

@keyframes horizontalScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.portfolio-image{
  height: 130px;
  width: 100px ;
}

.portfolio-image img{
  width: 90px !important;
  height: 120px !important;
  object-fit: cover !important;
  background: #000;
  border-radius: 10px;
  border: 1px solid rgba(199, 0, 255, 0.2);
  transition: transform 0.3s ease, border-color 0.3s ease;
  cursor: pointer;
  flex-shrink: 0; * VERY important *
}

.portfolio-image img:hover{
  transform: scale(1.05);
  border-color: #C700FF;
}

.sub-photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid #444;
  transition: transform 0.3s ease;
}

.sub-photo-item img:hover {
  transform: scale(1.05);
} */

.horizontal-scroll-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.horizontal-scroll-track {
  margin-top: 35px;
  height: 150px;
  display: flex;
  gap: 20px;
  animation: horizontalScroll 30s linear infinite;
  flex-wrap: nowrap;
}

/* IMPORTANT: width yahan control karo */
.portfolio-image {
  width: 100px;
  height: 130px;
  flex-shrink: 0; /* MOST IMPORTANT LINE */
}

.portfolio-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  border-radius: 10px;
  border: 1px solid rgba(199, 0, 255, 0.2);
  transition: transform 0.3s ease, border-color 0.3s ease;
  cursor: pointer;
}

.portfolio-image img:hover {
  transform: scale(1.05);
  border-color: #C700FF;
}

/* default (desktop) */
.promoters-portfolio {
  margin-top: 70px;
}

/* mobile view */
@media (max-width: 768px) {
  .promoters-portfolio {
    margin-top: -70px;
    margin-bottom: -150px;
  }

  .horizontal-scroll-track {
  animation: horizontalScroll 20s linear infinite;
}
}

@media (max-width: 480px) {
  .promoters-portfolio {
    margin-top: -70px;
    margin-bottom: -150px;
  }
}


/* Animation */
@keyframes horizontalScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}


.founder-content-col {
  flex: 1.2 1;
  text-align: left;
}

.founder-row.reversed .founder-content-col {
  text-align: left;
}

.founder-name {
  font-family: var(--font-heading);
  font-size: 2.5rem;
  color: #FFFFFF;
  margin-bottom: 10px;
  font-style: italic;
}

.founder-title {
  font-family: var(--font-body);
  font-size: 1.5rem;
  color: var(--accent-purple);
  margin-bottom: 25px;
  font-weight: 500;
  text-transform: uppercase;
}

.founder-biography {
  font-family: var(--font-body);
  font-size: 1.1rem;
  color: var(--text-white);
  line-height: 1.8;
  white-space: pre-wrap;
  /* Preserve line breaks */
  text-align: left;
}

/* Contact Page */
.contact-hero {
  padding: 40px 0;
  text-align: center;
}

.contact-heading {
  font-family: var(--font-heading);
  font-size: 2.2rem;
  color: #C700FF;
  margin-bottom: 60px;
  font-style: italic;
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

/* Removed duplicate/conflicting .contact-map-column and .map-placeholder definitions */

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  text-align: left;
}

.animated-label {
  display: block;
  font-family: var(--font-body);
  color: var(--accent-purple);
  margin-bottom: 10px;
  font-size: 1.1rem;
  font-weight: 500;
}

/* Mobile Adjustments for Founders & Contact */
@media (max-width: 900px) {

  /* Founders - Stack Vertically */
  .founder-row,
  .founder-row.reversed {
    flex-direction: column !important;
    gap: 40px;
    text-align: center;
    padding: 0;
  }
    
  .founder-content-col,
  .founder-row.reversed .founder-content-col {
    text-align: center;
    width: 100%;
  }

  .founder-content-col {
    margin-bottom: -120px !important;
  }
   .founders-hero{
    margin-bottom: -130px !important;
   }
  .founder-name {
    font-size: 2rem;
  }

  .founder-title {
    font-size: 1.2rem;
  }

  /* Contact - Stack Vertically */
  .contact-columns {
    flex-direction: column;
    gap: 40px;
    padding: 20px;
  }

  .map-placeholder {
    min-height: 300px;
  }
}

@media (max-width: 480px) {

  .founders-heading,
  .contact-heading {
    font-size: 2.2rem;
  }

  .founder-main-photo {
    max-width: 100%;
  }

  .founder-sub-photos {
    max-width: 100%;
  }

  .projects-grid {
    grid-template-columns: 1fr !important;
  }
}

/* --- Additional Responsive Typography --- */

.projects-heading {
  font-family: var(--font-heading);
  font-size: 2.2rem;
  color: #C700FF;
  font-style: italic;
  text-decoration: underline;
  text-decoration-color: var(--text-white);
  text-decoration-thickness: 1px;
  text-align: center;
  margin-bottom: 40px;
}

@media (max-width: 768px) {

  .projects-heading,
  .section-heading {
    font-size: 2.2rem !important;
    margin-bottom: 30px;
  }

  .bts-subheading {
    font-size: 1.8rem !important;
  }
}

@media (max-width: 480px) {

  .projects-heading,
  .section-heading {
    font-size: 2.2rem !important;
  }
}

/* --- UI Fixes (Refined V4) --- */

/* Fix: Project Page Category Box Spacing */
.projects-header-container {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 50px;
}

.projects-header-container .projects-heading {
  margin-bottom: 0 !important;
}

/* Removed redundant "Refined V4" map fixes which are now in the main block */

@media (max-width: 768px) {
  /* Targeted Fix: Aggressively Force Map to edge-to-edge on mobile */

  /* Reset parent containers */
  .contact-hero,
  .contact-content,
  .contact-columns {
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .contact-columns {
    display: flex;
    flex-direction: column;
    gap: 0 !important;
  }

  /* Map Column - Explicit Height V7 */
  .contact-map-column {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
    height: 400px !important;
    /* Fixed height */
    min-height: 400px !important;
    flex: none !important;
  }

  /* Map Placeholder - Explicit Height V7 */
  .map-placeholder {
    width: 100% !important;
    height: 400px !important;
    /* Fixed height match */
    min-height: 400px !important;
    border-radius: 12px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Iframe - Explicit Height V7 */
  .map-placeholder iframe {
    width: 100% !important;
    height: 400px !important;
    /* Force iframe height */
    display: block !important;
  }

  /* Re-add padding ONLY to the form column below */
  .contact-form-column {
    padding: 0 20px 30px 20px !important;
    /* Zero top padding */
  }

.load{

  display: flex;
  justify-content: center;   /* horizontal */
  align-items: center;       /* vertical */
  height: 100vh; 
}

  
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2DAA2D;EAC3D,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,uBAAuB,IAAI,eAAe;EAC1C,mBAAmB,QAAQ,aAAa;EACxC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE;;;;;;;;;;;IAWE,4CAA4C;IAC5C,uCAAuC;IACvC,yBAAyB;EAC3B;AACF;;AAEA,kCAAkC;AAClC;EACE;;;;;;;;;;;IAWE,4CAA4C;IAC5C,kCAAkC;IAClC,yBAAyB;EAC3B;AACF;;;;;AAKA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;EACjC,4CAA4C;EAC5C,6BAA6B;EAC7B,8BAA8B;EAC9B,mCAAmC;EACnC,kFAAkF;EAClF,uDAAuD;EACvD,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA,gEAAgE;AAChE;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;;EAME,kBAAkB;EAClB,qBAAqB;EACrB,4CAA4C;EAC5C,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qCAAqC;EACrC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB;;;;;;uBAMqB;EACrB,qDAAqD;EACrD,uCAAuC;EACvC,wBAAwB;EACxB,UAAU;EACV,+BAA+B;EAC/B,gFAAgF;AAClF;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,gDAAgD;EAChD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE;IACE,cAAc;EAChB;AACF;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,uDAAuD;AACvD;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;;EAEE,0DAA0D;EAC1D;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oDAAoD;EACpD,+DAA+D;AACjE;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,qCAAqC;EACvC;AACF;;AAEA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,mDAAmD;EACnD,0CAA0C;EAC1C,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,gBAAgB;IAChB,2CAA2C;IAC3C,8CAA8C;IAC9C,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,SAAS;EACX;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,kEAAkE;EAClE,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;EACd,4CAA4C;EAC5C,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,6BAA6B;EAC7B,kCAAkC;AACpC;;;AAGA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;;;AAIA,wCAAwC;AACxC;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;;EAGA;IACE,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,4CAA4C;IAC5C,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B;qCACmC;EACnC,sDAAsD;;EAEtD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,eAAe;AACf;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,2BAA2B;;AAE3B,YAAY;AACZ;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;;;;AAIA,wCAAwC;AACxC;;;;GAIG;;AAEH;;;;;;;;;;;;;;;;;;;GAmBG;;AAEH;;;GAGG;;AAEH,oCAAoC;AACpC;;;;;;;;GAQG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iDAAiD;IACjD,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,2CAA2C;IAC3C,UAAU;EACZ;;EAEA;IACE,2CAA2C;IAC3C,YAAY;EACd;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B;IACE;GACD,mBAAmB;EACpB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,aAAa,EAAE,QAAQ;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,qDAAqD;EACrD,+BAA+B;EAC/B,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,mBAAmB,UAAU,oBAAoB;EACjD,YAAY;AACd;;AAEA;;;EAGE,4BAA4B;AAC9B;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,0DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,iFAAiF;EACjF,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,aAAa,EAAE,MAAM;IACrB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,aAAa,EAAE,MAAM;IACrB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,4DAA4D;EAC5D,kBAAkB;EAClB,qCAAqC;EACrC,0DAA0D;EAC1D,0CAA0C;EAC1C,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,oCAAoC;EACpC,4EAA4E;EAC5E,6BAA6B;EAC7B,sBAAsB;EACtB,iEAAiE;EACjE,YAAY;EACZ,8DAA8D;EAC9D,gFAAgF;AAClF;;AAEA,kDAAkD;AAClD;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,yDAAyD;EACzD;;;;gBAIc;EACd,UAAU;EACV,+DAA+D;EAC/D;;uCAEqC;EACrC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;;;;;AAMA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,oCAAoC;EACpC,eAAe;EACf,0DAA0D;EAC1D,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;EAClC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,gDAAgD;EAChD,uCAAuC;EACvC,yBAAyB;EACzB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,qDAAqD;EACrD,qCAAqC;EACrC,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;sDAIoD;EACpD,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,wCAAwC;EACxC,kDAAkD;EAClD,UAAU;EACV,oBAAoB;EACpB,mDAAmD;EACnD,qDAAqD;EACrD,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,iDAAiD;EACjD,wCAAwC;EACxC,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC;kEACgE;EAChE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,0EAA0E;EAC1E,wBAAwB;EACxB,2CAA2C;EAC3C,aAAa;EACb,2EAA2E;EAC3E,wCAAwC;AAC1C;;AAEA;EACE,0EAA0E;EAC1E,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;;;;;;;;iCAS+B;EAC/B,0BAA0B;EAC1B,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE;IACE,qCAAqC;IACrC,gCAAgC;IAChC,SAAS;IACT,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;;AAE1B;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,8DAA8D;EAC9D,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ,EAAE,kCAAkC;EAC5C,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB,EAAE,6BAA6B;EAClD,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE;IACE,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,kGAAkG;;AAElG,iDAAiD;AACjD;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,gDAAgD;EAChD;IACE;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;;EAGA;IACE,uBAAuB;EACzB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;;AAE/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;AAIA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,uCAAuC;EACvC,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,oDAAoD;EACpD,8BAA8B;EAC9B,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IAGrB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAElB,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4EAA4E;AAC9E;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;;;EAGE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,wCAAwC;IACxC,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,wCAAwC;IACxC,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,UAAU;EACV,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,yDAAyD;EACzD,0CAA0C;EAC1C,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE;IACE,uCAAuC;IACvC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wCAAwC;IACxC,UAAU;EACZ;;EAEA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,yDAAyD;EACzD,wBAAwB;EACxB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,0CAA0C;EAC1C,YAAY;EACZ,yDAAyD;EACzD,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yDAAyD;EACzD,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,sCAAsC;EACxC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,gEAAgE;EAChE;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA,oDAAoD;AACpD;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,yDAAyD;EACzD,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,4EAA4E;EAC5E,sBAAsB;EACtB,YAAY;EACZ,gFAAgF;AAClF;;AAEA,kDAAkD;AAClD;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX;;;;gBAIc;EACd,UAAU;EACV;;uCAEqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX;;;;gBAIc;EACd,UAAU;EACV;;uCAEqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,wCAAwC;EACxC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,uBAAuB;;;AAGvB,uBAAuB;AACvB;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iDAAiD;AACjD;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,4EAA4E;EAC5E,sBAAsB;EACtB,YAAY;EACZ,gFAAgF;AAClF;;AAEA,kDAAkD;AAClD;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX;;;;gBAIc;EACd,UAAU;EACV;;uCAEqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6CAA6C;AAC7C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,oCAAoC;AACtC;;;;AAIA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,uCAAuC;EACvC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,6BAA6B;EAC7B,wCAAwC;EACxC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;IAC7C,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;;EAEE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF;;;;;EAKE,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB,SAAS,yCAAyC;EACpE,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS,iBAAiB,iBAAiB;EAC3C,0BAA0B,GAAG,wBAAwB;;EAErD,WAAW;EACX,WAAW;;EAEX,oDAAoD;AACtD;;;AAGA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,0DAA0D;EAC1D,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yDAAwR;EACxR,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,6CAA6C;EAC7C,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uDAAuD;EACvD,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,YAAY;CACb,kBAAkB;EACjB,mBAAmB;EACnB,0DAA0D;EAC1D,gBAAgB;EAChB,iEAAiE;EACjE,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,kCAAkC;;AAElC,uBAAuB;AACvB;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA,gCAAgC;AAChC;;EAEE,kCAAkC;EAClC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,2BAA2B;EAC3B,wBAAwB;EACxB,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,qDAAqD;AACrD;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;;;AAIA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC;kEACgE;EAChE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC;kEACgE;EAChE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;;EAEE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;EACxC;kEACgE;EAChE,8BAA8B;EAC9B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,oBAAoB;IACpB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,6CAA6C;IAC7C,4BAA4B;IAC5B,yCAAyC;IACzC,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oCAAoC;IACpC,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,0CAA0C;EAC5C;;EAEA;;IAEE,8BAA8B;EAChC;AACF;;AAEA,yDAAyD;;AAEzD,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;;AAEpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyDG;;AAEH;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,SAAS;EACT,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,aAAa;EACb,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;EACA,+CAA+C;AACjD;AACA;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;;AAGA,cAAc;AACd;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE,WAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,uFAAuF;;AAEvF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;;EAEE,gCAAgC;EAChC;;IAEE,iCAAiC;IACjC,SAAS;IACT,kBAAkB;IAClB,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;GACC;IACC,gCAAgC;GACjC;EACD;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,+BAA+B;EAC/B;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;EAEE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,6CAA6C;;AAE7C;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE;;IAEE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,4BAA4B;EAC9B;AACF;;AAEA,kCAAkC;;AAElC,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6EAA6E;;AAE7E;EACE,mEAAmE;;EAEnE,4BAA4B;EAC5B;;;IAGE,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA,yCAAyC;EACzC;IACE,sBAAsB;IACtB,wBAAwB;IACxB,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA,iDAAiD;EACjD;IACE,oCAAoC;IACpC,qBAAqB;EACvB;;AAEF;;EAEE,aAAa;EACb,uBAAuB,IAAI,eAAe;EAC1C,mBAAmB,QAAQ,aAAa;EACxC,aAAa;AACf;;;AAGA","sourcesContent":["/* --- Base & Typography --- */\n:root {\n  --primary-bg: #000000;\n  --accent-purple: #C700FF;\n  --accent-gradient: linear-gradient(90deg, #C700FF, #006EFF);\n  --text-white: #FFFFFF;\n  --text-white: #FFFFFF;\n  --font-logo: '10Pixel', sans-serif;\n  --font-heading: '10Pixel', sans-serif;\n  --font-body: '10Pixel', sans-serif;\n  --font-serif: '10Pixel', sans-serif;\n  --card-bg: #1a1a1a;\n  --placeholder-bg: #333333;\n  --heading-underline-gap: 0.25em;\n  --heading-underline-width: min(20ch, 80%);\n  --heading-underline-thickness: 6px;\n}\n\n.load{\n\n  display: flex; \n  justify-content: center;   /* horizontal */\n  align-items: center;       /* vertical */\n  height: 100vh; \n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  text-rendering: optimizeLegibility;\n}\n\n@supports (-webkit-touch-callout: none) {\n  body,\n  p,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  .hero h1,\n  .hero-heading,\n  .hero p {\n    -webkit-font-smoothing: subpixel-antialiased;\n    -webkit-text-stroke: 0.01em transparent;\n    color: #FFFFFF !important;\n  }\n}\n\n/* Android Chrome specific fixes */\n@media screen and (-webkit-min-device-pixel-ratio: 1) {\n  body,\n  p,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  .hero h1,\n  .hero-heading,\n  .hero p {\n    -webkit-font-smoothing: subpixel-antialiased;\n    text-rendering: optimizeLegibility;\n    color: #FFFFFF !important;\n  }\n}\n\n\n\n\nbody {\n  margin: 0;\n  font-family: var(--font-body);\n  font-weight: 400;\n  /* Regular weight for body text */\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  -webkit-text-size-adjust: 100%;\n  background-color: var(--primary-bg);\n  background: radial-gradient(circle at center, #C700FF15 0%, var(--primary-bg) 70%);\n  /* box-shadow: inset 0 0 50px rgba(199, 0, 255, 0.2); */\n  color: #FFFFFF;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-text-stroke: 0.01em transparent;\n}\n\n/* Ensure layout scales nicely on small mobile / iOS viewports */\nhtml,\nbody {\n  width: 100%;\n  max-width: 100%;\n}\n\nimg,\nvideo,\ncanvas {\n  max-width: 100%;\n  height: auto;\n}\n\nbody.no-scroll {\n  overflow-y: hidden;\n  /* Prevent vertical scrolling during fixed section */\n}\n\n:where(h1, h2, h3) {\n  font-family: var(--font-heading);\n  font-weight: 400;\n  /* Bolder headings */\n  font-style: italic;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  position: relative;\n  display: inline-block;\n  padding-bottom: var(--heading-underline-gap);\n  text-decoration: none !important;\n  overflow: visible;\n}\n\n/* Advanced Underline for Page Titles (h1) */\nh1::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: var(--heading-underline-width);\n  height: 2px;\n  /* Sleek and thin */\n  /* Sleek and thin */\n  background: linear-gradient(90deg,\n      transparent 0%,\n      rgba(199, 0, 255, 0) 10%,\n      #C700FF 40%,\n      #006EFF 60%,\n      rgba(0, 110, 255, 0) 90%,\n      transparent 100%);\n  /* Gradient from Purple (#C700FF) to Blue (#006EFF) */\n  transform: translateX(-50%) scaleX(0.5);\n  transform-origin: center;\n  opacity: 0;\n  will-change: transform, opacity;\n  animation: heading-underline-reveal 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n/* Distinct Underline for Subheadings (h2-h6) */\n:where(h2, h3, h4, h5, h6)::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 60px;\n  /* Fixed elegant width */\n  height: 2px;\n  /* Slightly visible but refined */\n  /* Slightly visible but refined */\n  background: var(--accent-gradient);\n  /* Solid accent color with slight transparency */\n  transform: translateX(-50%);\n  border-radius: 1px;\n}\n\np {\n  font-weight: 400;\n  color: #FFFFFF;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  text-rendering: optimizeLegibility;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.App {\n  text-align: center;\n  padding-top: 0;\n}\n\n/* Adjust padding for mobile */\n@media (max-width: 768px) {\n  .App {\n    padding-top: 0;\n  }\n}\n\n/* --- Logo Images --- */\n.navbar-logo-img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  animation: fadeInDown 1s ease-out 0.1s both;\n}\n\n/* Default State (Web & Mobile Other = Original Logo) */\n.logo-original {\n  display: block;\n}\n\n/* Hidden by default (Favicon) */\n.logo-favicon {\n  display: none;\n}\n\n.navbar-title {\n  display: none !important;\n}\n\n/* Mobile Adjustments */\n@media (max-width: 768px) {\n\n  /* Mobile Home: Show Favicon, Hide Original, Hide Toggle */\n  .navbar.page-home .logo-favicon {\n    display: block !important;\n  }\n\n  .navbar.page-home .logo-original {\n    display: none !important;\n  }\n\n  .mobile-home-hidden {\n    display: none !important;\n  }\n}\n\n.hero-logo-img {\n  height: 100px;\n  margin-bottom: 20px;\n  filter: drop-shadow(0 0 15px rgba(199, 0, 255, 0.8));\n  animation: glow 2s infinite ease-in-out, fadeInDown 1s ease-out;\n}\n\n@keyframes glow {\n  0% {\n    filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.7));\n  }\n\n  50% {\n    filter: drop-shadow(0 0 25px rgba(199, 0, 255, 1));\n  }\n\n  100% {\n    filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.7));\n  }\n}\n\n/* --- Animation Keyframes --- */\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes bounceIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n  }\n\n  70% {\n    transform: scale(0.9);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.05);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes labelGlow {\n  0% {\n    text-shadow: 0 0 5px rgba(200, 0, 255, 0.5);\n  }\n\n  50% {\n    text-shadow: 0 0 15px rgba(200, 0, 255, 0.8);\n  }\n\n  100% {\n    text-shadow: 0 0 5px rgba(200, 0, 255, 0.5);\n  }\n}\n\n@keyframes heading-underline-reveal {\n  0% {\n    transform: translateX(-50%) scaleX(0.2);\n    opacity: 0;\n  }\n\n  45% {\n    opacity: 0.85;\n  }\n\n  100% {\n    transform: translateX(-50%) scaleX(1);\n    opacity: 1;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  :where(h1, h2, h3, h4, h5, h6)::after {\n    animation: none !important;\n    opacity: 1;\n    transform: translateX(-50%) scaleX(1);\n  }\n}\n\n.footer-logo-img {\n  height: 40px;\n  animation: fadeInUp 1s ease-out 0.1s both;\n}\n\n/* --- Container --- */\n.container {\n  width: 90%;\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 70px;\n}\n\n/* Adjust container padding for mobile */\n@media (max-width: 768px) {\n  .container {\n    padding: 70px 0;\n  }\n}\n\n/* --- Navigation Bar --- */\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 5%;\n  background-color: var(--primary-bg);\n  position: relative;\n  width: 100%;\n  border-bottom: none;\n  margin-bottom: 0;\n  z-index: 10;\n}\n\n.navbar-logo {\n  display: flex;\n  align-items: center;\n}\n\n/* New container for navbar links */\n.navbar-links-container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.navbar-links {\n  display: flex;\n  list-style: none;\n  gap: 5px;\n  /* Reduced gap since we have padding in container */\n  background-color: rgba(255, 255, 255, 0.1);\n  /* Light grey/transparent background */\n  padding: 8px 15px;\n  border-radius: 50px;\n  /* Oval shape */\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n}\n\n.navbar-links a {\n  font-weight: 400;\n  /* Regular weight for nav links */\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  padding: 8px 15px;\n  border-radius: 20px;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.navbar-links a.active,\n.navbar-links a:hover {\n  background: var(--accent-gradient);\n  color: var(--text-white);\n  font-weight: 600;\n  /* Semi-bold for active links */\n}\n\n/* Mobile menu toggle */\n.navbar-toggle {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  z-index: 11;\n  /* Ensure it's above other elements */\n  padding: 10px;\n  /* Increase padding for easier tapping */\n  margin-left: 10px;\n  /* Add some spacing */\n  background-color: transparent;\n  /* Restore original background */\n  border: none;\n  /* Remove test border */\n  align-self: center;\n  /* Center vertically */\n}\n\n.bar {\n  width: 25px;\n  height: 3px;\n  background-color: var(--text-white);\n  margin: 3px 0;\n  transition: 0.3s;\n  border-radius: 2px;\n  /* Slightly rounded bars */\n}\n\n/* Mobile menu styles */\n.navbar-menu {\n  display: flex;\n  align-items: center;\n  /* Ensure content is centered */\n  height: 100%;\n  /* Full height */\n}\n\n/* Mobile navbar links for small screens */\n.mobile-navbar-links {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background-color: var(--primary-bg);\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  z-index: 9998;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n.mobile-navbar-links.show {\n  transform: translateX(0);\n}\n\n.mobile-navbar-links a {\n  padding: 15px;\n  margin: 5px 0;\n  border-radius: 5px;\n  text-align: center;\n  font-size: 1.1rem;\n  color: white;\n  background-color: rgba(0, 0, 0, 0.5);\n  text-decoration: none;\n}\n\n.mobile-navbar-links a.active,\n.mobile-navbar-links a:hover {\n  background: var(--accent-gradient);\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .navbar-links {\n    gap: 10px;\n  }\n\n  .navbar-links a {\n    padding: 6px 12px;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    padding: 15px 5%;\n    /* Reduce padding for mobile */\n    min-height: 70px;\n    /* Adjust height for mobile as per memory */\n    background-color: var(--primary-bg) !important;\n    /* Restore original background */\n  }\n\n  .navbar-links {\n    display: none;\n    /* Hide desktop nav on mobile */\n  }\n\n  .navbar-toggle {\n    display: flex !important;\n    position: relative;\n  }\n\n  /* Mobile navbar links positioning */\n  .mobile-navbar-links {\n    top: 100%;\n  }\n}\n\n/* --- Hero Section --- */\n.hero {\n  min-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: 35%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, #C700FF60 0%, transparent 70%);\n  border-radius: 50%;\n  z-index: -1;\n  animation: pulse 3s infinite ease-in-out;\n}\n\n.hero-logo {\n  display: flex;\n  align-items: center;\n}\n\n.hero h1 {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n  max-width: 600px;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  color: #FFFFFF;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  text-rendering: optimizeLegibility;\n}\n\n.hero-heading {\n  font-family: var(--font-serif);\n  font-size: 1.8rem;\n  font-weight: 400;\n  font-style: italic;\n  margin-bottom: 15px;\n  max-width: 600px;\n  animation: fadeInDown 1s ease-out 0.3s both;\n  color: #FFFFFF;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  text-rendering: optimizeLegibility;\n}\n\n.highlight-text {\n  color: #C700FF;\n  /* Bright purple color */\n  font-weight: 600;\n  /* Slightly bolder for emphasis */\n}\n\n.hero p {\n  font-size: 1rem;\n  max-width: 550px;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  color: #FFFFFF;\n  -webkit-font-smoothing: subpixel-antialiased;\n  -moz-osx-font-smoothing: auto;\n  text-rendering: optimizeLegibility;\n}\n\n\n/* Default: desktop */\n.content-mobile {\n  display: none;\n}\n\n/* Mobile view */\n@media (max-width: 480px) {\n  .content-desktop {\n    display: none;\n  }\n\n  .content-mobile {\n    display: block;\n  }\n}\n\n\n\n/* Mobile adjustments for hero section */\n@media (max-width: 768px) {\n  .hero {\n    padding: 80px 5% 60px;\n    min-height: 70vh;\n  }\n\n  .hero h1 {\n    font-size: 2.5rem;\n    margin-bottom: 25px;\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 500;\n  }\n\n\n  .hero-heading {\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 500;\n  }\n\n  .hero p {\n    font-size: 1.1rem;\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 400;\n  }\n\n  .hero-logo-img {\n    height: 100px;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero {\n    padding: 70px 5% 50px;\n    margin-top: 3rem;\n    min-height: 60vh;\n    margin-bottom: -5rem;\n  }\n\n  .hero h1 {\n    font-size: 2.2rem;\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 500;\n  }\n\n  .hero-heading {\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 500;\n  }\n\n  .hero p {\n    font-size: 1rem;\n    color: #FFFFFF !important;\n    -webkit-font-smoothing: subpixel-antialiased;\n    -moz-osx-font-smoothing: auto;\n    text-rendering: optimizeLegibility;\n    font-weight: 400;\n  }\n\n  .hero-logo-img {\n    height: 90px;\n  }\n}\n\n/* --- Button --- */\n.btn {\n  display: inline-block;\n  padding: 12px 30px;\n  /* Gradient Border Logic */\n  border: 2px solid transparent;\n  background: linear-gradient(var(--primary-bg), var(--primary-bg)) padding-box,\n    var(--accent-gradient) border-box;\n  /* Ensure primary background covers the padding area */\n\n  color: #FFFFFF;\n  /* White text */\n  font-weight: 500;\n  /* Regular weight */\n  border-radius: 50px;\n  /* Pill-shaped */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 50px;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 20px;\n}\n\n.btn:hover {\n  background: var(--accent-gradient);\n  border-color: transparent;\n  /* Optional: hide border if full fill */\n  color: var(--text-white);\n}\n\n/* --- Section Heading --- */\n.section-heading {\n  font-family: var(--font-heading);\n  font-size: 2.2rem;\n  font-weight: 400;\n  color: #C700FF;\n  /* Bright purple as specified */\n  margin-bottom: 35px;\n  text-transform: none !important;\n  animation: fadeInUp 1s ease-out 0.2s both;\n  font-style: normal;\n}\n\n@media (max-width: 480px) {\n  #project-heading{\n    margin-bottom: 60px;\n  }\n}\n\n/* ===== Scroll Wrapper ===== */\n.scrollable-grid {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.bts-gallery-heading{\n  margin-top: -20px;\n}\n\n\n@media (max-width: 480px) {\n  #bts-btn{\n    margin-top: -20px;\n  }\n}\n\n/* ===== Auto-scrolling Track ===== */\n.placeholder-grid {\n  display: flex;\n  gap: 35px;\n  width: max-content;\n  padding: 20px 0;\n}\n\n.continue:hover {\n  animation-play-state: running !important;\n}\n\n/* Auto-scroll animation */\n.autoscroll {\n  animation: reel-scroll 40s linear infinite;;\n}\n\n/* Pause on hover */\n.scrollable-grid:hover .autoscroll {\n  animation-play-state: paused;\n}\n\n/* ===== Individual Card ===== */\n.placeholder-card {\n  position: relative;\n  display: flex ;\n  justify-content: center;\n  align-items: center;\n  width: 260px;\n  height: 460px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #000;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);\n  transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\n/* Hover lift */\n.placeholder-card:hover {\n  transform: translateY(-6px) scale(1.03);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);\n}\n\n/* ===== Iframe Video ===== */\n.placeholder-card iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  object-fit: cover;\n  border-radius: 14px;\n  background: #000;\n}\n\n/* Disable iframe focus outline */\n.placeholder-card iframe:focus {\n  outline: none;\n}\n\n/* ===== Gradient Overlay (Cinematic edge) ===== */\n.placeholder-card::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.55),\n    rgba(0, 0, 0, 0.15) 40%,\n    rgba(0, 0, 0, 0)\n  );\n  pointer-events: none;\n}\n\n/* ===== Scroll Animation ===== */\n@keyframes reel-scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* ===== Responsive ===== */\n\n/* Tablets */\n@media (max-width: 1024px) {\n  .placeholder-card {\n    width: 220px;\n    height: 400px;\n  }\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .placeholder-grid {\n    gap: 16px;\n  }\n\n  .placeholder-card {\n    width: 180px;\n    height: 320px;\n    border-radius: 12px;\n  }\n}\n\n/* Small phones */\n@media (max-width: 480px) {\n  .placeholder-card {\n    width: 200px;\n    height: 270px;\n  }\n}\n\n\n\n/* --- Trailers & BTS Placeholders --- */\n/* .placeholder-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n} */\n\n/* .placeholder-card {\n  background-color: transparent;\n  /* Fixed: transparent video background *\n  border-radius: 15px;\n  height: 350px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-white);\n  font-weight: 500;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  min-width: auto;\n  flex-shrink: 0;\n  box-shadow: none !important;\n  /* Fixed: No shadow *\n  border: none;\n  position: relative;\n} */\n\n/* .placeholder-card:hover {\n  transform: translateY(-8px);\n  /* Removed hover background and shadow to keep video clean *\n} */\n\n/* --- Scrollable Grid for BTS --- */\n/* .scrollable-grid {\n  position: relative;\n  width: 100%;\n  max-width: 100vw;\n  overflow: hidden;\n  padding-bottom: 20px;\n  /* Space for visual balance *\n  margin: 0 auto;\n} */\n\n/* --- Autoscroll Animation ---\n.autoscroll {\n  width: max-content;\n  min-width: 100%;\n  animation: scroll 80s linear infinite;\n  /* Slower speed: 40s -> 80s *\n  scrollbar-width: none;\n  /* Firefox *\n  display: flex;\n  gap: 30px;\n  will-change: transform;\n  flex-wrap: nowrap;\n} */\n\n/* .autoscroll:hover {\n  animation-play-state: paused;\n} */\n\n.autoscroll::-webkit-scrollbar {\n  display: none;\n  /* Safari and Chrome */\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    /* Move left by 50% (width of one set of items) */\n    transform: translateX(-50%);\n  }\n}\n\n@keyframes pulse {\n  0% {\n    transform: translate(-50%, -50%) scale(0.9);\n    opacity: 0.8;\n  }\n\n  50% {\n    transform: translate(-50%, -50%) scale(1.1);\n    opacity: 1;\n  }\n\n  100% {\n    transform: translate(-50%, -50%) scale(0.9);\n    opacity: 0.8;\n  }\n}\n\n/* Mobile adjustments for scrollable grids */\n@media (max-width: 768px) {\n  .scrollable-grid {\n    padding-bottom: 25px;\n  }\n\n  .autoscroll {\n    animation-duration: 60s;\n    gap: 25px;\n  }\n\n  .placeholder-card {\n    min-width: auto;\n    height: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n  .scrollable-grid {\n    padding-bottom: 20px;\n  }\n\n  .autoscroll {\n    animation-duration: 50s;\n    gap: 20px;\n  }\n\n  .placeholder-card {\n    min-width: auto;\n    height: 260px;\n  }\n}\n\n/* --- Services Section --- */\n.services-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 10px;\n  /* Reduced further to bring cards closer */\n  justify-content: center;\n}\n\n.services-labels {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 0px;\n  /* Reduced further to bring labels closer */\n  justify-content: center;\n  margin-top: 15px;\n  justify-items: center;\n}\n\n.services-labels>.service-label {\n  margin: 15px auto;\n  text-align: center;\n}\n\n.service-pair {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  /* Reduced further to bring cards and labels closer */\n}\n\n.service-card {\n  background-color: transparent;\n  /* Removed background */\n  border: none;\n  /* Removed purple border */\n  border-radius: 15px;\n  transition: all 0.3s ease;\n  box-shadow: none;\n  /* Removed box shadow */\n  overflow: hidden;\n  width: fit-content;\n  /* Fit to content size */\n  height: fit-content;\n  /* Fit to content size */\n  margin: 0 auto;\n  /* Center the card */\n}\n\n.service-card-link {\n  text-decoration: none;\n  display: block;\n  width: fit-content;\n  /* Fit to content size */\n  height: fit-content;\n  /* Fit to content size */\n  cursor: pointer;\n  /* Show pointer cursor */\n  transition: transform 0.3s ease;\n  /* margin: 0 auto;\n   */\n   margin-bottom: 20px;\n  /* Center the link */\n}\n\n.service-card-link:hover {\n  transform: translateY(-5px);\n  /* Add hover effect */\n}\n\n/* Removed hover effect as per requirements */\n\n.service-image-container {\n  position: relative;\n  width: fit-content;\n  /* Fit to image size */\n  height: fit-content;\n  /* Fit to image size */\n  overflow: hidden;\n  background-color: transparent;\n  /* Removed background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  /* Add padding to prevent images from touching edges */\n  box-sizing: border-box;\n}\n\n.service-image {\n  width: auto;\n  /* Adjust to natural image width */\n  height: 198px; /*198px*/\n  /* Increased by 10% from 180px */\n  object-fit: contain;\n  /* Changed from cover to contain to show full image */\n  transition: transform 0.3s ease;\n  background-color: transparent;\n  /* Removed background */\n  display: block;\n  border: 1px solid #FFFFFF;   \n  border-radius: 12px;         /* Rounded corners */\n  padding: 4px;\n}\n\n.service-card,\n.service-card-link,\n.service-image-container {\n  overflow: visible !important;\n}\n\n\n.service-card:hover .service-image {\n  transform: scale(1.05);\n}\n\n.service-icon {\n  color: var(--accent-purple);\n  font-size: 4rem;\n  text-align: center;\n  position: relative;\n}\n\n.camera-icon {\n  position: absolute;\n  font-size: 2rem;\n  bottom: 10px;\n  right: 10px;\n}\n\n.service-label {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: var(--text-white);\n  padding: 8px 20px;\n  border-radius: 20px;\n  border: 1px solid var(--accent-purple);\n  font-family: var(--font-body);\n  /* font-family: Arial, Helvetica, sans-serif !important; */\n  font-weight: 500;\n  /* Medium weight */\n  text-transform: uppercase;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  /* Removed absolute positioning to ensure labels appear in normal document flow */\n  position: relative;\n  bottom: auto;\n  left: auto;\n  transform: none;\n  margin: 15px auto;\n  text-align: center;\n  display: inline-block;\n}\n\n.service-label-link {\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.service-label-link:hover {\n  text-decoration: none;\n}\n\n.service-card h3 {\n  display: none;\n  /* Hide the old text elements */\n}\n\n/* Responsive adjustments for Services section */\n@media (max-width: 768px) {\n  .services-container {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    /* Reduced further to bring cards closer */\n  }\n\n  .service-pair {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n  }\n\n  .services-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .services-labels {\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .service-card {\n    height: fit-content;\n    /* Fit to content size */\n    width: fit-content;\n    /* Fit to content size */\n  }\n\n  .service-card-link {\n    height: fit-content;\n    /* Fit to content size */\n    width: fit-content;\n    /* Fit to content size */\n  }\n\n  .service-image {\n    height: 188px; /*158*/\n    /* Increased by 10% from 144px */\n  }\n\n  .service-label {\n    font-size: 0.9rem;\n    padding: 6px 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .service-card {\n    height: fit-content;\n    /* Fit to content size */\n    width: fit-content;\n    /* Fit to content size */\n  }\n\n  .service-card-link {\n    height: fit-content;\n    /* Fit to content size */\n    width: fit-content;\n    /* Fit to content size */\n  }\n\n  .service-image {\n    height: 200px; /*132*/\n    /* Increased by 10% from 120px */\n  }\n\n  .service-label {\n    font-size: 0.8rem;\n    padding: 5px 12px;\n  }\n}\n\n/* --- Projects Section --- */\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n}\n\n.project-poster {\n  border-radius: 15px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  position: relative;\n  height: 400px;\n  /* Fixed height for consistent sizing */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000;\n  border: 1px solid #FFFFFF;\n  /* Added white border as requested */\n}\n\n.project-poster:hover {\n  transform: scale(1.05);\n}\n\n.project-poster img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  /* Show full image without cropping */\n  object-position: center;\n  display: block;\n  background-color: #000;\n}\n\n/* --- Team/Profiles Section --- */\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 30px;\n}\n\n.bts-section {\n  margin: 40px 0 60px 0;\n}\n\n.bts-content {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n  /* Align content to top */\n}\n\n.bts-text-content {\n  flex: 1;\n  padding-right: 20px;\n  /* Add some padding to separate from video column */\n}\n\n.bts-visual-content {\n  flex: 1;\n}\n\n.bts-subheading {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: none;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.bts-description {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  max-width: 600px;\n}\n\n.movie-info {\n  margin-bottom: 40px;\n}\n\n.movie-info:last-child {\n  margin-bottom: 0;\n}\n\n.bts-section {\n  margin: 40px 0 60px 0;\n}\n\n.movie-item {\n  margin-bottom: 60px;\n}\n\n.movie-item:last-child {\n  margin-bottom: 0;\n}\n\n.bts-visual-content {\n  flex: 1;\n}\n\n.film-strip {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  /* Consistent spacing with text content */\n}\n\n.film-frame-container {\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n  /* Film strip frame that completely covers the video block */\n  padding: 20px 30px;\n  /* Space for the film strip borders */\n  /* Add a subtle shadow to make it look more like a frame */\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  /* Ensure proper box sizing */\n  box-sizing: border-box;\n  border-radius: 15px;\n}\n\n.film-strip-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  /* Dark charcoal grey with subtle texture */\n  background: #1a1a1a;\n  border-radius: 15px;\n  z-index: 1;\n  /* Subtle grain texture simulation */\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);\n  /* Ensure proper box sizing */\n  box-sizing: border-box;\n  /* Film strip frame that completely encompasses the video block */\n  border: none;\n  /* Add a subtle inner glow to make it look more like a frame */\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);\n}\n\n/* Film strip frame with black and white borders */\n.film-strip-overlay::before,\n.film-strip-overlay::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25px;\n  /* Wider to create a proper frame */\n  /* Black and white stripes forming the film strip frame */\n  background: repeating-linear-gradient(to bottom,\n      #000 0px,\n      #000 15px,\n      #fff 15px,\n      #fff 30px);\n  z-index: 2;\n  /* Add 3D effect to make it look like a real film strip frame */\n  box-shadow:\n    inset 1px 0 3px rgba(255, 255, 255, 0.4),\n    inset -1px 0 3px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333;\n  /* Subtle border to define the frame */\n}\n\n.film-strip-overlay::before {\n  left: 15px;\n  /* Positioned to create the left frame */\n}\n\n.film-strip-overlay::after {\n  right: 15px;\n  /* Positioned to create the right frame */\n}\n\n\n\n\n\n.film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  /* Match the inner frame */\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  z-index: 4;\n  /* Ensure content is above overlay */\n  cursor: pointer;\n  /* Style to make it look like it's inside the film frame */\n  background: #000;\n  /* Black background for video */\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  /* Shadow to separate from frame */\n  width: 100%;\n  height: 100%;\n}\n\n.video-block-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  /* Video content inside the film frame */\n  border-radius: 10px;\n  /* Match the film-frame-content radius */\n  overflow: hidden;\n  /* Style to make it look embedded in the frame */\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  /* Shadow to give depth */\n  /* Ensure proper sizing within the frame */\n  box-sizing: border-box;\n}\n\n.video-block-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 10px;\n  /* Match the container radius */\n  /* Style to make it look embedded in the film frame */\n  filter: contrast(1.05) saturate(1.05);\n  /* Slight enhancement */\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);\n  /* Inner shadow for depth */\n  background-color: #000;\n}\n\n/* Removed hover effect */\n.film-frame-content:hover {\n  transform: none;\n}\n\n.checkerboard-pattern {\n  width: 100%;\n  height: 100%;\n  background-image:\n    linear-gradient(45deg, #444 25%, transparent 25%),\n    linear-gradient(-45deg, #444 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #444 75%),\n    linear-gradient(-45deg, transparent 75%, #444 75%);\n  background-size: 20px 20px;\n  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;\n}\n\n.play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  /* Size for good visibility */\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  /* Removed transition to eliminate hover effects */\n  z-index: 3;\n  pointer-events: none;\n  /* Allow clicks to pass through to video controls */\n  /* Style to make it look embedded in the film frame */\n  background: rgba(0, 0, 0, 0.4);\n  /* Darker background for contrast */\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Center the icon perfectly */\n  line-height: 1;\n  /* Add a subtle border to match the frame style */\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  /* Shadow for depth */\n}\n\n/* Removed hover effect on play overlay */\n.film-frame-content:hover .play-overlay {\n  color: rgba(200, 0, 255, 0.8);\n  transform: translate(-50%, -50%);\n}\n\n/* Original video container styles - kept for backward compatibility */\n.video-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.video-player-container {\n  width: 100%;\n  border-radius: 15px;\n  overflow: hidden;\n  margin-bottom: 30px;\n  border: 15px solid #333;\n  /* Rim-like border */\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.video-player {\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.video-player video {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.video-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.video-description {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.bts-tabs {\n  display: flex;\n  justify-content: center;\n  margin: 30px 0 40px 0;\n  gap: 15px;\n}\n\n.tab-button {\n  padding: 12px 30px;\n  border: 2px solid transparent !important;\n  background: linear-gradient(#000, #000) padding-box,\n    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  color: #FFFFFF;\n  font-weight: 500;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  outline: none;\n}\n\n.tab-button:hover,\n.tab-button:focus {\n  background: linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  color: var(--text-white);\n  box-shadow: 0 0 10px rgba(199, 0, 255, 0.5);\n  outline: none;\n  /* Ensure border is transparent to maintain size but background covers it */\n  border: 2px solid transparent !important;\n}\n\n.tab-button.active {\n  background: linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  color: var(--text-white);\n  border: 2px solid transparent !important;\n}\n\n.team-card-link {\n  text-decoration: none;\n}\n\n.team-card {\n  background-color: var(--card-bg);\n  border: 2px solid var(--accent-purple);\n  border-radius: 15px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  transition: all 0.3s ease;\n}\n\n.team-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 0 20px 3px rgba(199, 0, 255, 0.2);\n}\n\n.team-card-img-placeholder {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  /* Makes it a square */\n  background-color: var(--placeholder-bg);\n  border-radius: 10px;\n}\n\n.team-card p {\n  color: var(--text-white);\n  font-weight: 600;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n/* --- Footer --- */\n.footer {\n  background-color: #240046;\n  /* Deep purple - matches logo color */\n  padding: 30px 5%;\n  z-index: 100;\n  position: relative;\n  margin-top: 50px;\n  /* Add margin to ensure proper spacing */\n}\n\n.footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.footer-column {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  /* Increased gap for better spacing */\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.footer-logo-img {\n  height: 30px;\n  filter: grayscale(100%) brightness(200%);\n  /* Monochrome version of the logo */\n}\n\n.social-icons {\n  display: flex;\n  gap: 15px;\n}\n\n.social-icons a {\n  width: 30px;\n  height: 30px;\n  border-radius: 6px;\n  /* Soft-cornered squares */\n  background-color: #333;\n  /* Light grey/off-white fill */\n  color: var(--text-white);\n  /* Light grey/off-white icon color */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.social-icons a:hover {\n  background-color: var(--accent-purple);\n  color: var(--text-white);\n}\n\n.footer-column h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  /* Medium/bold weight */\n  margin-bottom: 10px;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  color: #FFFFFF;\n  /* White text for violet background */\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.footer-links a {\n  color: #FFFFFF;\n  /* Light grey for links on violet */\n  transition: color 0.3s ease;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  text-transform: capitalize;\n  /* Sentence case (only first letter capitalized) */\n  font-size: 0.85rem;\n}\n\n.footer-links a:hover {\n  color: #FFFFFF;\n  /* White on hover */\n}\n\n.footer-description {\n  color: #FFFFFF;\n  /* Light grey text for violet background */\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  font-size: 0.85rem;\n  /* Smaller size */\n  line-height: 1.4;\n  max-width: 300px;\n}\n\n.copyright {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  /* Light border for violet */\n  padding-top: 15px;\n  margin-top: 15px;\n  font-size: 0.8rem;\n  /* Smallest size */\n  color: #FFFFFF;\n  /* Light grey for violet background */\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  text-align: center;\n  /* Centered text */\n}\n\n/* Mobile adjustments for footer */\n@media (max-width: 768px) {\n  .footer {\n    padding: 40px 5%;\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n\n  .footer-column h4 {\n    font-size: 1.2rem;\n    margin-bottom: 15px;\n  }\n\n  .footer-links a {\n    font-size: 0.9rem;\n  }\n\n  .footer-description {\n    font-size: 0.85rem;\n  }\n\n  .social-icons {\n    gap: 12px;\n  }\n\n  .social-icons a {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n\n  .copyright {\n    font-size: 0.75rem;\n    padding-top: 15px;\n    margin-top: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer {\n    padding: 30px 5%;\n  }\n\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 25px;\n  }\n\n  .footer-column h4 {\n    font-size: 1.1rem;\n    margin-bottom: 12px;\n  }\n\n  .footer-links a {\n    font-size: 0.85rem;\n  }\n\n  .footer-description {\n    font-size: 0.8rem;\n  }\n\n  .social-icons {\n    gap: 10px;\n    justify-content: center;\n  }\n\n  .social-icons a {\n    width: 30px;\n    height: 30px;\n    font-size: 0.9rem;\n  }\n\n  .copyright {\n    font-size: 0.7rem;\n    padding-top: 12px;\n    margin-top: 12px;\n  }\n}\n\n/* --- What We Do Page --- */\n.what-we-do-main {\n  background-color: #000000;\n  /* Solid black background */\n  min-height: calc(100vh - 80px);\n}\n\n.what-we-do-hero {\n  padding: 60px 5%;\n  text-align: center;\n}\n\n.what-we-do-heading {\n  font-family: var(--font-heading);\n  /* Decorative serif font */\n  font-size: 2.2rem;\n  font-weight: 400;\n  color: #8A00C2;\n  /* Bright purple */\n  margin-bottom: 60px;\n  text-transform: none !important;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n  font-style: normal !important;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  /* 3 columns */\n  gap: 20px;\n  /* Reduce gap */\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.service-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n}\n\n.service-container-link {\n  text-decoration: none;\n  color: inherit;\n  transition: transform 0.3s ease;\n  display: block;\n  height: 100%;\n}\n\n.service-container-link:hover {\n  transform: translateY(-5px);\n}\n\n.service-container-link .service-card {\n  cursor: pointer;\n}\n\n/* Admin Panel Styles */\n.admin-panel {\n  background-color: var(--primary-bg);\n  color: var(--text-white);\n  min-height: calc(100vh - 80px);\n  padding: 20px;\n}\n\n.admin-header {\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 20px 0;\n  border-bottom: 1px solid var(--accent-purple);\n}\n\n.admin-title {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #FFFFFF;\n  margin: 0;\n  font-style: italic;\n  text-decoration: underline;\n  text-transform: none !important;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.admin-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 30px;\n  justify-content: center;\n}\n\n.admin-tab-button {\n  padding: 12px 25px;\n  border: 2px solid var(--accent-purple);\n  background-color: transparent;\n  color: var(--accent-purple);\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.admin-tab-button:hover,\n.admin-tab-button.active {\n  background-color: var(--accent-purple);\n  color: var(--text-white);\n}\n\n.admin-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.admin-section h2 {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 400;\n  color: #FFFFFF;\n  margin-bottom: 20px;\n  text-align: center;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.admin-form-container {\n  background-color: var(--card-bg);\n  border-radius: 15px;\n  padding: 25px;\n  margin-bottom: 30px;\n  border: 1px solid var(--accent-purple);\n}\n\n.admin-form h3 {\n  font-family: var(--font-heading);\n  font-weight: 400;\n  color: var(--accent-purple);\n  margin-bottom: 20px;\n  text-align: center;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0px;\n  font-weight: 500;\n  color: var(--text-white);\n}\n\n.form-input,\n.form-textarea {\n  width: 100%;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #444;\n  background-color: #333;\n  color: var(--text-white);\n  font-family: var(--font-body);\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.form-textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.submit-btn {\n  display: inline-block;\n  padding: 12px 30px;\n  border: 2px solid #FFFFFF;\n  background-color: transparent;\n  color: #FFFFFF;\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  width: 100%;\n  font-size: 1rem;\n}\n\n.submit-btn:hover {\n  background-color: var(--accent-purple);\n  color: var(--text-white);\n}\n\n.delete-btn {\n  padding: 8px 15px;\n  border: 2px solid #ff3333;\n  background-color: transparent;\n  color: #FFFFFF;\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.delete-btn:hover {\n  background-color: #ff3333;\n  color: var(--text-white);\n}\n\n.admin-items-list h3 {\n  font-family: var(--font-heading);\n  font-weight: 400;\n  color: var(--accent-purple);\n  margin: 30px 0 20px 0;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.admin-item {\n  background-color: var(--card-bg);\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 20px;\n  border: 1px solid #444;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.admin-item-content {\n  flex: 1;\n}\n\n.admin-item-content h4 {\n  font-family: var(--font-heading);\n  color: var(--accent-purple);\n  margin-bottom: 10px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.admin-item-content p {\n  color: var(--text-white);\n  margin-bottom: 10px;\n  line-height: 1.5;\n}\n\n.item-link,\n.item-email,\n.item-date,\n.item-message {\n  font-size: 0.9rem;\n}\n\n.admin-item-image {\n  max-width: 200px;\n  border-radius: 10px;\n  margin-top: 10px;\n}\n\n.admin-item-video {\n  max-width: 300px;\n  margin-top: 10px;\n  border-radius: 10px;\n}\n\n/* Responsive adjustments for Admin Panel */\n@media (max-width: 768px) {\n  .admin-panel {\n    padding: 15px;\n  }\n\n  .admin-title {\n    font-size: 2rem;\n  }\n\n  .admin-tabs {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .admin-tab-button {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .admin-item {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .admin-item-image,\n  .admin-item-video {\n    max-width: 100%;\n  }\n}\n\n.service-container-link:hover {\n  transform: translateY(-5px);\n}\n\n.service-container-link .service-label {\n  background-color: rgba(0, 0, 0, 0.7);\n  color: var(--text-white);\n  padding: 8px 20px;\n  border-radius: 20px;\n  border: 1px solid var(--accent-purple);\n  font-family: var(--font-body);\n  font-weight: 500;\n  text-transform: uppercase;\n  white-space: nowrap;\n  letter-spacing: 0.5px;\n  position: relative;\n  margin: 15px auto 0;\n  text-align: center;\n  display: block;\n  width: fit-content;\n}\n\n.service-card {\n  background-color: transparent;\n  /* Remove dark grey outer container */\n  border: none;\n  /* Remove border */\n  border-radius: 15px;\n  /* Keep rounded corners */\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.service-illustration {\n  width: 100%;\n  height: 150px;\n  /* Reduce height */\n  background-color: transparent;\n  /* Remove darker grey background */\n  border-radius: 15px;\n  /* Keep rounded corners */\n  margin-bottom: 0;\n  /* Remove margin */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  /* Prevent illustration from shrinking */\n}\n\n.service-placeholder {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  /* Remove grey background */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #C700FF;\n  position: relative;\n  overflow: hidden;\n}\n\n.service-placeholder::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(45deg,\n      rgba(199, 0, 255, 0.1) 25%,\n      transparent 25%,\n      transparent 75%,\n      rgba(199, 0, 255, 0.1) 75%),\n    linear-gradient(45deg,\n      rgba(199, 0, 255, 0.1) 25%,\n      transparent 25%,\n      transparent 75%,\n      rgba(199, 0, 255, 0.1) 75%);\n  background-size: 20px 20px;\n  background-position: 0 0, 10px 10px;\n  z-index: 1;\n}\n\n.placeholder-text {\n  position: relative;\n  z-index: 2;\n  text-align: center;\n  padding: 20px;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 10px;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n\n.placeholder-icon {\n  position: relative;\n  z-index: 2;\n  font-size: 3rem;\n  margin-bottom: 20px;\n  color: #C700FF;\n}\n\n.placeholder-icon .camera-icon {\n  position: absolute;\n  font-size: 1.5rem;\n  bottom: -5px;\n  right: -10px;\n}\n\n.service-placeholder {\n  color: #FFFFFF;\n  /* White text */\n  font-family: var(--font-body);\n  font-size: 1rem;\n}\n\n.service-label {\n  display: none;\n  /* Hide the service label */\n}\n\n.service-description {\n  color: #CCCCCC;\n  /* Light grey text */\n  font-family: var(--font-body);\n  font-weight: 400;\n  text-align: center;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-top: auto;\n  /* Push description to bottom of card */\n  margin-bottom: 0;\n}\n\n.what-we-do-footer {\n  background-color: #240046;\n  /* Deep purple - matches logo color */\n  padding: 60px 5%;\n  margin-top: 60px;\n}\n\n.what-we-do-footer .footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 40px;\n  text-align: left;\n  margin-bottom: 40px;\n}\n\n.what-we-do-footer .footer-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.what-we-do-footer .footer-logo {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.what-we-do-footer .footer-logo-img {\n  height: 40px;\n}\n\n.what-we-do-footer .social-icons {\n  display: flex;\n  gap: 15px;\n}\n\n.what-we-do-footer .social-icons a {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  /* Soft-cornered squares */\n  background-color: transparent;\n  /* Transparent background */\n  color: #FFFFFF;\n  /* White outline-style icons */\n  border: 1px solid #FFFFFF;\n  /* White border */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.what-we-do-footer .social-icons a:hover {\n  background-color: #8A00C2;\n  /* Purple fill on hover */\n  border-color: #8A00C2;\n  /* Purple border on hover */\n}\n\n.what-we-do-footer .footer-column h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  font-family: var(--font-body);\n  /* Sans-serif font */\n  color: #FFFFFF;\n  /* White heading */\n}\n\n.what-we-do-footer .footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.what-we-do-footer .footer-links a {\n  color: #E0E0E0;\n  /* Light grey for links on violet */\n  font-family: var(--font-body);\n  /* Sans-serif font */\n  font-weight: 400;\n  /* Regular weight */\n  text-decoration: none;\n}\n\n.what-we-do-footer .footer-links a:hover {\n  color: #FFFFFF;\n  /* White on hover */\n}\n\n.what-we-do-footer .footer-description {\n  color: #E0E0E0;\n  /* Light grey text for violet background */\n  font-family: var(--font-body);\n  /* Sans-serif font */\n  font-weight: 400;\n  /* Regular weight */\n  font-size: 0.9rem;\n  line-height: 1.5;\n  max-width: 300px;\n}\n\n.what-we-do-footer .copyright {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  /* Light border for violet */\n  padding-top: 20px;\n  margin-top: 20px;\n  font-size: 0.8rem;\n  color: #E0E0E0;\n  /* Light grey for violet background */\n  font-family: var(--font-body);\n  /* Sans-serif font */\n  font-weight: 400;\n  /* Regular weight */\n  text-align: center;\n  /* Centered text */\n}\n\n/* Responsive adjustments for What We Do page */\n@media (max-width: 992px) {\n  .services-grid {\n    grid-template-columns: repeat(2, 1fr);\n    /* 2 columns on medium screens */\n    gap: 25px;\n    /* Reduce gap on medium screens */\n  }\n}\n\n@media (max-width: 768px) {\n  .services-grid {\n    grid-template-columns: 1fr;\n    /* 1 column on small screens */\n    gap: 15px;\n    /* Reduce gap on small screens */\n  }\n\n  .navbar .navbar-links {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .what-we-do-footer .footer-grid {\n    text-align: center;\n  }\n\n  .what-we-do-footer .footer-column {\n    align-items: center;\n  }\n\n  .what-we-do-footer .copyright {\n    text-align: center;\n  }\n}\n\n/* --- Projects Page --- */\n\n@media (max-width: 480px) {\n  #project{\n    margin-top: 0;\n  }\n}\n.projects-header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  background-color: #000000;\n  /* Solid black background */\n  z-index: 1000;\n  border-bottom: 1px solid #222;\n}\n\n.projects-main {\n  background-color: #000000;\n  /* Solid black background */\n  min-height: calc(100vh - 80px);\n  padding: 24px 0 60px;\n  position: relative;\n  z-index: 1;\n  margin-top: 60px;\n  /* Account for fixed header */\n  /* overflow: hidden; Removed to allow dropdown to be visible */\n  will-change: transform;\n  /* Enable hardware acceleration */\n}\n\n.projects-hero {\n  padding: 0 5%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.projects-header-container {\n  position: relative;\n  margin-bottom: 24px;\n  z-index: 1000;\n  text-align: center;\n}\n\n.category-filter {\n  position: absolute;\n  display: inline-block;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1003;\n  /* Ensure it's above other elements */\n}\n\n.category-dropdown {\n  background: transparent;\n  border: 1px solid #FFFFFF;\n  border-radius: 4px;\n  color: #FFFFFF;\n  padding: 6px 10px;\n  font-family: var(--font-body);\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  cursor: pointer;\n  min-width: 120px;\n  justify-content: space-between;\n  font-size: 12px;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  transition: transform 0.3s ease;\n}\n\n.category-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: #000000;\n  border: 1px solid #C700FF;\n  border-radius: 4px;\n  margin-top: 3px;\n  z-index: 1004;\n  /* Increased z-index to ensure visibility */\n  max-height: 150px;\n  overflow-y: auto;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  min-width: 120px;\n  width: auto;\n}\n\n.category-dropdown-item {\n  padding: 8px 12px;\n  color: #FFFFFF;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border-bottom: 1px solid #333;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.category-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.category-dropdown-item:hover {\n  background: rgba(199, 0, 255, 0.2);\n  color: #C700FF;\n}\n\n/* --- Projects Section --- */\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 24px;\n}\n\n.project-poster {\n  border-radius: 15px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  position: relative;\n  height: 360px;\n  /* Fixed height for consistent sizing */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #000;\n}\n\n.project-poster:hover {\n  transform: scale(1.05);\n}\n\n.project-poster img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  /* Show full image without cropping */\n  object-position: center;\n  display: block;\n  background-color: #000;\n}\n\n/* Project overlay and options */\n.project-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  border-radius: 15px;\n}\n\n.project-poster:hover .project-overlay {\n  opacity: 1;\n}\n\n.project-options {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 80%;\n}\n\n.project-option-btn {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 25px;\n  font-family: var(--font-body);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1rem;\n}\n\n.bts-btn {\n  background-color: transparent;\n  border: 1px solid #FFFFFF;\n  color: white;\n}\n\n.bts-btn:hover {\n  background: var(--accent-gradient);\n  border-color: transparent;\n  transform: translateY(-2px);\n}\n\n.trailer-btn {\n  background-color: transparent;\n  border: 1px solid #FFFFFF;\n  color: white;\n}\n\n.trailer-btn:hover {\n  background: var(--accent-gradient);\n  border-color: transparent;\n  color: white;\n  transform: translateY(-2px);\n}\n\n/* Fullscreen overlay */\n.trailer-modal {\n  position: fixed;\n  inset: 0; /* top:0 right:0 bottom:0 left:0 */\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n\n/* Wrapper keeps aspect ratio */\n.trailer-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  max-width: 100vw;\n  max-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Responsive video */\n.trailer-iframe {\n  width: 100%;\n  height: 100%;\n  max-width: 100vw;\n  max-height: 100vh;\n  border: none;\n  object-fit: contain; /* keeps full video visible */\n  background: black;\n}\n\n/* Close button */\n.trailer-close {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  background: rgba(0, 0, 0, 0.6);\n  border: none;\n  color: #fff;\n  font-size: 32px;\n  cursor: pointer;\n  z-index: 10001;\n  padding: 6px 12px;\n  border-radius: 50%;\n}\n\n.trailer-close:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Mobile optimizations */\n@media (max-width: 768px) {\n  .trailer-close {\n    font-size: 28px;\n    top: 12px;\n    right: 12px;\n  }\n}\n\n.projects-footer {\n  background-color: #240046;\n  /* Deep purple - matches logo color */\n  padding: 60px 5%;\n  margin-top: 60px;\n  color: #FFFFFF;\n}\n\n.projects-footer .footer-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 40px;\n  text-align: left;\n  margin-bottom: 40px;\n}\n\n.projects-footer .footer-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.projects-footer .footer-logo {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.projects-footer .footer-logo-img {\n  height: 40px;\n  filter: grayscale(100%) brightness(200%);\n  /* Monochrome version of the logo */\n}\n\n.projects-footer .social-icons {\n  display: flex;\n  gap: 15px;\n}\n\n.projects-footer .social-icons a {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  /* Soft-cornered squares */\n  background-color: #333;\n  /* Light grey/off-white fill */\n  color: var(--text-white);\n  /* Light grey/off-white icon color */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n\n.projects-footer .social-icons a:hover {\n  background-color: var(--accent-purple);\n  color: var(--text-white);\n}\n\n.projects-footer .footer-column h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  /* Medium/bold weight */\n  margin-bottom: 20px;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  color: #FFFFFF;\n  /* White text for violet background */\n}\n\n.projects-footer .footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.projects-footer .footer-links a {\n  color: #E0E0E0;\n  /* Light grey for links on violet */\n  transition: color 0.3s ease;\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  text-decoration: none;\n  text-transform: capitalize;\n  /* Sentence case (only first letter capitalized) */\n}\n\n.projects-footer .footer-links a:hover {\n  color: #FFFFFF;\n  /* White on hover */\n}\n\n.projects-footer .footer-description {\n  color: #E0E0E0;\n  /* Light grey text for violet background */\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  font-size: 0.9rem;\n  /* Smaller size */\n  line-height: 1.5;\n  max-width: 300px;\n}\n\n.projects-footer .copyright {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  /* Light border for violet */\n  padding-top: 20px;\n  margin-top: 20px;\n  font-size: 0.8rem;\n  /* Smallest size */\n  color: #E0E0E0;\n  /* Light grey for violet background */\n  font-family: var(--font-body);\n  /* Geometric sans-serif */\n  font-weight: 400;\n  /* Regular weight */\n  text-align: center;\n  /* Centered text */\n}\n\n/* Responsive adjustments for Projects page */\n@media (max-width: 992px) {\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    /* 2 columns on medium screens */\n  }\n\n  .projects-header-container {\n    flex-direction: column;\n  }\n}\n\n/* Add these new responsive breakpoints at the end of the file, just before the closing comments */\n\n/* Extra small devices (phones, 480px and down) */\n@media (max-width: 480px) {\n  .container {\n    width: 95%;\n    padding: 60px 0;\n  }\n\n  .section-heading {\n    font-size: 2rem;\n  }\n\n  .btn {\n    padding: 10px 20px;\n    font-size: 0.9rem;\n  }\n\n  .hero h1 {\n    font-size: 1.2rem;\n  }\n\n  .hero-heading {\n    font-size: 1.5rem;\n  }\n\n  .hero p {\n    font-size: 0.9rem;\n  }\n\n  .hero-logo-img {\n    height: 80px;\n  }\n\n  .placeholder-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .placeholder-card {\n    height: 350px;\n    /* Maintain better height on small screens */\n  }\n\n  .services-cards {\n    grid-template-columns: 1fr;\n    gap: 25px;\n  }\n\n  .services-labels {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .team-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    text-align: center;\n  }\n\n  .footer-column {\n    align-items: center;\n  }\n\n  /* Responsive adjustments for Services section */\n  @media (max-width: 768px) {\n    .services-cards {\n      grid-template-columns: 1fr;\n      gap: 20px;\n    }\n\n    .services-labels {\n      grid-template-columns: 1fr;\n      gap: 15px;\n    }\n\n    .service-card {\n      height: 250px;\n    }\n\n    .service-label {\n      font-size: 0.9rem;\n      padding: 6px 15px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .service-card {\n      height: 200px;\n    }\n\n    .service-label {\n      font-size: 0.8rem;\n      padding: 5px 12px;\n    }\n  }\n\n\n  .social-icons {\n    justify-content: center;\n  }\n}\n\n/* Small devices (phones, 481px to 767px) */\n@media (min-width: 481px) and (max-width: 767px) {\n  .container {\n    width: 95%;\n  }\n\n  .section-heading {\n    font-size: 2.2rem;\n  }\n\n  .placeholder-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .placeholder-card {\n    height: 300px;\n    /* Adjust height for medium screens */\n  }\n\n  .services-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n\n  .services-labels {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .team-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n}\n\n/* Medium devices (tablets, 768px to 991px) */\n@media (min-width: 768px) and (max-width: 991px) {\n  .placeholder-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .placeholder-card {\n    height: 350px;\n    /* Maintain better height for tablets */\n  }\n\n  .services-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .services-labels {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .team-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Large devices (desktops, 992px to 1199px) */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .container {\n    max-width: 960px;\n  }\n}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1200px;\n  }\n}\n\n/* Responsive adjustments for Projects page */\n@media (max-width: 992px) {\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    /* 2 columns on medium screens */\n  }\n\n  .projects-header-container {\n    flex-direction: column;\n  }\n\n  .category-filter {\n    position: relative;\n    right: auto;\n    top: auto;\n    transform: none;\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .projects-grid {\n    grid-template-columns: 1fr;\n    /* 1 column on small screens */\n  }\n\n  .navbar .navbar-links {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .projects-footer .footer-grid {\n    text-align: center;\n  }\n\n  .projects-footer .footer-column {\n    align-items: center;\n  }\n\n  .projects-footer .copyright {\n    text-align: center;\n  }\n\n  .category-filter {\n    position: relative;\n    right: auto;\n    top: auto;\n    transform: none;\n    margin-top: 20px;\n  }\n}\n\n/* --- Founders Page --- */\n.founders-main {\n  background-color: #000000;\n  /* Solid black background */\n  min-height: calc(100vh - 80px);\n  padding: 32px 0 60px;\n}\n\n.founders-hero {\n  padding: 0 5%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.founders-heading {\n  font-family: var(--font-heading);\n  /* Elegant Serif font */\n  font-size: 3rem;\n  /* Large size */\n  font-weight: 400;\n  /* High contrast */\n  color: #C700FF;\n  /* Brand's signature vibrant purple */\n  margin-bottom: 32px;\n  text-transform: none;\n  /* Not uppercase */\n  text-align: center;\n  font-style: italic;\n  animation: fadeInUp 1s ease-out 0.2s both;\n  font-style: normal !important;\n  \n}\n\n.founder-item {\n  margin-bottom: 48px;\n}\n\n.founder-item:last-child {\n  margin-bottom: 0;\n}\n\n.founder-content {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n\n\n.founder-columns {\n  display: flex;\n  gap: 32px;\n  align-items: flex-start;\n}\n\n.founder-columns--reversed {\n  flex-direction: row-reverse;\n}\n\n.founder-columns--reversed .founder-text-content {\n  text-align: left;\n  align-items: flex-start;\n}\n\n.founder-columns--reversed .founder-biography {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.founder-text-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.founder-name {\n  font-family: var(--font-heading);\n  /* Prominent Serif font */\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #FFFFFF;\n  /* White color */\n  margin: 0;\n  text-transform: none;\n  font-style: italic;\n}\n\n.founder-title {\n  font-family: var(--font-heading);\n  /* Clean, modern sans-serif */\n  font-size: 1.2rem;\n  font-weight: 400;\n  /* Regular weight */\n  color: #FFFFFF;\n  /* White color */\n  margin: 0;\n  text-transform: none;\n  font-style: italic;\n}\n\n.founder-biography {\n  font-family: var(--font-body);\n  /* Standard sans-serif */\n  font-size: 1rem;\n  font-size: 1rem;\n  color: #FFFFFF;\n  /* White color */\n  line-height: 1.6;\n  margin-top: 15px;\n  /* Separation from designation */\n  max-width: 600px;\n  margin: 0;\n}\n\n.founder-photo-content {\n  flex: 1;\n}\n\n.founder-main-photo .photo-placeholder {\n  width: 100%;\n  height: 460px;\n  background-color: var(--placeholder-bg);\n  /* Grey background */\n  border-radius: 15px;\n  /* Soft, rounded corners */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1.2rem;\n  font-style: italic;\n}\n\n.founder-photo-grid {\n  display: flex;\n  gap: 20px;\n}\n\n.founder-photo-placeholder {\n  flex: 1;\n}\n\n.founder-photo-placeholder .photo-placeholder {\n  width: 100%;\n  height: 150px;\n  background-color: var(--placeholder-bg);\n  /* Grey background */\n  border-radius: 15px;\n  /* Rounded rectangle */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1rem;\n  font-style: italic;\n}\n\n/* Responsive adjustments for Founders page */\n@media (max-width: 992px) {\n  .founders-heading {\n    font-size: 2.5rem;\n  }\n\n  .founder-columns {\n    flex-direction: column;\n  }\n\n  .founder-columns--reversed {\n    flex-direction: column;\n  }\n\n  .founder-columns--reversed .founder-text-content {\n    text-align: left;\n  }\n\n  .founder-columns--reversed .founder-biography {\n    margin-left: 0;\n  }\n\n  .founder-main-photo .photo-placeholder {\n    height: 360px;\n  }\n}\n\n@media (max-width: 600px) {\n\n  .founder-text-content,\n  .founder-columns--reversed .founder-text-content {\n    align-items: center;\n    text-align: left;\n  }\n\n  .founder-biography {\n    max-width: 100%;\n    font-size: 0.95rem;\n    line-height: 1.55;\n  }\n\n  .founder-photo-grid {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .founder-content {\n    gap: 24px;\n  }\n\n  .founder-columns {\n    gap: 20px;\n  }\n\n  .founder-name {\n    font-size: 1.9rem;\n  }\n\n  .founder-title {\n    font-size: 1.05rem;\n  }\n\n  .founder-main-photo .photo-placeholder {\n    height: 280px;\n    border-radius: 12px;\n  }\n\n  .founder-photo-placeholder .photo-placeholder {\n    height: 110px;\n    border-radius: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .founders-heading {\n    font-size: 2rem;\n  }\n\n  .founder-name {\n    font-size: 2rem;\n  }\n\n  .founder-photo-grid {\n    flex-direction: column;\n  }\n\n  .founder-main-photo .photo-placeholder {\n    height: 250px;\n  }\n\n  .founder-photo-placeholder .photo-placeholder {\n    height: 120px;\n  }\n}\n\n/* --- Contact Us Page --- */\n.contact-main {\n  background-color: #000000;\n  /* Solid black background */\n  min-height: calc(100vh - 80px);\n  padding: 40px 0;\n}\n\n.contact-hero {\n  padding: 0 5%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.contact-heading {\n  font-family: var(--font-heading);\n  /* Signature stylish Serif font */\n  font-size: 2.2rem;\n  /* Large size */\n  font-weight: 400;\n  /* High contrast */\n  color: #C700FF;\n  /* Bright, vibrant purple */\n  margin-bottom: 40px;\n  text-transform: none;\n  /* Not uppercase */\n  text-align: center;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n  font-style: normal !important;\n}\n\n.contact-content {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 100%;\n}\n\n.contact-columns {\n  display: flex;\n  gap: 30px;\n  align-items: stretch;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.contact-map-column {\n  margin-top: 60px;\n  flex: 1;\n  min-width: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\n.map-placeholder {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  min-height: 450px;\n  /* Ensure sufficient height */\n  background-color: var(--placeholder-bg);\n  /* Light grey */\n  border-radius: 15px;\n  /* Very soft, rounded corners */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1.5rem;\n  font-style: italic;\n  overflow: hidden;\n}\n\n.map-placeholder iframe {\n  width: 100%;\n  height: 100%;\n  display: block;\n  border-radius: inherit;\n  object-fit: cover;\n}\n\n.contact-form-column {\n  flex: 1;\n  min-width: 350px;\n  /* Reduced to fit side-by-side on laptop */\n  display: flex;\n  flex-direction: column;\n  margin-top: 60px;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  color: #C700FF;\n  /* Bright purple label */\n  font-family: var(--font-heading);\n  /* Decorative serif font */\n  font-size: 1.2rem;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.animated-label {\n  animation: labelGlow 2s infinite ease-in-out;\n}\n\n.form-input,\n.form-textarea {\n  background-color: #1a1a1a;\n  /* Darker background */\n  border: 2px solid #C700FF;\n  /* Purple border */\n  border-radius: 50px;\n  /* Pill-shaped */\n  padding: 25px 40px;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  outline: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 10px rgba(199, 0, 255, 0.2);\n  width: 100%;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n  border-color: #C700FF;\n  box-shadow: 0 0 15px rgba(200, 0, 255, 0.4);\n  transform: scale(1.02);\n}\n\n.form-input:hover,\n.form-textarea:hover {\n  border-color: #C700FF;\n  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);\n}\n\n.form-input::placeholder,\n.form-textarea::placeholder {\n  color: #999999;\n  font-style: italic;\n  opacity: 0.7;\n}\n\n.form-textarea {\n  min-height: 250px;\n  border-radius: 30px;\n  /* Slightly less rounded for textarea */\n  padding: 100px 120px;\n  resize: vertical;\n  font-size: 1.2rem;\n}\n\n.submit-btn {\n  background: linear-gradient(45deg, #C700FF, #C700FF);\n  /* Purple gradient */\n  border: none;\n  border-radius: 50px;\n  /* Pill-shaped */\n  color: #FFFFFF;\n  /* White text */\n  padding: 15px 40px;\n  font-family: var(--font-heading);\n  /* Decorative serif font */\n  font-size: 1.2rem;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-self: flex-start;\n  /* Align to the left */\n  margin-top: 20px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  box-shadow: 0 5px 15px rgba(199, 0, 255, 0.4);\n  transform: translateY(0);\n}\n\n.submit-btn:hover {\n  background: linear-gradient(45deg, #C700FF, #C700FF);\n  /* Reverse gradient on hover */\n  color: #FFFFFF;\n  transform: translateY(-3px);\n  box-shadow: 0 8px 20px rgba(199, 0, 255, 0.6);\n}\n\n.submit-btn:active {\n  transform: translateY(1px);\n  box-shadow: 0 3px 10px rgba(199, 0, 255, 0.4);\n}\n\n/* Responsive adjustments for Contact Us page */\n@media (max-width: 992px) {\n  .contact-heading {\n    font-size: 2.5rem;\n  }\n\n  .contact-columns {\n    flex-direction: column;\n  }\n\n  .map-placeholder {\n    height: 400px;\n  }\n}\n\n@media (max-width: 768px) {\n  .contact-heading {\n    font-size: 2rem;\n    margin-bottom: 30px !important;\n  }\n\n  .map-placeholder {\n    height: 300px;\n  }\n\n  .submit-btn {\n    width: 100%;\n  }\n\n  .contact-columns {\n    flex-direction: column;\n    gap: 24px;\n    align-items: stretch;\n  }\n\n  .contact-form-column,\n  .contact-map-column {\n    width: 100%;\n    min-width: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .contact-main {\n    padding: 32px 0 48px;\n  }\n\n  .contact-hero {\n    padding: 0 6%;\n  }\n\n  .contact-heading {\n    font-size: 1.75rem;\n    margin-bottom: 28px;\n  }\n\n  .contact-content {\n    gap: 24px;\n  }\n\n  .contact-columns {\n    gap: 18px;\n    align-items: center;\n  }\n\n  .map-placeholder {\n    height: 220px;\n    border-radius: 12px;\n  }\n\n  .contact-form {\n    gap: 14px;\n    width: 250%;\n  }\n\n  .contact-form-column {\n    justify-content: center;\n  }\n\n  .form-group label {\n    font-size: 1rem;\n  }\n\n  .form-input,\n  .form-textarea {\n    padding: 12px 16px;\n    border-radius: 18px;\n    font-size: 16px;\n    /* Prevent iOS zoom */\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n  }\n\n  .form-textarea {\n    min-height: 140px;\n  }\n\n  .submit-btn {\n    font-size: 16px;\n    padding: 12px 20px;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n}\n\n/* --- Service Detail Pages --- */\n.service-detail-page {\n  background-color: #000000;\n  min-height: calc(100vh - 80px);\n  padding: 40px 0;\n}\n\n.service-hero {\n  padding: 60px 0;\n  text-align: center;\n  background: radial-gradient(circle at center, #C700FF20 0%, transparent 70%);\n}\n\n.service-title {\n  font-family: var(--font-heading);\n  font-size: 2.6rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: none !important;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  line-height: 1.1;\n  word-break: break-word;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.service-intro {\n  font-family: var(--font-body);\n  font-size: 1.2rem;\n  color: var(--text-white);\n  max-width: 800px;\n  margin: 0 auto 40px;\n  line-height: 1.6;\n}\n\n.service-content {\n  padding: 40px 0;\n}\n\n.service-description h2 {\n  font-family: var(--font-heading);\n  font-size: 2.2rem;\n  font-weight: 400;\n  color: #FFFFFF;\n  margin: 40px 0 20px;\n  text-transform: none;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.service-description h3 {\n  font-family: var(--font-body);\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #C700FF;\n  margin: 30px 0 15px;\n  text-transform: none;\n}\n\n.service-description p {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.service-highlights {\n  background-color: #1a1a1a;\n  border-radius: 15px;\n  padding: 30px;\n  margin: 40px 0;\n}\n\n.service-highlights h3 {\n  font-family: var(--font-heading);\n  font-size: 1.6rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: none;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.service-highlights ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.service-highlights li {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  padding: 10px 0 10px 30px;\n  position: relative;\n  line-height: 1.5;\n}\n\n.service-highlights li:before {\n  content: \"•\";\n  color: #C700FF;\n  font-size: 1.5rem;\n  position: absolute;\n  left: 0;\n  top: 8px;\n}\n\n/* --- Natural Flow for BTS Projects --- */\n.natural-flow-section {\n  position: relative;\n  height: auto;\n  background: #000000;\n  padding: 50px 0;\n  margin-top: 0;\n}\n\n.movie-item {\n  margin-bottom: 80px;\n  scroll-margin-top: 100px;\n}\n\n.movie-item:last-child {\n  margin-bottom: 0;\n}\n\n.movie-card {\n  background: #1a1a1a;\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(199, 0, 255, 0.3);\n  max-width: 1200px;\n  margin: 0 auto;\n  transition: all 0.3s ease;\n}\n\n.movie-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 25px 60px rgba(199, 0, 255, 0.4);\n}\n\n.movie-header {\n  margin-bottom: 30px;\n  text-align: center;\n  width: 100%;\n}\n\n.movie-title {\n  font-family: var(--font-heading);\n  font-size: 3rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin: 0;\n  text-transform: none !important;\n  letter-spacing: 1px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  animation: fadeInUp 1s ease-out 0.2s both;\n}\n\n.movie-media {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto 30px;\n}\n\n.movie-description {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.movie-description p {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Video container styling */\n.natural-flow-section .film-frame-container {\n  max-width: 100%;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n/* Remove fixed positioning elements */\n.fixed-animated-content,\n.scroll-spacer,\n.scroll-progress-container {\n  display: none;\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .movie-card {\n    padding: 30px;\n  }\n\n  .movie-title {\n    font-size: 2.5rem;\n    font-weight: 400;\n    font-style: italic;\n    text-decoration: underline;\n    text-decoration-color: var(--text-white);\n    text-decoration-thickness: 1px;\n  }\n\n  .movie-description p {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .movie-card {\n    padding: 20px;\n  }\n\n  .movie-title {\n    font-size: 2rem;\n    font-weight: 400;\n    font-style: italic;\n    text-decoration: underline;\n    text-decoration-color: var(--text-white);\n    text-decoration-thickness: 1px;\n  }\n\n  .movie-media {\n    max-width: 100%;\n  }\n\n  .movie-description {\n    max-width: 100%;\n  }\n}\n\n/* Hide previous scroll styles */\n.continuous-scroll-section {\n  display: none;\n}\n\n.bts-section {\n  position: relative;\n}\n\n/* Ensure proper centering and visibility */\n.bts-projects-page {\n  position: relative;\n  z-index: 1;\n}\n\n.projects-hero {\n  position: relative;\n  z-index: 2;\n}\n\n.projects-heading {\n  position: relative;\n  z-index: 3;\n  text-align: center;\n  margin-bottom: 16px;\n  /* Reduced spacing */\n  font-family: var(--font-heading);\n  font-weight: 400;\n  color: #C700FF;\n  font-style: italic;\n  width: 100%;\n  animation: fadeInUp 1s ease-out 0.2s both;\n  font-style: normal !important;\n}\n\n.bts-tabs {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n  /* Reduced spacing */\n}\n\n/* --- Scroll Animation for BTS Projects --- */\n.scroll-animated-section {\n  position: relative;\n  background: #000000;\n  padding: 50px 0;\n  margin-top: 0;\n  z-index: 1;\n  display: none;\n  /* Hide the old scroll animation section */\n}\n\n.bts-section {\n  position: relative;\n}\n\n.bts-content {\n  display: flex;\n  gap: 32px;\n  margin-bottom: 0;\n  position: sticky;\n  top: 80px;\n  z-index: 2;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 70vh;\n}\n\n/* Left Side - Movie Information */\n.movie-list-container {\n  flex: 1;\n  max-width: 400px;\n  height: auto;\n  padding-right: 20px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.movie-card-swapper {\n  position: relative;\n  width: 100%;\n  height: 350px;\n  perspective: 1000px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.movie-card {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #1a1a1a;\n  border: 2px solid rgba(199, 0, 255, 0.3);\n  border-radius: 15px;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  backface-visibility: hidden;\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  opacity: 1;\n  align-items: center;\n  text-align: center;\n  transform: translateZ(0);\n}\n\n.movie-card.current {\n  transform: translateZ(0);\n  z-index: 2;\n}\n\n.movie-card-swapper.direction-down .movie-card.current {\n  animation: slideInFromBottom 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n.movie-card-swapper.direction-up .movie-card.current {\n  animation: slideInFromTop 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n@keyframes slideInFromBottom {\n  0% {\n    transform: translateY(50px) scale(0.95);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes slideInFromTop {\n  0% {\n    transform: translateY(-50px) scale(0.95);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n/* Enhanced smooth transitions */\n.movie-list-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin: 0 0 20px 0;\n  text-transform: none !important;\n  letter-spacing: 1px;\n  text-align: center;\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transform: translateZ(0);\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.movie-list-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin: 0;\n  text-align: center;\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transform: translateZ(0);\n}\n\n/* Right Side - Video Display */\n.video-display-container {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  max-width: 648px;\n}\n\n.video-content {\n  background: #1a1a1a;\n  border-radius: 15px;\n  padding: 0;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border: none;\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  opacity: 1;\n  height: 350px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translateZ(0);\n}\n\n.video-content.changing {\n  transform: scale(0.98) translateZ(0);\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.video-info {\n  text-align: center;\n  padding: 20px 0;\n  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  opacity: 1;\n}\n\n.video-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 800;\n  color: #C700FF;\n  margin: 0 0 15px 0;\n  text-transform: none !important;\n  letter-spacing: 1px;\n}\n\n.video-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Reels navigation styles */\n.reel-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n}\n\n.service-detail-image {\n  max-width: 300px;\n  height: auto;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.service-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n  gap: 30px;\n}\n\n.service-header .service-title {\n  flex: 1;\n  text-align: center;\n  margin: 0;\n}\n\n.service-image-container {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Responsive adjustments for service detail pages */\n@media (max-width: 768px) {\n  .service-header {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .service-header .service-title {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .service-image-container {\n    justify-content: center;\n  }\n\n  .service-detail-image {\n    max-width: 100%;\n  }\n\n  .reel-nav:hover {\n    background: rgba(0, 0, 0, 0.8);\n    transform: translateY(-50%) scale(1.1);\n  }\n\n  .reel-nav.prev {\n    left: 20px;\n  }\n\n  .reel-nav.next {\n    right: 20px;\n  }\n\n  .reel-nav:disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n    transform: translateY(-50%);\n  }\n\n  .reels-progress {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 8px;\n    z-index: 10;\n  }\n\n  .progress-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.5);\n    transition: all 0.3s ease;\n    cursor: pointer;\n  }\n\n  .progress-dot.active {\n    background: #C700FF;\n    transform: scale(1.2);\n  }\n\n  /* Fixed content section - stays in place like Instagram reels */\n  .fixed-content {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 90%;\n    max-width: 400px;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 15px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .fixed-content .movie-title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }\n\n  .fixed-content .movie-description {\n    font-size: 0.95rem;\n  }\n}\n\n/* Service Detail Page Styles */\n\n.service-detail-image {\n  max-width: 300px;\n  height: auto;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.service-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.service-header .service-title {\n  flex: 1;\n  text-align: center;\n  margin: 0;\n}\n\n.service-image-container {\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 10px;\n}\n\n/* Our Services subtitle */\n.services-subtitle {\n  color: #FFFFFF;\n  font-family: var(--font-heading);\n  font-size: 1.5rem;\n  font-weight: 400;\n  text-align: left;\n  margin: 20px 0 40px;\n}\n\n/* Larger headings for description and what we provide with DM Serif Display font */\n.service-hero h2 {\n  text-align: left;\n  margin-top: 30px;\n  margin-bottom: 15px;\n  width: 100%;\n  font-family: 'DM Serif Display', serif;\n  font-size: 2.2rem;\n  font-weight: 400;\n  color: #FFFFFF;\n  text-transform: none;\n  font-style: normal;\n  text-decoration: none;\n}\n\n.service-intro {\n  text-align: left;\n  margin: 0 0 20px 0;\n  width: 100%;\n  max-width: 100%;\n  font-size: 1.2rem;\n  font-family: 'DM Serif Display', serif;\n  font-weight: 400;\n  white-space: pre-wrap;\n}\n\n.service-long-description {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin-bottom: 20px;\n  white-space: pre-wrap;\n}\n\n.service-hero p {\n  width: 100%;\n  max-width: 100%;\n  text-align: left !important;\n  font-size: 1.1rem;\n  line-height: 1.7;\n  font-family: sans-serif;\n  font-weight: 400;\n  margin-bottom: 40px;\n}\n\n@media (max-width: 1024px) {\n  .service-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 20px;\n  }\n\n  .service-header .service-title {\n    text-align: center;\n    font-size: 2.3rem;\n  }\n\n  .service-image-container {\n    padding-left: 0;\n    justify-content: center;\n  }\n\n  .service-detail-image {\n    max-width: 260px;\n  }\n\n  .services-subtitle,\n  .service-hero h2,\n  .service-intro,\n  .service-hero p {\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .service-hero h2 {\n    font-size: 1.9rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .service-hero {\n    padding: 40px 0;\n  }\n\n  .service-title {\n    font-size: 1.9rem;\n    letter-spacing: 0.5px;\n  }\n\n  .services-subtitle {\n    font-size: 1.2rem;\n    margin: 16px 0 28px;\n  }\n\n  .service-intro {\n    font-size: 1rem;\n  }\n\n  .service-hero p {\n    font-size: 0.95rem;\n    line-height: 1.6;\n  }\n\n  .service-description h2 {\n    font-size: 1.7rem;\n    text-align: center;\n  }\n\n  .service-description h3 {\n    font-size: 1.2rem;\n  }\n}\n\n/* Full width description and what we provide content */\n.service-hero .container {\n  max-width: 100%;\n  width: 100%;\n  padding: 0 5%;\n}\n\n/* Responsive adjustments for service detail pages */\n@media (max-width: 768px) {\n  .service-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 20px;\n  }\n\n  .service-header .service-title {\n    text-align: center;\n    margin-bottom: 0;\n  }\n\n  .services-subtitle {\n    text-align: center;\n    margin-top: 0;\n  }\n\n  .service-image-container {\n    justify-content: center;\n    padding-left: 0;\n  }\n\n  .service-detail-image {\n    max-width: 100%;\n  }\n\n  /* Mobile alignment adjustments */\n  .service-hero h2 {\n    text-align: center;\n    font-size: 1.8rem;\n  }\n\n  .service-intro {\n    text-align: center;\n  }\n}\n\n.fixed-content {\n  display: none;\n  position: fixed;\n  top: 150px;\n  left: 0;\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  gap: 40px;\n  padding: 0 5%;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.fixed-content>* {\n  pointer-events: auto;\n}\n\n.movie-info-container {\n  flex: 1;\n  max-width: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.movie-card {\n  background: #1a1a1a;\n  border: 2px solid rgba(199, 0, 255, 0.3);\n  border-radius: 15px;\n  padding: 30px;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.movie-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin: 0 0 20px 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.movie-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin: 0;\n}\n\n.video-container {\n  flex: 2;\n  max-width: 648px;\n  height: 350px;\n  /* Match photo card height */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.video-content {\n  background: #1a1a1a;\n  border-radius: 15px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n/* Scroll triggers - create scrolling space */\n.scroll-triggers {\n  display: none;\n  /* Hide scroll triggers since we're using simple layout */\n  margin-top: 100vh;\n  /* Start after the fixed content */\n  padding-bottom: 100vh;\n  /* End with space below */\n}\n\n.scroll-trigger {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.trigger-content {\n  width: 100%;\n  max-width: 800px;\n  padding: 40px;\n  text-align: center;\n  color: transparent;\n  /* Hide content but keep for scroll detection */\n  font-size: 1.2rem;\n  line-height: 1.6;\n}\n\n.trigger-content h3 {\n  color: transparent;\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  margin-bottom: 20px;\n}\n\n/* Ensure proper spacing */\n.projects-main {\n  padding-top: 32px;\n}\n\n/* Reels content layout */\n.bts-content {\n  display: flex;\n  gap: 32px;\n  margin-bottom: 0;\n  position: sticky;\n  top: 80px;\n  z-index: 2;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: 70vh;\n}\n\n.movie-item {\n  margin-bottom: 40px;\n}\n\n/* Video container styling */\n.video-content .film-frame-container {\n  max-width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border-radius: 15px;\n  overflow: hidden;\n  position: relative;\n}\n\n.reels-section .film-frame-container {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border-radius: 15px;\n  overflow: hidden;\n  position: relative;\n  padding: 20px 30px;\n  box-sizing: border-box;\n}\n\n.video-content .film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  z-index: 4;\n  background: #000;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n}\n\n.video-content .video-block-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n}\n\n.video-content .video-block-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  display: block;\n}\n\n.video-content .play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  z-index: 3;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n.video-content .film-strip-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #1a1a1a;\n  border-radius: 15px;\n  z-index: 1;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  border: none;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);\n}\n\n/* Film strip frame with black and white borders */\n.video-content .film-strip-overlay::before,\n.video-content .film-strip-overlay::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25px;\n  background: repeating-linear-gradient(to bottom,\n      #000 0px,\n      #000 15px,\n      #fff 15px,\n      #fff 30px);\n  z-index: 2;\n  box-shadow:\n    inset 1px 0 3px rgba(255, 255, 255, 0.4),\n    inset -1px 0 3px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333;\n}\n\n.video-content .film-strip-overlay::before {\n  left: 15px;\n}\n\n.video-content .film-strip-overlay::after {\n  right: 15px;\n}\n\n.reels-section .film-strip-overlay::before,\n.reels-section .film-strip-overlay::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25px;\n  background: repeating-linear-gradient(to bottom,\n      #000 0px,\n      #000 15px,\n      #fff 15px,\n      #fff 30px);\n  z-index: 2;\n  box-shadow:\n    inset 1px 0 3px rgba(255, 255, 255, 0.4),\n    inset -1px 0 3px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333;\n}\n\n.reels-section .film-strip-overlay::before {\n  left: 15px;\n}\n\n.reels-section .film-strip-overlay::after {\n  right: 15px;\n}\n\n/* Additional styles for reels section */\n.reels-section .video-block-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n}\n\n.reels-section .video-block-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  display: block;\n}\n\n.reels-section .film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  z-index: 4;\n  background: #000;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n}\n\n.reels-section .play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  z-index: 3;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n/* Ensure navbar and footer remain visible */\n.navbar {\n  z-index: 1000;\n  position: relative;\n  top: 0;\n}\n\n.footer {\n  z-index: 100;\n  position: relative;\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n  .reels-content {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .movie-info-container {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .movie-title {\n    font-size: 1.8rem;\n  }\n\n  .movie-description {\n    font-size: 1rem;\n  }\n\n  .reels-section .film-frame-container {\n    height: 300px;\n  }\n\n  .video-container {\n    height: 300px;\n  }\n\n  .video-container {\n    min-height: 300px;\n  }\n\n  .reel-nav {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n\n  .reel-nav.prev {\n    left: 10px;\n  }\n\n  .reel-nav.next {\n    right: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .reels-content {\n    gap: 20px;\n  }\n\n  .movie-title {\n    font-size: 1.5rem;\n  }\n\n  .movie-description {\n    font-size: 1rem;\n  }\n\n  .reels-section .film-frame-container {\n    height: 250px;\n  }\n\n  .video-container {\n    height: 250px;\n  }\n\n  .video-container {\n    min-height: 250px;\n  }\n\n  .reel-nav {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n\n  .reel-nav.prev {\n    left: 10px;\n  }\n\n  .reel-nav.next {\n    right: 10px;\n  }\n\n  .reels-progress {\n    top: 10px;\n  }\n\n  .reels-section .projects-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* --- Simple Video Section for BTS Projects --- */\n.simple-video-section {\n  position: relative;\n  height: auto;\n  background: #000000;\n  padding: 50px 0;\n  margin-top: 0;\n}\n\n.simple-video-section .bts-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.simple-video-section .projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.simple-video-section .movie-item {\n  margin-bottom: 30px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  scroll-margin-top: 0;\n}\n\n.simple-video-section .movie-item:hover {\n  transform: translateY(-5px);\n}\n\n.simple-video-section .movie-item:last-child {\n  margin-bottom: 0;\n}\n\n.simple-video-section .movie-card {\n  background: #1a1a1a;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(199, 0, 255, 0.3);\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.simple-video-section .movie-card:hover {\n  border-color: #C700FF;\n  box-shadow: 0 15px 35px rgba(199, 0, 255, 0.4);\n}\n\n.simple-video-section .movie-header {\n  margin-bottom: 20px;\n  text-align: center;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.simple-video-section .movie-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin: 0 0 10px 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n/* BTS Video Styles */\nbody {\n  margin: 0;\n  padding: 0;\n  background: black;\n  color: white;\n  font-family: \"Poppins\", sans-serif;\n  overflow-x: hidden;\n}\n\n/* Wrapper */\n.bts-video-wrapper {\n  width: 100%;\n  background: black;\n  color: white;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Header */\n.bts-header {\n  text-align: center;\n  margin-top: 60px;\n}\n\n.bts-title {\n  font-family: var(--font-heading);\n  font-size: 3rem;\n  font-weight: 400;\n  color: #b300ff;\n  margin-bottom: 10px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.bts-toggle {\n  margin-bottom: 30px;\n}\n\n.toggle-btn {\n  background: #2d143d;\n  color: #b300ff;\n  border: none;\n  padding: 8px 25px;\n  border-radius: 25px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.toggle-btn.active {\n  background: #b300ff;\n  color: white;\n}\n\n/* Layout */\n.bts-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2rem;\n  width: 90%;\n  max-width: 1200px;\n}\n\n/* Left Info */\n.bts-info {\n  width: 40%;\n  position: sticky;\n  top: 50px;\n  /* Further reduced spacing from navbar */\n  transition: opacity 0.4s ease;\n}\n\n.movie-name {\n  font-size: 1.8rem;\n  font-style: italic;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.movie-description {\n  margin-top: 5px;\n  /* Further reduced spacing from movie name */\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n/* Right Reel Section */\n\n\n/* Right Reel Section */\n.bts-reel-frame {\n  width: 70%;\n  height: 95vh;\n  background: none;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.bts-reel-scroll {\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  scroll-snap-type: y mandatory;\n  scrollbar-width: none;\n}\n\n.bts-reel-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.bts-reel-item {\n  scroll-snap-align: start;\n  height: 95vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bts-reel-item video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .bts-main {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .bts-info {\n    width: 100%;\n    position: static;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .bts-reel-frame {\n    width: 100%;\n    height: 70vh;\n  }\n\n  .movie-name {\n    font-size: 1.5rem;\n  }\n\n  .movie-description {\n    font-size: 0.95rem;\n  }\n}\n\n/* Extra small devices (phones, 480px and down) */\n@media (max-width: 480px) {\n  .movie-description {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    width: 95%;\n    padding: 60px 0;\n  }\n\n  .section-heading {\n    font-size: 2rem;\n  }\n\n  .btn {\n    padding: 10px 20px;\n    font-size: 0.9rem;\n  }\n\n  .hero h1 {\n    font-size: 1.2rem;\n  }\n\n  .hero-heading {\n    font-size: 1.5rem;\n  }\n\n  .hero p {\n    font-size: 0.9rem;\n  }\n\n  .hero-logo-img {\n    height: 80px;\n  }\n\n  .placeholder-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .services-cards {\n    grid-template-columns: 1fr;\n    gap: 25px;\n  }\n\n  .services-labels {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .team-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    text-align: center;\n  }\n\n  .footer-column {\n    align-items: center;\n  }\n\n  .social-icons {\n    justify-content: center;\n  }\n}\n\n/* Small devices (phones, 481px to 767px) */\n@media (min-width: 481px) and (max-width: 767px) {\n  .container {\n    width: 95%;\n  }\n\n  .section-heading {\n    font-size: 2.2rem;\n  }\n\n  .placeholder-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .placeholder-card {\n    height: 300px;\n    /* Adjust height for medium screens */\n  }\n\n  .services-cards {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n\n  .services-labels {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .team-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 25px;\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 30px;\n  }\n}\n\n/* Medium devices (tablets, 768px to 991px) */\n@media (min-width: 768px) and (max-width: 991px) {\n  .placeholder-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .placeholder-card {\n    height: 320px;\n    /* Adjust height for tablets */\n  }\n\n  .services-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .services-labels {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .team-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .footer-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Large devices (desktops, 992px to 1199px) */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .container {\n    max-width: 960px;\n  }\n}\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1200px;\n  }\n}\n\n.simple-video-section .movie-media {\n  width: 100%;\n  margin: 0 0 20px 0;\n  flex: 1;\n}\n\n.simple-video-section .movie-description {\n  width: 100%;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.simple-video-section .movie-description p {\n  font-family: var(--font-body);\n  font-size: 1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Video container styling */\n.simple-video-section .film-frame-container {\n  max-width: 100%;\n  margin: 0 auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border-radius: 15px;\n  overflow: hidden;\n  padding: 20px 30px;\n  box-sizing: border-box;\n  position: relative;\n  height: 350px;\n  /* Fixed height to match photo cards */\n}\n\n/* Film strip overlay */\n.simple-video-section .film-strip-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #1a1a1a;\n  border-radius: 15px;\n  z-index: 1;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  border: none;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5), inset 0 0 15px rgba(199, 0, 255, 0.2);\n}\n\n/* Film strip frame with black and white borders */\n.simple-video-section .film-strip-overlay::before,\n.simple-video-section .film-strip-overlay::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 25px;\n  background: repeating-linear-gradient(to bottom,\n      #000 0px,\n      #000 15px,\n      #fff 15px,\n      #fff 30px);\n  z-index: 2;\n  box-shadow:\n    inset 1px 0 3px rgba(255, 255, 255, 0.4),\n    inset -1px 0 3px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333;\n}\n\n.simple-video-section .film-strip-overlay::before {\n  left: 15px;\n}\n\n.simple-video-section .film-strip-overlay::after {\n  right: 15px;\n}\n\n/* Film frame content */\n.simple-video-section .film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  z-index: 4;\n  cursor: pointer;\n  background: #000;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n}\n\n/* Play overlay */\n.simple-video-section .play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  z-index: 3;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n/* Video block container */\n.simple-video-section .video-block-container {\n  position: relative;\n  width: 100%;\n  height: 450px;\n  /* Increased from 350px */\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n}\n\n.simple-video-section .video-block-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  display: block;\n}\n\n/* Film frame content */\n.simple-video-section .film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  z-index: 4;\n  cursor: pointer;\n  background: #000;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n}\n\n/* Play overlay */\n.simple-video-section .play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  z-index: 3;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n/* --- Video Container Improvements --- */\n.video-container {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.video-player-container {\n  width: 100%;\n  border-radius: 15px;\n  overflow: hidden;\n  margin-bottom: 30px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  position: relative;\n  height: 350px;\n  /* Fixed height to match photo cards */\n}\n\n.video-player {\n  width: 100%;\n  height: 100%;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n.video-player video {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.video-info {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.video-title {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n}\n\n.video-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Mobile adjustments for video components */\n@media (max-width: 768px) {\n  .video-player-container {\n    height: 350px;\n    border-radius: 12px;\n  }\n\n  .video-title {\n    font-size: 2rem;\n  }\n\n  .video-description {\n    font-size: 1rem;\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-player-container {\n    height: 300px;\n    border-radius: 10px;\n  }\n\n  .video-title {\n    font-size: 1.8rem;\n  }\n\n  .video-description {\n    font-size: 0.9rem;\n  }\n}\n\n/* --- BTS Video Page --- */\n.bts-video-page {\n  background-color: #000000;\n  min-height: calc(100vh - 80px);\n  padding: 40px 0;\n  overflow: hidden;\n  /* Prevent scrolling */\n}\n\n.bts-video-page .projects-main {\n  position: relative;\n  z-index: 1;\n}\n\n.video-section {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.video-wrapper {\n  width: 100%;\n  max-width: 1000px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.video-container {\n  position: relative;\n  width: 100%;\n  height: 450px;\n  /* Increased from 350px */\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  background-color: #000;\n}\n\n.video-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-info {\n  text-align: center;\n  padding: 20px;\n}\n\n.video-title {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n}\n\n.video-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* --- Instagram Reels Style --- */\n.reels-section {\n  position: relative;\n  height: 80vh;\n  background: #000000;\n  padding: 50px 0;\n  margin-top: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reels-content {\n  display: flex;\n  gap: 40px;\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  position: relative;\n  align-items: stretch;\n}\n\n/* Left Side - Movie Information */\n.movie-info-container {\n  flex: 1;\n  max-width: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.movie-card {\n  background: #1a1a1a;\n  border: 2px solid rgba(199, 0, 255, 0.3);\n  border-radius: 15px;\n  padding: 20px;\n  /* Reduced padding */\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.movie-title {\n  font-family: var(--font-heading);\n  font-size: 2rem;\n  font-weight: 800;\n  color: #C700FF;\n  margin: 0 0 10px 0;\n  /* Reduced spacing */\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.movie-description {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* Right Side - Video Display */\n.video-container {\n  flex: 2;\n  max-width: 648px;\n  height: 350px;\n  /* Match photo card height */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-top: 10px;\n  /* Reduced spacing */\n}\n\n.reel-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 24px;\n  cursor: pointer;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(5px);\n}\n\n.reel-nav:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.reel-nav.prev {\n  left: 20px;\n}\n\n.reel-nav.next {\n  right: 20px;\n}\n\n.reel-nav:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n  transform: translateY(-50%);\n}\n\n.reels-progress {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n}\n\n.progress-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.progress-dot.active {\n  background: #C700FF;\n  transform: scale(1.2);\n}\n\n/* Responsive adjustments for video section */\n@media (max-width: 768px) {\n  .video-title {\n    font-size: 2rem;\n  }\n\n  .video-description {\n    font-size: 1rem;\n  }\n\n  .video-wrapper {\n    padding: 0 15px;\n  }\n\n  .video-info {\n    padding: 15px;\n  }\n\n  .reel-nav {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n\n  .reel-nav.prev {\n    left: 10px;\n  }\n\n  .reel-nav.next {\n    right: 10px;\n  }\n\n  .reel-info {\n    padding: 15px;\n  }\n\n  .video-title {\n    font-size: 1.5rem;\n  }\n\n  .video-description {\n    font-size: 0.9rem;\n  }\n}\n\n/* Responsive adjustments for video section */\n@media (max-width: 992px) {\n  .video-title {\n    font-size: 2rem;\n  }\n\n  .video-description {\n    font-size: 1rem;\n  }\n\n  .video-container {\n    height: 300px;\n  }\n\n  .simple-video-section .film-frame-container {\n    height: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .video-title {\n    font-size: 1.8rem;\n  }\n\n  .video-description {\n    font-size: 0.9rem;\n  }\n\n  .video-container {\n    height: 250px;\n  }\n\n  .simple-video-section .film-frame-container {\n    height: 250px;\n  }\n\n  .simple-video-section .projects-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Show the scroll animation section */\n.scroll-animated-section {\n  display: none;\n  /* Hide scroll animation for reels */\n}\n\n\n\n/* Additional styles for reels section */\n.reels-section .video-block-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n  box-sizing: border-box;\n}\n\n.reels-section .video-block-container video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  display: block;\n}\n\n.reels-section .film-frame-content {\n  position: relative;\n  display: block;\n  border-radius: 10px;\n  overflow: hidden;\n  z-index: 4;\n  background: #000;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n}\n\n.reels-section .play-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 1.5rem;\n  color: rgba(200, 0, 255, 0.8);\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  z-index: 3;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border: 2px solid rgba(200, 0, 255, 0.5);\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\n}\n\n/* BTS Video Styles */\nbody {\n  margin: 0;\n  padding: 0;\n  background: black;\n  color: white;\n  font-family: \"Poppins\", sans-serif;\n  overflow-x: hidden;\n}\n\n/* Wrapper */\n.bts-video-wrapper {\n  width: 100%;\n  background: black;\n  color: white;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Header */\n.bts-header {\n  text-align: center;\n  margin-top: 60px;\n}\n\n.bts-title {\n  font-family: var(--font-heading);\n  font-size: 3rem;\n  font-weight: 400;\n  color: #b300ff;\n  margin-bottom: 10px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.bts-toggle {\n  margin-bottom: 30px;\n}\n\n.toggle-btn {\n  background: #2d143d;\n  color: #FFFFFF;\n  border: none;\n  padding: 8px 25px;\n  border-radius: 25px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.toggle-btn.active {\n  background: #b300ff;\n  color: white;\n}\n\n/* Layout */\n.bts-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2rem;\n  width: 90%;\n  max-width: 1200px;\n}\n\n/* Left Info */\n.bts-info {\n  width: 40%;\n  position: sticky;\n  top: 150px;\n  transition: opacity 0.4s ease;\n}\n\n.movie-name {\n  font-size: 1.8rem;\n  font-style: italic;\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.movie-description {\n  margin-top: 15px;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n/* Right Reel Section */\n.bts-reel-frame {\n  width: 70%;\n  height: 90vh;\n  background: none;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n}\n\n.bts-reel-scroll {\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  scroll-snap-type: y mandatory;\n  scrollbar-width: none;\n}\n\n.bts-reel-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.bts-reel-item {\n  scroll-snap-align: start;\n  height: 90vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bts-reel-item video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .bts-main {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .bts-info {\n    width: 100%;\n    position: relative !important;\n    /* Force relative positioning */\n    z-index: 10;\n    text-align: center;\n    background: #000;\n    /* Ensure text is readable against black bg */\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n    /* Push video down */\n  }\n\n  .bts-reel-frame {\n    width: 100%;\n    height: 70vh;\n    margin-top: 0 !important;\n  }\n\n  .movie-name {\n    font-size: 1.5rem;\n    margin-bottom: 3px;\n    /* Further reduced spacing */\n  }\n\n  .movie-description {\n    font-size: 0.8rem !important;\n    /* Reduced font size */\n    line-height: 1.4;\n    margin-top: 5px;\n    color: #e0e0e0;\n  }\n}\n\n/* Remove underline from footer headings */\n.footer-column h4::after {\n  content: none !important;\n  display: none !important;\n}\n\n.footer-column h4 {\n  padding-bottom: 0 !important;\n}\n\n/* Remove underline from founder name and title */\n.founder-name::after,\n.founder-title::after {\n  content: none !important;\n  display: none !important;\n}\n\n.founder-name,\n.founder-title {\n  padding-bottom: 0 !important;\n}\n\n/* Ensure all specific page headings are inline-block for proper underline alignment */\n.service-title,\n.what-we-do-heading,\n.projects-heading,\n.founders-heading,\n.hero-heading {\n  display: inline-block !important;\n  width: auto !important;\n  max-width: 100%;\n}\n\n/* Ensure their containers center them */\n.service-header,\n.what-we-do-hero,\n.projects-header-container,\n.founders-hero {\n  text-align: center;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.service-subtopics {\n  margin: 15px 0;\n  text-align: left;\n  width: 100%;\n}\n\n.service-subtopic-item {\n  margin-bottom: 15px;\n}\n\n.service-subtopic-title {\n  color: #C700FF;\n  font-size: 1.1rem;\n  margin-bottom: 5px;\n  font-weight: 600;\n  display: inline-block;\n}\n.service-subtopic-title {\n  position: relative;        /* needed so underline attaches to text */\n  display: inline-block;\n}\n\n\n.service-subtopic-title::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;                /* move line up */\n  transform: translateY(4px);  /* fine-tune alignment */\n\n  width: 100%;\n  height: 2px;\n\n  background: linear-gradient(90deg, #C700FF, #006EFF);\n}\n\n\n.service-subtopic-description {\n  color: #CCCCCC;\n  font-size: 0.95rem;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.service-name-container {\n  margin-top: -10px;\n  text-align:center;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n@media(max-width:480px) {\n  .service-name-container{\n    margin-top: 10px; \n  }\n}\n\n.service-name-link {\n  /* font-family: Arial, Helvetica, sans-serif !important; */\n  text-decoration: none;\n  display: inline-block;\n}\n\n.service-name {\n  color: #FFFFFF;\n  font-family: var(--font-heading);\n  font-size: 1.2rem;\n  font-weight: 400;\n  letter-spacing: 1px;\n  margin: 0;\n  transition: color 0.3s ease;\n}\n\n.service-name-link:hover .service-name {\n  color: #C700FF;\n}\n\n.edit-btn {\n  padding: 8px 15px;\n  border: 2px solid #33ff33;\n  background-color: transparent;\n  color: #33ff33;\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.edit-btn:hover {\n  background-color: #33ff33;\n  color: var(--primary-bg);\n}\n\n.cancel-btn {\n  padding: 12px 30px;\n  border: 2px solid #ff9933;\n  background-color: transparent;\n  color: #ff9933;\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  width: auto;\n  font-size: 1rem;\n}\n\n.cancel-btn:hover {\n  background-color: #ff9933;\n  color: #FFFFFF;\n}\n\n.delete-btn {\n  padding: 8px 15px;\n  border: 2px solid #ff4444;\n  background-color: transparent;\n  color: #ff4444;\n  font-weight: 500;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.delete-btn:hover {\n  background-color: #ff4444;\n  color: #FFFFFF;\n}\n\n.form-select {\n  background-color: #1a1a1a;\n  border: 2px solid #C700FF;\n  border-radius: 50px;\n  padding: 15px 40px;\n  color: #FFFFFF;\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  outline: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 10px rgba(199, 0, 255, 0.2);\n  width: 100%;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%239933FF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 20px center;\n  background-size: 20px;\n}\n\n.form-select:focus {\n  border-color: #C700FF;\n  box-shadow: 0 0 15px rgba(200, 0, 255, 0.4);\n  transform: scale(1.02);\n}\n\n.form-select:hover {\n  border-color: #C700FF;\n  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);\n}\n\n.form-select option {\n  background-color: #1a1a1a;\n  color: #FFFFFF;\n  padding: 10px;\n}\n\n/* --- Founders Page Styles --- */\n.founder-row {\n  display: flex;\n  gap: 60px;\n  align-items: flex-start;\n  margin-bottom: 120px;\n}\n\n.founder-row.reversed {\n  flex-direction: row-reverse;\n}\n\n.founder-image-col {\n  flex: 0 0 360px;\n  /* Reduced width to fit 342px images snugly */\n  max-width: 100%;\n  width: 100%;\n}\n\n.founder-content-col {\n  flex: 0 0 50%;\n  max-width: 50%;\n  text-align: left;\n  /* Enforce left alignment */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  /* Vertically center content if needed, or flex-start */\n  align-items: flex-start;\n  /* Left align flex items */\n}\n\n.founder-main-photo img {\n  width: 342px;\n  /* Exact match with sub-images */\n  height: 350px;\n  /* moderate height */\n  object-fit: cover;\n  /* Keeps it looking like a nice portrait */\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(199, 0, 255, 0.3);\n  transition: transform 0.3s ease;\n}\n\n.founder-main-photo img:hover {\n  transform: scale(1.02);\n}\n\n.founder-name {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  color: #C700FF;\n  margin-bottom: 5px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: #555;\n  text-decoration-thickness: 1px;\n  text-align: left;\n}\n\n.founder-title {\n  color: #FFFFFF;\n  font-size: 1.2rem;\n  margin-bottom: 20px;\n  opacity: 0.8;\n  font-family: var(--font-body);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n.founder-biography {\n  color: #CCCCCC;\n  line-height: 1.8;\n  margin-bottom: 180px;\n  font-size: 1.1rem;\n  font-family: var(--font-body);\n}\n\n.founder-sub-photos {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 30px;\n  align-items: center;\n  /* Center the images in the column */\n}\n\n.sub-photo-item img {\n  width: 342px;\n /* height: 208px;*/\n  object-fit: contain;\n  /* Changed from cover to contain to fit photo completely */\n  background: #000;\n  /* Optional: background for empty space if aspect ratio differs */\n  border-radius: 10px;\n  border: 1px solid rgba(199, 0, 255, 0.2);\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n.sub-photo-item img:hover {\n  transform: scale(1.05);\n  border-color: #C700FF;\n}\n\n@media (max-width: 992px) {\n  .founder-row {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .founder-row.reversed {\n    flex-direction: column;\n  }\n\n  .founder-image-col,\n  .founder-content-col {\n    flex: 0 0 100%;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .founder-sub-photos {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* --- Admin Panel --- */\n.admin-header {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.admin-title {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #C700FF;\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  font-style: italic;\n}\n\n.admin-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 15px;\n  margin-bottom: 30px;\n}\n\n.admin-tab-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: var(--text-white);\n  padding: 10px 20px;\n  border-radius: 30px;\n  font-family: var(--font-body);\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.admin-tab-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n.admin-tab-button.active {\n  background: var(--accent-gradient);\n  color: var(--text-white);\n  border-color: transparent;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(199, 0, 255, 0.4);\n}\n\n/* --- Footer Visual Effects --- */\n\n/* Footer Logo Effect */\n.footer-logo-img {\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.footer-logo-img:hover {\n  transform: scale(1.1);\n  filter: drop-shadow(0 0 10px rgba(199, 0, 255, 0.6));\n}\n\n/* Social Icons Gradient Hover */\n.social-icons a:hover .fa-instagram,\n.social-icons a:hover .fa-linkedin-in {\n  background: var(--accent-gradient);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  transform: scale(1.2);\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n\n/* --- Project Card Image Fitting --- */\n.project-poster {\n  height: auto !important;\n  /* Allow card to shrink/grow to fit image */\n  min-height: auto !important;\n  display: flex !important;\n  /* Removes bottom whitespace from inline-block images */\n  flex-direction: column;\n}\n\n.project-poster img {\n  width: 100% !important;\n  height: auto !important;\n  object-fit: contain !important;\n  /* Ensure full image is shown */\n  display: block;\n  flex-grow: 1;\n}\n\n/* --- Fix Project Card Grid Stretching --- */\n.projects-grid {\n  align-items: start !important;\n  /* Prevent cards from stretching to fill row height */\n}\n\n/* --- Specific Fix for Home Page Project Cards --- */\n#project .project-poster {\n  max-width: 350px !important;\n  margin: 0 auto !important;\n}\n\n/* --- Specific Fix for Projects Page Project Cards --- */\n.projects-main .project-poster {\n  max-width: 350px !important;\n  margin: 0 auto !important;\n}\n\n/* --- Fix Contact Page Alignment & Sizing (Extra Compact) --- */\n.contact-hero {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n\n\n.contact-columns {\n  display: flex !important;\n  justify-content: space-between;\n  align-items: stretch;\n  gap: 20px;\n  /* Tighter gap */\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.contact-map-column,\n.contact-form-column {\n  flex: 1;\n  width: 48%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Map sizing - Extra Compact */\n.map-placeholder {\n  height: 100%;\n  min-height: 220px;\n  /* Reduced to ~220px */\n  width: 100%;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n/* Form Layout */\n.contact-form {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* Compact Inputs */\n.form-group {\n  margin-bottom: 10px !important;\n}\n\n.animated-label {\n  color: #FFFFFF !important;\n  font-family: var(--font-body);\n  font-size: 0.9rem;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.form-input {\n  padding: 5px 15px !important;\n  height: 35px !important;\n  font-size: 0.9rem;\n  border: 2px solid transparent !important;\n  background: linear-gradient(#333, #333) padding-box,\n    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  border-radius: 8px !important;\n  color: white !important;\n}\n\n.form-textarea {\n  padding: 8px 15px !important;\n  height: 55px !important;\n  /* Increased by ~50% from 35px */\n  min-height: 55px !important;\n  max-height: 55px !important;\n  resize: none !important;\n  font-size: 0.9rem;\n  border: 2px solid transparent !important;\n  background: linear-gradient(#333, #333) padding-box,\n    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  border-radius: 8px !important;\n  color: white !important;\n}\n\n/* Force placeholders to be white */\n.form-input::placeholder,\n.form-textarea::placeholder {\n  color: white !important;\n  opacity: 1;\n}\n\n.submit-btn {\n  margin-top: auto;\n  padding: 6px 25px;\n  font-size: 0.9rem;\n  border: 2px solid transparent !important;\n  background: linear-gradient(#333, #333) padding-box,\n    linear-gradient(90deg, #C700FF, #006EFF) border-box !important;\n  border-radius: 25px !important;\n  color: white !important;\n  transition: all 0.3s ease;\n}\n\n.submit-btn:hover {\n  border-color: transparent;\n  box-shadow: 0 0 10px rgba(200, 0, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .contact-columns {\n    flex-direction: column;\n  }\n}\n\n/* --- BTS Video Layout (New) --- */\n.bts-main {\n  display: flex;\n  gap: 40px;\n  position: relative;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  align-items: flex-start;\n}\n\n.bts-info {\n  flex: 1;\n  position: sticky;\n  top: 100px;\n  max-width: 100%;\n  padding: 20px;\n}\n\n.bts-reel-frame {\n  flex: 2;\n  position: relative;\n}\n\n.bts-reel-scroll {\n  display: flex;\n  flex-direction: column;\n  gap: 60px;\n  padding-bottom: 100px;\n}\n\n.bts-reel-item {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.film-frame-container {\n  position: relative;\n  width: 100%;\n  max-width: 450px;\n  /* Reduced max-width for better laptop fit */\n  aspect-ratio: 9/16;\n  max-height: 80vh;\n  /* Prevent overflowing screen height */\n  background: #000;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  border: 1px solid #333;\n}\n\n.film-frame-content {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 2;\n}\n\n.video-block-container {\n  width: 100%;\n  height: 100%;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-block-container video,\n.video-block-container iframe {\n  width: 100%;\n  height: 100%;\n  /*object-fit: contain !important;*/\n  /* Forces complete visibility */\n  border: none;\n}\n\n@media (max-width: 900px) {\n  .bts-main {\n    display: block;\n    /* Vertical stack */\n  }\n\n  .bts-info {\n    position: sticky;\n    top: 70px;\n    /* Below Navbar */\n    z-index: 30;\n    /* Above scrolling videos */\n    background: rgba(0, 0, 0, 0.9);\n    /* Dark background */\n    backdrop-filter: blur(10px);\n    max-height: 30vh;\n    padding: 15px;\n    border-bottom: 2px solid var(--accent-purple);\n    border-radius: 0 0 15px 15px;\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);\n    margin-bottom: 20px;\n    /* Space before videos start */\n    text-align: center;\n  }\n\n  .bts-reel-scroll {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    /* Clear separation between videos */\n    padding-bottom: 40px;\n  }\n\n  .bts-reel-item {\n    position: relative;\n    /* Normal flow */\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n\n  .film-frame-container {\n    width: 100%;\n    /* Full width of container */\n    max-width: 450px;\n    /* Limit width for larger mobiles */\n    height: auto;\n    aspect-ratio: 9/16;\n    margin: 0 auto;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n  }\n\n  .video-block-container video,\n  .video-block-container iframe {\n    object-fit: contain !important;\n  }\n}\n\n/* --- New Responsive Styles for Founders & Contact --- */\n\n/* Founders Page */\n.founders-hero {\n  padding: 60px 0 0;\n  text-align: center;\n  \n}\n\n.founders-heading {\n  font-family: var(--font-heading);\n  font-size: 2.2rem;\n  color: #C700FF;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n}\n\n.founder-row {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n  margin-bottom: 80px;\n  padding: 20px;\n}\n\n.founder-row:last-child {\n  margin-bottom: 0;\n}\n\n.founder-row.reversed {\n  flex-direction: row-reverse;\n}\n\n.founder-image-col {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.founder-main-photo {\n  width: 100%;\n  max-width: 400px;\n  margin-bottom: 20px;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 2px solid var(--accent-purple);\n  box-shadow: 0 0 20px rgba(199, 0, 255, 0.3);\n}\n\n.founder-main-photo img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.founder-sub-photos {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 15px;\n  width: 100%;\n  max-width: 400px;\n}\n\n/* promoters portfolio css */\n/* .horizontal-scroll-wrapper{\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.horizontal-scroll-track {\n  width: 100%;\n  margin-top: 10px;\n  /* height: 130px; *\n  display: flex;\n  gap: 20px;\n  animation: horizontalScroll 30s linear infinite;\n}\n\n@keyframes horizontalScroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.portfolio-image{\n  height: 130px;\n  width: 100px ;\n}\n\n.portfolio-image img{\n  width: 90px !important;\n  height: 120px !important;\n  object-fit: cover !important;\n  background: #000;\n  border-radius: 10px;\n  border: 1px solid rgba(199, 0, 255, 0.2);\n  transition: transform 0.3s ease, border-color 0.3s ease;\n  cursor: pointer;\n  flex-shrink: 0; * VERY important *\n}\n\n.portfolio-image img:hover{\n  transform: scale(1.05);\n  border-color: #C700FF;\n}\n\n.sub-photo-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n  border: 1px solid #444;\n  transition: transform 0.3s ease;\n}\n\n.sub-photo-item img:hover {\n  transform: scale(1.05);\n} */\n\n.horizontal-scroll-wrapper {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.horizontal-scroll-track {\n  margin-top: 35px;\n  height: 150px;\n  display: flex;\n  gap: 20px;\n  animation: horizontalScroll 30s linear infinite;\n  flex-wrap: nowrap;\n}\n\n/* IMPORTANT: width yahan control karo */\n.portfolio-image {\n  width: 100px;\n  height: 130px;\n  flex-shrink: 0; /* MOST IMPORTANT LINE */\n}\n\n.portfolio-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #000;\n  border-radius: 10px;\n  border: 1px solid rgba(199, 0, 255, 0.2);\n  transition: transform 0.3s ease, border-color 0.3s ease;\n  cursor: pointer;\n}\n\n.portfolio-image img:hover {\n  transform: scale(1.05);\n  border-color: #C700FF;\n}\n\n/* default (desktop) */\n.promoters-portfolio {\n  margin-top: 70px;\n}\n\n/* mobile view */\n@media (max-width: 768px) {\n  .promoters-portfolio {\n    margin-top: -70px;\n    margin-bottom: -150px;\n  }\n\n  .horizontal-scroll-track {\n  animation: horizontalScroll 20s linear infinite;\n}\n}\n\n@media (max-width: 480px) {\n  .promoters-portfolio {\n    margin-top: -70px;\n    margin-bottom: -150px;\n  }\n}\n\n\n/* Animation */\n@keyframes horizontalScroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n\n.founder-content-col {\n  flex: 1.2;\n  text-align: left;\n}\n\n.founder-row.reversed .founder-content-col {\n  text-align: left;\n}\n\n.founder-name {\n  font-family: var(--font-heading);\n  font-size: 2.5rem;\n  color: #FFFFFF;\n  margin-bottom: 10px;\n  font-style: italic;\n}\n\n.founder-title {\n  font-family: var(--font-body);\n  font-size: 1.5rem;\n  color: var(--accent-purple);\n  margin-bottom: 25px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.founder-biography {\n  font-family: var(--font-body);\n  font-size: 1.1rem;\n  color: var(--text-white);\n  line-height: 1.8;\n  white-space: pre-wrap;\n  /* Preserve line breaks */\n  text-align: left;\n}\n\n/* Contact Page */\n.contact-hero {\n  padding: 40px 0;\n  text-align: center;\n}\n\n.contact-heading {\n  font-family: var(--font-heading);\n  font-size: 2.2rem;\n  color: #C700FF;\n  margin-bottom: 60px;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n}\n\n/* Removed duplicate/conflicting .contact-map-column and .map-placeholder definitions */\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  text-align: left;\n}\n\n.animated-label {\n  display: block;\n  font-family: var(--font-body);\n  color: var(--accent-purple);\n  margin-bottom: 10px;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n/* Mobile Adjustments for Founders & Contact */\n@media (max-width: 900px) {\n\n  /* Founders - Stack Vertically */\n  .founder-row,\n  .founder-row.reversed {\n    flex-direction: column !important;\n    gap: 40px;\n    text-align: center;\n    padding: 0;\n  }\n    \n  .founder-content-col,\n  .founder-row.reversed .founder-content-col {\n    text-align: center;\n    width: 100%;\n  }\n\n  .founder-content-col {\n    margin-bottom: -120px !important;\n  }\n   .founders-hero{\n    margin-bottom: -130px !important;\n   }\n  .founder-name {\n    font-size: 2rem;\n  }\n\n  .founder-title {\n    font-size: 1.2rem;\n  }\n\n  /* Contact - Stack Vertically */\n  .contact-columns {\n    flex-direction: column;\n    gap: 40px;\n    padding: 20px;\n  }\n\n  .map-placeholder {\n    min-height: 300px;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .founders-heading,\n  .contact-heading {\n    font-size: 2.2rem;\n  }\n\n  .founder-main-photo {\n    max-width: 100%;\n  }\n\n  .founder-sub-photos {\n    max-width: 100%;\n  }\n\n  .projects-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* --- Additional Responsive Typography --- */\n\n.projects-heading {\n  font-family: var(--font-heading);\n  font-size: 2.2rem;\n  color: #C700FF;\n  font-style: italic;\n  text-decoration: underline;\n  text-decoration-color: var(--text-white);\n  text-decoration-thickness: 1px;\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n@media (max-width: 768px) {\n\n  .projects-heading,\n  .section-heading {\n    font-size: 2.2rem !important;\n    margin-bottom: 30px;\n  }\n\n  .bts-subheading {\n    font-size: 1.8rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .projects-heading,\n  .section-heading {\n    font-size: 2.2rem !important;\n  }\n}\n\n/* --- UI Fixes (Refined V4) --- */\n\n/* Fix: Project Page Category Box Spacing */\n.projects-header-container {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 30px;\n  margin-bottom: 50px;\n}\n\n.projects-header-container .projects-heading {\n  margin-bottom: 0 !important;\n}\n\n/* Removed redundant \"Refined V4\" map fixes which are now in the main block */\n\n@media (max-width: 768px) {\n  /* Targeted Fix: Aggressively Force Map to edge-to-edge on mobile */\n\n  /* Reset parent containers */\n  .contact-hero,\n  .contact-content,\n  .contact-columns {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  .contact-columns {\n    display: flex;\n    flex-direction: column;\n    gap: 0 !important;\n  }\n\n  /* Map Column - Explicit Height V7 */\n  .contact-map-column {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n    height: 400px !important;\n    /* Fixed height */\n    min-height: 400px !important;\n    flex: none !important;\n  }\n\n  /* Map Placeholder - Explicit Height V7 */\n  .map-placeholder {\n    width: 100% !important;\n    height: 400px !important;\n    /* Fixed height match */\n    min-height: 400px !important;\n    border-radius: 12px !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  /* Iframe - Explicit Height V7 */\n  .map-placeholder iframe {\n    width: 100% !important;\n    height: 400px !important;\n    /* Force iframe height */\n    display: block !important;\n  }\n\n  /* Re-add padding ONLY to the form column below */\n  .contact-form-column {\n    padding: 0 20px 30px 20px !important;\n    /* Zero top padding */\n  }\n\n.load{\n\n  display: flex;\n  justify-content: center;   /* horizontal */\n  align-items: center;       /* vertical */\n  height: 100vh; \n}\n\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
